<template>
  <div id="insightsPeople">
    <div class="margin-subpages">
      <div class="flex">
        <el-select v-model="selectTeam" filterable :placeholder="$t('insights.Select')" class="input-style"
        :class="[ blurMode ?  'blurelement': '' ]">
          <el-option v-if="user.user_type !== 'leadership'" class="text-dropdown"
            :label="allTeamsLabel" :value="allTeamsLabel"></el-option>
          <el-option-group v-if="optionsTeam.length" label="Teams">
            <el-option class="text-dropdown"
            :class="[ blurMode ?  'blurelement': '' ]"
            v-for="item in optionsTeam" :key="item.key" :label="item.name"
              :value="item.key"></el-option>
          </el-option-group>
          <el-option-group v-if="visibleCohortOptions.length" label="Cohorts">
            <el-option class="text-dropdown"
            :class="[ blurMode ?  'blurelement': '' ]"
            v-for="item in visibleCohortOptions" :key="`cohort-${item.key}`" :label="item.name"
              :value="getCohortOptionValue(item.key)"></el-option>
          </el-option-group>
        </el-select>
        <el-input class="input-style ml-24" style="font-size: 18px; width: 220px !important" autosize
          :placeholder="$t('global.Search')" v-model="inputSearch" clearable></el-input>
        <div class="flex-center flex-1" style="justify-content: flex-end">
          <div class="flex-center">
            <img class="dispTalentTypeStyle" :style="'width: ' + (disp_talentType == 'All_Types')
                ? '84px;'
                : '110px;'
              " :src="getImgPeopleUrl(disp_talentType)" />
          </div>
          <el-dropdown trigger="click" :hide-on-click="false" ref="dropdownMenu">
            <img @click="dropdownTalentTypeClick" style="cursor: pointer" src="@/assets/images/filter-list-24px.png" />
            <el-dropdown-menu slot="dropdown">
              <div class="dropdownHeader">
                <div>
                  <el-button @click="handleSelectAll" class="dropdownHeaderTextStyle" type="text">{{
                    $t("insights.Select_all") }}</el-button>
                  <el-button @click="checkedTalentType = []" class="dropdownHeaderTextStyle" style="margin-left: 24px"
                    type="text">{{ $t("insights.Clear") }}</el-button>
                </div>
                <el-tooltip effect="dark" placement="top">
                  <div class="tooltipStyle" slot="content">
                    {{ $t("insights.Talent_Types_are_tagged") }}
                  </div>
                  <div class="flex-center">
                    <img :src="getImgUrl('help_outline-16px')" />
                  </div>
                </el-tooltip>
              </div>
              <div class="dropdownItem-insightsPeople">
                <el-checkbox-group v-model="checkedTalentType">
                  <el-dropdown-item v-for="item in talentTypeOption" :key="item.type">
                    <el-checkbox :label="item.type" :key="item.type">{{ item.type }} ({{ item.count }})</el-checkbox>
                  </el-dropdown-item>
                </el-checkbox-group>
              </div>
              <div class="dropdownFooter">
                <el-button @click="cancelTalentType" type="cancel">{{
                  $t("insights.Cancel")
                }}</el-button>
                <el-button @click="saveTalentType" type="save">{{
                  $t("insights.Okay")
                }}</el-button>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="split-risk-power">
        <div class="risk-container">
          <div class="flex-center mb-24">
            <div>
              <div class="fs-16 fw-700">{{ $t("insights.People_Risk_Recovery_Trends") }}</div>
              <div class="fs-10 opa-05" style="margin-top: 2px;">{{ $t("insights.Click_any_week_for_details") }}</div>
            </div>
            <div class="flex-center ml-auto mr-6">
              <div class="risk-title recovery"></div>
            </div>
            <div class="fs-11 opa-08">{{ $t("insights.Recovery") }}</div>
            <div class="flex-center ml-12 mr-6">
              <div class="risk-title one"></div>
              <div class="risk-title two"></div>
              <div class="risk-title three"></div>
            </div>
            <div class="fs-11 opa-08">{{ $t("insights.RISK_LEVELS") }}</div>
          </div>
          <div class="relative" :style="{ height: riskChartHeight }">
            <div v-if="loadingDataChart" class="people-panel-skeleton people-panel-skeleton-risk" :style="{ height: riskChartHeight }">
              <div class="people-risk-skeleton-axis">
                <div
                  v-for="value in ['50', '40', '30', '20', '10', '0']"
                  :key="`risk-skeleton-axis-${value}`"
                  class="text-skeleton people-risk-skeleton-axis-label"
                >
                  &nbsp;
                </div>
              </div>
              <div class="people-risk-skeleton-plot">
                <div class="people-risk-skeleton-grid">
                  <div
                    v-for="line in 5"
                    :key="`risk-skeleton-grid-${line}`"
                    class="people-risk-skeleton-grid-line"
                  ></div>
                </div>
                <div class="people-risk-skeleton-series">
                  <div
                    v-for="(group, index) in [
                      { green: 72, red: 122 },
                      { green: 84, red: 96 },
                      { green: 58, red: 110 },
                      { green: 76, red: 134 },
                      { green: 118, red: 108 },
                      { green: 116, red: 112 },
                      { green: 92, red: 106 },
                      { green: 56, red: 144 }
                    ]"
                    :key="`risk-skeleton-group-${index}`"
                    class="people-risk-skeleton-group"
                  >
                    <div class="people-risk-skeleton-group-bars">
                      <div
                        class="text-skeleton people-risk-skeleton-bar people-risk-skeleton-bar-thin"
                        :style="{ height: `${group.green}px` }"
                      ></div>
                      <div
                        class="text-skeleton people-risk-skeleton-bar people-risk-skeleton-bar-thin"
                        :style="{ height: `${group.red}px` }"
                      ></div>
                    </div>
                    <div class="text-skeleton people-risk-skeleton-group-label">&nbsp;</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="" :style="{ height: riskChartHeight, width: '552px' }">
              <canvas ref="riskAndRecoveryChart"></canvas>
            </div>
          </div>
        </div>
        <div class="power-container">
          <div class="flex-center mb-14">
            <el-dropdown @command="handlePowerPick">
              <span class="el-dropdown-link">
                {{ PowerSkillShowingData
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="width: 160px">
                <el-dropdown-item command="Impact Rating">
                  {{ $t("insights.Impact_Rating") }}
                </el-dropdown-item>
                <el-dropdown-item command="Talent Type">{{
                  $t("insights.Talent_Type")
                }}</el-dropdown-item>
                <el-dropdown-item command="Network Type">{{
                  $t("insights.Network_Type")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <div class="ml-auto" v-if="PowerSkillShowingData == 'Power Skills'"> -->
            <!-- <el-dropdown @command="handleTimePick">
                <span class="el-dropdown-link">
                  {{ timeShowingData
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width: 140px">
                  <el-dropdown-item command="By month"
                    >By month</el-dropdown-item
                  >
                  <el-dropdown-item command="By years"
                    >By years</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown> -->
            <!-- </div> -->
          </div>

          <!-- <div v-if="PowerSkillShowingData == 'Power Skills'">
            <div v-if="loadingDataChart">
              <div v-for="data in [1, 2, 3, 4, 5, 6]" :key="data + '_bar_loading'"
                class="power-tabs flex-center image-skeleton opa-05"></div>
            </div>
            <div
              v-else
              v-for="data in powerChartData"
              :key="data.label + '_bar'"
              :class="`power-tabs flex-center`"
            >
              <div
                :class="`color-bar ${data.icon}`"
                :style="`width: ${setBarWidth(
                  data.point,
                  data.point_total
                )}px;`"
              ></div>
              <div class="relative">{{ data.label }}</div>
              <div class="ml-auto relative">
                {{
                  data.point_total > 0
                    ? Math.round((data.point / data.point_total) * 100)
                    : 0
                }}%
              </div>
            </div>
          </div> -->

          <!-- Impact Rating Distribution -->
          <div v-if="PowerSkillShowingData == 'Impact Rating'" class="impact-chart-container">
            <div v-if="loadingDataChart || loadingPeopleTable" class="people-panel-skeleton people-impact-skeleton" style="height: 200px;">
              <div class="people-impact-skeleton-chart">
                <div class="text-skeleton people-impact-skeleton-ring"></div>
                <div class="people-impact-skeleton-center">
                  <div class="text-skeleton people-impact-skeleton-center-score">&nbsp;</div>
                  <div class="text-skeleton people-impact-skeleton-center-label">&nbsp;</div>
                  <div class="text-skeleton people-impact-skeleton-center-count">&nbsp;</div>
                </div>
              </div>
              <div class="people-impact-skeleton-legend-grid">
                <div
                  v-for="(value, index) in [84, 92, 86, 88, 74]"
                  :key="`impact-skeleton-${index}`"
                  class="people-impact-skeleton-chip"
                >
                  <div class="text-skeleton people-impact-skeleton-chip-dot">&nbsp;</div>
                  <div class="text-skeleton people-impact-skeleton-chip-line" :style="{ width: `${value}px` }">&nbsp;</div>
                </div>
              </div>
            </div>
            <template v-else>
              <div class="donut-chart-wrapper">
                <div class="donut-chart-area">
                  <canvas ref="impactDonutChart" width="180" height="180"></canvas>
                  <div class="donut-center-text">
                    <div class="center-avg">{{ filteredAvgImpactRating.toFixed(1) }}</div>
                    <div class="center-label">{{ $t("insights.AVG") }}</div>
                    <div class="center-people">{{ impactDistribution.total }} people</div>
                  </div>
                </div>
                <div class="donut-legend">
                  <div 
                    v-for="range in impactDistribution.ranges" 
                    :key="range.label"
                    class="legend-item"
                  >
                    <span class="legend-color" :style="{ backgroundColor: range.color }"></span>
                    <span class="legend-label">{{ range.label }}</span>
                    <span class="legend-count">{{ range.count }}</span>
                    <span class="legend-percent">({{ getPercentage(range.count, impactDistribution.total) }}%)</span>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div v-else-if="PowerSkillShowingData == 'Talent Type'" class="network-container relative"
            style="min-height: 200px">
            <div v-if="loadingDataChart" class="people-panel-skeleton people-grid-skeleton" style="min-height: 200px">
              <div class="people-grid-skeleton-matrix">
                <div
                  v-for="value in 16"
                  :key="`talent-grid-skeleton-${value}`"
                  class="text-skeleton people-grid-skeleton-cell"
                  :style="{ opacity: value % 5 === 0 ? 0.45 : value % 2 === 0 ? 0.7 : 0.55 }"
                ></div>
              </div>
            </div>
            <div v-else class="flex">
              <div class="text-left-table">
                <div class="text" style="width: 150px; left: -24px">
                  {{ $t("insights.INDIVIDUAL_PERFORMANCE") }}
                </div>
              </div>
              <div class="grid-table">
                <el-tooltip :content="$t('category.Talent_Types.Untapped_Potential')" placement="top">
                  <div class="cell flex-mid c-FBC02D" :style="{ opacity: talentChartOpacities['Untapped Potential'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Untapped Potential"]
                      ? talentChartData["Untapped Potential"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Activated')" placement="top">
                  <div class="cell flex-mid c-C2E337" :style="{ opacity: talentChartOpacities['Activated'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Activated"]
                      ? talentChartData["Activated"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.High_Performer')" placement="top">
                  <div class="cell flex-mid c-66BB6A" :style="{ opacity: talentChartOpacities['High Performer'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["High Performer"]
                      ? talentChartData["High Performer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Superstar')" placement="top">
                  <div class="cell flex-mid c-66BB6A" :style="{ opacity: talentChartOpacities['Superstar'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Superstar"]
                      ? talentChartData["Superstar"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Talent_Types.Valued_Contributor')" placement="top">
                  <div class="cell flex-mid c-FBC02D" :style="{ opacity: talentChartOpacities['Valued Contributor'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Valued Contributor"]
                      ? talentChartData["Valued Contributor"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Key_Player')" placement="top">
                  <div class="cell flex-mid c-C2E337" :style="{ opacity: talentChartOpacities['Key Player'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Key Player"]
                      ? talentChartData["Key Player"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Respected_Expert')" placement="top">
                  <div class="cell flex-mid c-66BB6A" :style="{ opacity: talentChartOpacities['Respected Expert'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Respected Expert"]
                      ? talentChartData["Respected Expert"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Distinguished_Talent')" placement="top">
                  <div class="cell flex-mid c-66BB6A" :style="{ opacity: talentChartOpacities['Distinguished Talent'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Distinguished Talent"]
                      ? talentChartData["Distinguished Talent"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Talent_Types.Community_Pillar')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: talentChartOpacities['Community Pillar'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Community Pillar"]
                      ? talentChartData["Community Pillar"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Engaged_Contributor')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: talentChartOpacities['Engaged Contributor'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Engaged Contributor"]
                      ? talentChartData["Engaged Contributor"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Core_Player')" placement="top">
                  <div class="cell flex-mid c-C2E337" :style="{ opacity: talentChartOpacities['Core Player'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Core Player"]
                      ? talentChartData["Core Player"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Solid_Performer')" placement="top">
                  <div class="cell flex-mid c-C2E337" :style="{ opacity: talentChartOpacities['Solid Performer'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Solid Performer"]
                      ? talentChartData["Solid Performer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Talent_Types.Up_and_coming')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: talentChartOpacities['Up-and-Coming'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Up-and-Coming"]
                      ? talentChartData["Up-and-Coming"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Rising_Star')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: talentChartOpacities['Rising Star'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Rising Star"]
                      ? talentChartData["Rising Star"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Emerging_Talent')" placement="top">
                  <div class="cell flex-mid c-FBC02D" :style="{ opacity: talentChartOpacities['Emerging Talent'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Emerging Talent"]
                      ? talentChartData["Emerging Talent"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.High_Potential')" placement="top">
                  <div class="cell flex-mid c-FBC02D" :style="{ opacity: talentChartOpacities['High Potential'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["High Potential"]
                      ? talentChartData["High Potential"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                
                <el-tooltip :content="$t('category.Talent_Types.Starter')" placement="top">
                  <div class="cell flex-mid c-F44336" :style="{ opacity: talentChartOpacities['Latent Potential'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Latent Potential"]
                      ? talentChartData["Latent Potential"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Contributor')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: talentChartOpacities['Contributor'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Contributor"]
                      ? talentChartData["Contributor"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Crowd_Favorite')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: talentChartOpacities['Crowd Favorite'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Crowd Favorite"]
                      ? talentChartData["Crowd Favorite"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Talent_Types.Unsung_Talent')" placement="top">
                  <div class="cell flex-mid c-FBC02D" :style="{ opacity: talentChartOpacities['Unsung Talent'] || 0.4 }">
                    {{
                      talentChartData && talentChartData["Unsung Talent"]
                      ? talentChartData["Unsung Talent"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div v-if="!loadingDataChart" class="fs-11 opa-08 pt-12 pl-32 fc-000000 center">
              {{ $t("insights.NETWORK_EFFECTIVENESS") }}
            </div>
          </div>
          <div v-else-if="PowerSkillShowingData == 'Network Type'" class="network-container">
            <div class="flex">
              <div class="text-left-table">
                <div class="text">{{ $t("insights.OUTER_NETWORK") }}</div>
              </div>
              <div class="grid-table">
                <el-tooltip :content="$t('category.Network_type.Super_Outer')" placement="top">
                  <div class="cell flex-mid c-C2E337" :style="{ marginRight: 0, paddingRight: '4px', width: '83px', opacity: networkChartOpacities['Super Outer'] || 0.4 }">
                    {{
                      networkChartData && networkChartData["Super Outer"]
                      ? networkChartData["Super Outer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <div class="cell"></div>
                <el-tooltip :content="$t('category.Network_type.Super_Network')" placement="top">
                  <div class="cell flex-mid c-66BB6A" :style="{ marginRight: 0, paddingRight: '4px', borderRadius: '4px 0 0 4px', opacity: networkChartOpacities['Super Network'] || 0.4 }"></div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Super_Network')" placement="top">
                  <div class="cell flex-mid c-66BB6A" :style="{ marginBottom: 0, paddingBottom: '4px', borderRadius: '0 4px 0 0', opacity: networkChartOpacities['Super Network'] || 0.4 }">
                    {{
                      networkChartData && networkChartData["Super Network"]
                      ? networkChartData["Super Network"]
                      : 0
                    }}
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Network_type.High_Outer')" placement="top">
                  <div class="cell flex-mid c-FBC02D" :style="{ marginRight: 0, paddingRight: '4px', width: '83px', opacity: networkChartOpacities['High Outer'] || 0.4 }">
                    {{
                      networkChartData && networkChartData["High Outer"]
                      ? networkChartData["High Outer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <div class="cell"></div>
                <el-tooltip :content="$t('category.Network_type.High_Network')" placement="top">
                  <div class="cell flex-mid c-C2E337" :style="{ opacity: networkChartOpacities['High Network'] || 0.4 }">
                    {{
                      networkChartData && networkChartData["High Network"]
                      ? networkChartData["High Network"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Super_Network')" placement="top">
                  <div class="cell flex-mid c-66BB6A" :style="{ borderRadius: '0 0 4px 4px', opacity: networkChartOpacities['Super Network'] || 0.4 }"></div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Network_type.Medium_Outer')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: networkChartOpacities['Medium Outer'] || 0.4 }">
                    {{
                      networkChartData && networkChartData["Medium Outer"]
                      ? networkChartData["Medium Outer"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Medium_Network')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: networkChartOpacities['Medium Network'] || 0.4 }">
                    {{
                      networkChartData && networkChartData["Medium Network"]
                      ? networkChartData["Medium Network"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.High_Inner')" placement="top">
                  <div class="cell center flex-mid c-FBC02D" :style="{ marginBottom: 0, paddingBottom: '4px', borderRadius: '4px 4px 0 0', opacity: networkChartOpacities['High Inner'] || 0.4, zIndex: 99 }">
                    <div class="min-of-cell-2">
                      {{
                        networkChartData && networkChartData["High Inner"]
                        ? networkChartData["High Inner"]
                        : 0
                      }}
                    </div>
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Super_Inner')" placement="top">
                  <div class="cell center c-C2E337" :style="{ marginBottom: 0, paddingBottom: '4px', borderRadius: '4px 4px 0 0', opacity: networkChartOpacities['Super Inner'] || 0.4, zIndex: 99 }">
                    <div class="min-of-cell-2">
                      {{
                        networkChartData && networkChartData["Super Inner"]
                        ? networkChartData["Super Inner"]
                        : 0
                      }}
                    </div>
                  </div>
                </el-tooltip>

                <el-tooltip :content="$t('category.Network_type.Low_Network')" placement="top">
                  <div class="cell flex-mid c-F44336" :style="{ opacity: networkChartOpacities['Low Network'] || 0.4 }">
                    {{
                      networkChartData && networkChartData["Low Network"]
                      ? networkChartData["Low Network"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Medium_Inner')" placement="top">
                  <div class="cell flex-mid c-EF8D3A" :style="{ opacity: networkChartOpacities['Medium Inner'] || 0.4 }">
                    {{
                      networkChartData && networkChartData["Medium Inner"]
                      ? networkChartData["Medium Inner"]
                      : 0
                    }}
                  </div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.High_Inner')" placement="top">
                  <div class="cell flex-mid c-FBC02D" :style="{ borderRadius: '0 0 4px 4px', opacity: networkChartOpacities['High Inner'] || 0.4 }"></div>
                </el-tooltip>
                <el-tooltip :content="$t('category.Network_type.Super_Inner')" placement="top">
                  <div class="cell flex-mid c-C2E337" :style="{ borderRadius: '0 0 4px 4px', opacity: networkChartOpacities['Super Inner'] || 0.4 }"></div>
                </el-tooltip>
              </div>
            </div>
            <div class="fs-10 opa-06 pt-12 pl-32 center">
              {{ $t("insights.INNER_NETWORK") }}
            </div>
          </div>

          <!-- <div v-else-if="PowerSkillShowingData == 'Excels At'" style="height: 228px" class="thin-scrollbar pr-4">
            <div v-for="(value, index) in excelsAtDataChart" :key="`${index}_${value.label}`" class="excels-card">
              <div class="flex-center fs-13 fc-000000">
                <div class="opa-06">{{ index + 1 }}</div>
                <div class="ml-6 fw-700 ellipsis mr-6">{{ value.label }}</div>
                <div class="ml-auto opa-08">{{ value.userCount }}</div>
                <i class="el-icon-user-solid fc-6C30CC opa-08 ml-4"></i>
                <div class="percent-tag ml-4">
                  <div class="percent" :style="`width: ${setBarExcelsWidth(value.percentage)}px;`"></div>
                </div>
                <div style="width: 20px" class="cursor-pointer" @click="value.expand = !value.expand">
                  <i v-if="value.expand" class="el-icon-arrow-up ml-4"></i>
                  <i v-else class="el-icon-arrow-down ml-4"></i>
                </div>
              </div>
              <div v-if="value.expand" class="expend-user flex-center">
                <div v-for="(user, i) in value.topUser" :key="user.userId">
                  <div class="user-cell" v-if="i < 3">
                    <div class="flex-center" v-if="user.imageProfile">
                      <img v-lazy="user.imageProfile" :key="user.imageProfile" class="image-skeleton image-profile-40" />
                    </div>
                    <div v-else class="image image-profile-40">
                      <div class="text-in-image text-in-image-40 flex-mid">
                        {{ $utils("acronymName", { fullName: user.fullname }) }}
                      </div>
                    </div>
                    <div class="count-excels">
                      {{ user.excelsCount }}
                    </div>
                  </div>
                </div>
                <div class="ml-auto fs-12 fw-700 cursor-pointer" style="color: #006772"
                  @click="viewListClick(value.label)">
                  {{ $t("insights.view_list") }}
                </div>
              </div>
            </div>
          </div> -->

        </div>
      </div>

      <div class="flex-center mt-24">
        <div class="flex-1">
          <span class="fs-18 fw-700">{{
            $t("insights.PEOPLE_INTELLIGENCE")
          }}</span>
        </div>
        <div style="padding-right: 12px">
          <span class="fc-000000 fs-14">{{ $t("insights.Sort_By") }}</span>
        </div>
        <div class="showOption">
          <el-menu class="el-menu-demo menuOptionStyle" mode="horizontal" style="width: 200px">
            <el-submenu index="0" style="width: 200px">
              <template slot="title">
                <span class="txtOptionStar" id="sortBy">{{
                  $t("insights.Highest_Risk_Level")
                }}</span>
              </template>
              <el-menu-item index="1" @click="sortBy('highest_risk')" style="font-size: 14px; width: 200px">{{
                $t("insights.Highest_Risk_Level") }}</el-menu-item>
              <el-menu-item index="2" @click="sortBy('lowest_risk')" style="font-size: 14px; width: 200px">{{
                $t("insights.Lowest_Risk_Level") }}</el-menu-item>
              <el-menu-item index="3" @click="sortBy('highest_impact')" style="font-size: 14px; width: 200px">{{
                $t("insights.Highest_Impact_Rating") }}</el-menu-item>
              <el-menu-item index="4" @click="sortBy('lowest_impact')" style="font-size: 14px; width: 200px">{{
                $t("insights.Lowest_Impact_Rating") }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <!-- Impact Rating Display Toggle -->
        <div class="flex-center ml-12">
          <span class="fs-14 mr-8">{{ $t("insights.Score") }}</span>
          <div class="switch-contrainer-small">
            <input
              type="checkbox"
              id="impactDisplayToggle"
              class="input-checkbox"
              v-model="showImpactPercentile"
            />
            <label for="impactDisplayToggle" class="lable-checkbox"></label>
          </div>
          
          <!-- Make the Percentile text a dropdown only when a specific team is selected -->
          <template v-if="showImpactPercentile">
            <!-- If a specific team is selected, show dropdown options -->
            <el-dropdown 
              v-if="!isAllTeamsSelected" 
              trigger="click" 
              @command="handlePercentileScope" 
              class="ml-8"
            >
              <span class="el-dropdown-link cursor-pointer fs-14">
                {{ $t("insights.Percentile") }} <span class="percentile-type">({{ percentileScopeShortText }})</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="filtered">{{ $t("insights.Scoped") }}</el-dropdown-item>
                <el-dropdown-item command="global">{{ $t("insights.Global") }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- If All Teams view, just show Percentile text -->
            <span v-else class="fs-14 ml-8">{{ $t("insights.Percentile") }}</span>
          </template>
          <span v-else class="fs-14 ml-8">{{ $t("insights.Percentile") }}</span>
        </div>

        <div class="mt-2 ml-20">
              <div class="flex-center">
                <svg @click="exportTable()" width="24" height="24" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg" class="icon-export">
                  <path fill="currentColor"
                    d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3q0 .825-.587 1.413T18 20z" />
                </svg>
              </div>
            </div>
            
      </div>



      <!-- Talent Group preset chip strip — surfaces the pre-curated groups
           that map onto leadership's "find risk / find top talent / find
           promotion ready" mental models. Each chip toggles a filter; clicking
           the active chip clears it. -->
      <div class="talent-group-strip mt-16">
        <button
          type="button"
          class="talent-group-chip"
          :class="{ active: selectedTalentGroup === 'all' }"
          @click="selectedTalentGroup = 'all'"
        >
          <span class="talent-group-chip-label">{{ $t("insights.All_People") }}</span>
          <span class="talent-group-chip-count">{{ totalPeopleCount }}</span>
        </button>
        <el-tooltip
          v-for="g in talentGroups"
          :key="g.key"
          :content="g.description"
          placement="top"
          effect="light"
          popper-class="talent-group-tooltip"
          :open-delay="350"
        >
          <button
            type="button"
            class="talent-group-chip"
            :class="{
              active: selectedTalentGroup === g.key,
              empty: talentGroupCountsReady && !talentGroupCounts[g.key],
              loading: !talentGroupCountsReady
            }"
            @click="handleTalentGroupClick(g.key)"
          >
            <span class="talent-group-chip-label">{{ g.label }}</span>
            <span class="talent-group-chip-count">{{ talentGroupCountLabel(g.key) }}</span>
          </button>
        </el-tooltip>
      </div>

      <!-- Talent Group Filter Criteria Bar -->
      <div v-if="selectedTalentGroup !== 'all'" class="filter-criteria-toolbar mt-16 mb-12">
        <div class="flex-center">
          <div class="filter-icon">
            <i class="el-icon-info"></i>
          </div>
          <div class="filter-details">
            <div class="filter-title">{{ selectedTalentGroupConfig.label }} ({{ talentGroupCountLabel(selectedTalentGroup) }})</div>
            <div class="filter-description">{{ selectedTalentGroupConfig.description }}</div>
          </div>
          <el-button type="text" class="edit-criteria-btn" @click="selectedTalentGroup = 'all'">
            <i class="el-icon-close"></i>
          </el-button>
        </div>
      </div>

      <div class="divTable mt-24">
        <div class="people-table-header">
          <el-tooltip :content="$t('insights.col_name_team_tooltip')" placement="top" effect="light">
            <div class="people-col col-person">
              <div class="qd-eyebrow">{{ $t("insights.Name_and_Team") }}</div>
              <div class="qd-eyebrow-sub">{{ $t("insights.Health_Indicator") }}</div>
            </div>
          </el-tooltip>

          <el-tooltip
            v-for="col in metricColumns"
            :key="col.key"
            :content="col.key === 'engagement' ? '' : $t(col.tooltipKey)"
            placement="top"
            effect="light"
            :popper-class="col.key === 'engagement' ? 'people-engagement-tooltip' : ''"
          >
            <template v-if="col.key === 'engagement'" slot="content">
              <div class="people-engagement-tooltip-content">
                <div
                  v-for="(line, lineIndex) in $t(col.tooltipKey).split('\n')"
                  :key="`engagement-tooltip-${lineIndex}`"
                  class="people-engagement-tooltip-line"
                >
                  {{ line }}
                </div>
              </div>
            </template>
            <div
              class="people-col col-metric col-metric-sortable"
              :class="{ 'is-sorted': columnSort.key === col.key }"
              role="button"
              tabindex="0"
              :aria-sort="columnSort.key === col.key ? (columnSort.direction === 'asc' ? 'ascending' : 'descending') : 'none'"
              @click="setColumnSort(col.key)"
              @keydown.enter.prevent="setColumnSort(col.key)"
              @keydown.space.prevent="setColumnSort(col.key)"
            >
              <div class="qd-eyebrow col-eyebrow">
                <span>{{ $t(col.titleKey) }}</span>
                <span class="col-sort-indicator" aria-hidden="true">
                  <template v-if="columnSort.key === col.key">{{ columnSort.direction === 'asc' ? '▲' : '▼' }}</template>
                  <template v-else>↕</template>
                </span>
              </div>
              <div class="qd-eyebrow-sub">{{ $t(col.subtitleKey) }}</div>
            </div>
          </el-tooltip>

          <div class="people-col col-chevron"></div>
        </div>
        <!-- card -->
        <div v-for="(val, index) in displayedPeople" :key="index + 'card'" class="people-row-wrap">
          <div class="box-card-table" :class="{
          'recovery': val.risk_level === '0',
          'risk low': val.risk_level === '1',
          'risk medium': val.risk_level === '2',
          'risk high': val.risk_level === '3',
          'expanded': isRowExpanded(val.email)
        }">
            <el-tooltip v-if="['0', '1', '2', '3'].includes(val.risk_level)"
                       :content="val.risk_due"
                       placement="left"
                       trigger="hover"
                       :open-delay="300"
                       effect="light"
                       popper-class="health-indicator-tooltip">
              <template slot="content">
                <div class="health-tooltip-content">
                  <div class="health-tooltip-header">
                    <img :src="getHealthIndicatorImage(val.risk_level)" class="tooltip-icon" />
                    <div class="tooltip-title">
                      {{ getRiskLevelTitle(val.risk_level) }}
                    </div>
                  </div>
                  <div class="health-tooltip-description">
                    {{ val.risk_due || getDefaultRiskMessage(val.risk_level) }}
                  </div>

                  <!-- Happiness Pattern Section -->
                  <div class="happiness-pattern-section">
                    <div class="pattern-header">
                      <span class="pattern-title">Recent Happiness Pattern</span>
                      <span class="pattern-subtitle">(Past 2 weeks)</span>
                    </div>

                    <div v-if="loadingPatterns[val.email]" class="pattern-loading">
                      <div class="loading-dots">
                        <span></span><span></span><span></span>
                      </div>
                    </div>

                    <div v-else-if="happinessPatterns[val.email]" class="happiness-pattern">
                      <div class="pattern-weeks-inline">
                        <div class="pattern-week-inline" v-if="happinessPatterns[val.email].pattern.filter(d => d.week === 1).length > 0">
                          <div class="week-label">Last week</div>
                          <div class="pattern-grid-week">
                            <div
                              v-for="(day, dayIdx) in happinessPatterns[val.email].pattern.filter(d => d.week === 1)"
                              :key="'w1-' + dayIdx"
                              :class="`pattern-day pattern-${day.status}`"
                              :title="formatPatternDayTooltip(day)"
                            >
                              <div class="day-indicator"></div>
                            </div>
                          </div>
                        </div>
                        <div class="pattern-week-inline" v-if="happinessPatterns[val.email].pattern.filter(d => d.week === 2).length > 0">
                          <div class="week-label">This week</div>
                          <div class="pattern-grid-week">
                            <div
                              v-for="(day, dayIdx) in happinessPatterns[val.email].pattern.filter(d => d.week === 2)"
                              :key="'w2-' + dayIdx"
                              :class="`pattern-day pattern-${day.status}`"
                              :title="formatPatternDayTooltip(day)"
                            >
                              <div class="day-indicator"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                                         <div v-else class="pattern-unavailable">
                       <div class="unavailable-icon">📊</div>
                       <span>No happiness data found for the past 2 weeks</span>
                     </div>
                  </div>
                </div>
              </template>
              <img
                :src="getHealthIndicatorImage(val.risk_level)"
                class="health-indicator"
                @mouseenter="loadHappinessPattern(val.email)"
              />
            </el-tooltip>

            <!-- Column 1: Person -->
            <div class="people-col col-person">
              <div class="flex-center cursor-pointer" @click="showPreviewData(val)">
                <div v-if="val.profilepic" style="width: 44px" class="profilepic"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <img v-lazy="val.profilepic" :key="val.profilepic" class="imgProfile image-skeleton"/>
                  <div class="fs-10 fw-600 noti-count">
                    <el-tooltip :content="getEngagementTooltip(val.house_level)" placement="top">
                      <img :src="getImgHouse(val.house_level)" class="imgProfilehouse"/>
                    </el-tooltip>
                  </div>
                </div>
                <div v-else style="width: 44px" class="profilepic"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="image imgProfile flex-mid">
                    <span class="text-in-image text-in-image-50 flex-mid">{{
                        $utils("acronymName", {
                          firstName: val.firstname,
                          lastName: val.lastname,
                        })
                      }}</span>
                  </div>
                  <div class="fs-10 fw-600 noti-count">
                    <el-tooltip :content="getEngagementTooltip(val.house_level)" placement="top">
                      <img :src="getImgHouse(val.house_level)" class="imgProfilehouse"/>
                    </el-tooltip>
                  </div>
                </div>
                <div class="flex-column ml-12 person-meta">
                  <span class="txtName ellipsis fs-13 fw-600 fc-000000"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    {{ val.firstname }} {{ val.lastname }}
                  </span>
                  <span class="txtTeam ellipsis fs-11 fw-500 opa-08 fc-000000"
                  :class="[ blurMode ?  'blurelement': '' ]">{{
                    val.team_name }}</span>
                  <div class="person-healthbar">
                    <el-progress :percentage="val.healthbar || 0" :color="healthBarColor(val.healthbar)"
                      :stroke-width="4" :show-text="false"></el-progress>
                  </div>
                </div>
              </div>
            </div>

            <!-- Column 2: Well-being. Uses latest completed WHO-5 once the cached background bundle arrives. -->
            <div class="people-col col-metric">
              <div v-if="isWellbeingScoreLoading(val.email)" class="score-chip score-chip-loading">
                <div class="text-skeleton score-chip-loading-value">&nbsp;</div>
                <div class="text-skeleton score-chip-loading-caption">&nbsp;</div>
              </div>
              <div v-else class="score-chip" :class="`score-chip-${getScoreBand(getWellbeingScore(val.email))}`">
                <div class="score-chip-value">{{ formatScore(getWellbeingScore(val.email)) }}</div>
                <div class="score-chip-caption">
                  <template v-if="getWellbeingScore(val.email) === null">{{ $t("insights.No_data") }}</template>
                  <template v-else>{{ scoreBandLabel(getWellbeingScore(val.email)) }}</template>
                </div>
              </div>
            </div>

            <!-- Column 3: Engagement -->
            <div class="people-col col-metric">
              <div v-if="isTableScoreLoading(val.email, 'computed_engagement')" class="score-chip score-chip-loading">
                <div class="text-skeleton score-chip-loading-value">&nbsp;</div>
                <div class="text-skeleton score-chip-loading-caption">&nbsp;</div>
              </div>
              <button
                v-else
                type="button"
                class="score-chip score-chip-button"
                :class="`score-chip-${getScoreBand(getCompositeMetric(val.email, 'computed_engagement'))}`"
                :aria-label="getEngagementScoreActionLabel(val)"
                @click.stop="openEngagementScoreModal(val)"
              >
                <div class="score-chip-value">{{ formatScore(getCompositeMetric(val.email, 'computed_engagement')) }}</div>
                <div class="score-chip-caption">
                  <template v-if="getCompositeMetric(val.email, 'computed_engagement') === null">Not enough data</template>
                  <template v-else>{{ scoreBandLabel(getCompositeMetric(val.email, 'computed_engagement')) }}</template>
                </div>
              </button>
            </div>

            <!-- Column 4: Performance -->
            <div class="people-col col-metric">
              <div v-if="isTableScoreLoading(val.email, 'computed_performance')" class="score-chip score-chip-loading">
                <div class="text-skeleton score-chip-loading-value">&nbsp;</div>
                <div class="text-skeleton score-chip-loading-caption">&nbsp;</div>
              </div>
              <div v-else class="score-chip" :class="`score-chip-${getScoreBand(getPerformanceMetric(val).value)}`">
                <div class="score-chip-value">{{ formatScore(getPerformanceMetric(val).value) }}</div>
                <div class="score-chip-caption">
                  <template v-if="getPerformanceMetric(val).source === 'empty'">{{ $t("insights.Performance_no_reviews") }}</template>
                  <template v-else>{{ scoreBandLabel(getPerformanceMetric(val).value) }}</template>
                </div>
              </div>
            </div>

            <!-- Column 5: Peer Trust -->
            <div class="people-col col-metric">
              <div v-if="isTableScoreLoading(val.email, 'computed_trust')" class="score-chip score-chip-loading">
                <div class="text-skeleton score-chip-loading-value">&nbsp;</div>
                <div class="text-skeleton score-chip-loading-caption">&nbsp;</div>
              </div>
              <div v-else class="score-chip" :class="`score-chip-${getScoreBand(getCompositeMetric(val.email, 'computed_trust'))}`">
                <div class="score-chip-value">{{ formatScore(getCompositeMetric(val.email, 'computed_trust')) }}</div>
                <div class="score-chip-caption" v-if="getCompositeMetric(val.email, 'computed_peer_trust') != null">
                  {{ Math.round(Number(getCompositeMetric(val.email, 'computed_peer_trust'))) }} {{ $t("insights.Peers") }}
                </div>
                <div class="score-chip-caption" v-else>{{ scoreBandLabel(getCompositeMetric(val.email, 'computed_trust')) }}</div>
              </div>
            </div>

            <!-- Column 6: Impact Rating (matches chip system: value + delta caption) -->
            <div class="people-col col-metric">
              <div class="score-chip" :class="`score-chip-${getScoreBand(val.impact_rating)}`">
                <div class="score-chip-value">
                  <template v-if="!showImpactPercentile">{{ val.impact_rating.toFixed(1) }}</template>
                  <template v-else>{{ calculatePercentile(val.email).toFixed(0) }}%</template>
                </div>
                <div class="score-chip-caption impact-caption" v-if="val.impact_rating > val.impact_rating_lastweek">
                  <span class="impact-arrow up">▲</span>{{ val.impact_compare.toFixed(1) }}
                </div>
                <div class="score-chip-caption impact-caption" v-else-if="val.impact_rating_lastweek > val.impact_rating">
                  <span class="impact-arrow down">▼</span>{{ val.impact_compare.toFixed(1) }}
                </div>
                <div class="score-chip-caption impact-caption neutral" v-else>—</div>
              </div>
            </div>

            <!-- Chevron -->
            <div class="people-col col-chevron">
              <button
                type="button"
                class="row-expand-btn"
                :aria-expanded="isRowExpanded(val.email) ? 'true' : 'false'"
                :aria-controls="`people-detail-${index}`"
                :aria-label="$t('insights.Show_details_for', { name: `${val.firstname} ${val.lastname}` })"
                @click.stop="toggleRowExpanded(val.email, $event)"
                @keydown.enter.stop.prevent="toggleRowExpanded(val.email, $event)"
                @keydown.space.stop.prevent="toggleRowExpanded(val.email, $event)"
              >
                <i class="el-icon-arrow-down" :class="{ 'rotated': isRowExpanded(val.email) }"></i>
              </button>
            </div>
          </div>

          <!-- Expanded detail panel -->
          <transition name="people-expand">
            <div
              v-if="isRowExpanded(val.email)"
              :id="`people-detail-${index}`"
              class="people-row-detail"
              :class="{
                'recovery': val.risk_level === '0',
                'risk low': val.risk_level === '1',
                'risk medium': val.risk_level === '2',
                'risk high': val.risk_level === '3'
              }"
              role="region"
            >
              <div v-if="isPeopleDetailLoading(val.email) && !isPeopleDetailReady(val.email)" class="people-detail-skeleton">
                <div v-for="panel in 3" :key="`people-detail-skeleton-${panel}`" class="people-detail-skeleton-panel">
                  <div class="text-skeleton people-detail-skeleton-title">&nbsp;</div>
                  <div class="text-skeleton people-detail-skeleton-line people-detail-skeleton-line-wide">&nbsp;</div>
                  <div class="text-skeleton people-detail-skeleton-line">&nbsp;</div>
                  <div class="text-skeleton people-detail-skeleton-line people-detail-skeleton-line-short">&nbsp;</div>
                </div>
              </div>
              <template v-else>
              <!-- Panel A: Positioning & Achievements -->
              <div class="detail-panel">
                <div class="qd-eyebrow detail-panel-title">{{ $t("insights.Positioning_and_Achievements") }}</div>
                <div class="detail-panel-body">
                  <div class="detail-tag-row">
                    <el-tooltip :content="getTalentTooltip(val.talent)" placement="top" effect="dark">
                      <span class="detail-pill" :class="talentAndNetworkTagsStyle(val.talent)">
                        <span class="detail-pill-dot"></span>
                        {{ val.talent === 'Latent Potential' ? 'Starter' : val.talent }}
                      </span>
                    </el-tooltip>
                    <el-tooltip v-if="val.network_type" :content="getNetworkTooltip(val.network_type)" placement="top" effect="dark">
                      <span class="detail-pill" :class="talentAndNetworkTagsStyle(val.network_type)">
                        <span class="detail-pill-dot"></span>
                        {{ val.network_type }}
                      </span>
                    </el-tooltip>
                  </div>

                  <div class="detail-stat-row">
                    <el-tooltip :content="getSkillTooltip(alignement[val.email] ? alignement[val.email].rating_skill : '0.0')" placement="top">
                      <div class="detail-stat">
                        <div class="detail-stat-label">{{ $t("insights.Skills") }}</div>
                        <div class="detail-stat-value">
                          <span>{{ alignement[val.email] ? alignement[val.email].rating_skill : '0.0' }}</span>
                          <img width="13" height="13" :src="getImgStar(alignement[val.email] ? alignement[val.email].rating_skill : 0)" class="detail-stat-star"/>
                        </div>
                        <div
                          v-if="alignement[val.email] && parseFloat(alignement[val.email].rating_skill) > 0"
                          class="detail-stat-band"
                          :class="`band-${getSkillBandSlug(alignement[val.email].rating_skill)}`"
                        >
                          <span class="detail-stat-band-dot" aria-hidden="true"></span>
                          {{ getSkillBandLabel(alignement[val.email].rating_skill) }}
                        </div>
                      </div>
                    </el-tooltip>

                    <el-tooltip :content="getValuesTooltip(val.email)" placement="top">
                      <div class="detail-stat">
                        <div class="detail-stat-label">{{ $t("insights.Values") }}</div>
                        <div class="detail-stat-value">{{ getGreaterValueAlignment(val.email) === 10 ? '10' : getGreaterValueAlignment(val.email).toFixed(1) }}<span class="detail-stat-suffix">/10</span></div>
                        <div
                          v-if="getGreaterValueAlignment(val.email) > 0"
                          class="detail-stat-band"
                          :class="`band-${getValuesBandSlug(getGreaterValueAlignment(val.email))}`"
                        >
                          <span class="detail-stat-band-dot" aria-hidden="true"></span>
                          {{ getValuesBandLabel(getGreaterValueAlignment(val.email)) }}
                        </div>
                        <div
                          v-if="getValueAlignmentSplit(val.email).show"
                          class="detail-stat-split"
                        >
                          <div class="detail-stat-split-row">
                            <span class="detail-stat-split-label">{{ $t("insights.Values_split_given_label") }}</span>
                            <span class="detail-stat-split-bar" aria-hidden="true">
                              <span
                                class="detail-stat-split-bar-fill"
                                :style="{ width: (getValueAlignmentSplit(val.email).given * 10) + '%' }"
                              ></span>
                            </span>
                            <span class="detail-stat-split-num">{{ getValueAlignmentSplit(val.email).given.toFixed(1) }}</span>
                          </div>
                          <div class="detail-stat-split-row">
                            <span class="detail-stat-split-label">{{ $t("insights.Values_split_received_label") }}</span>
                            <span class="detail-stat-split-bar" aria-hidden="true">
                              <span
                                class="detail-stat-split-bar-fill"
                                :style="{ width: (getValueAlignmentSplit(val.email).received * 10) + '%' }"
                              ></span>
                            </span>
                            <span class="detail-stat-split-num">{{ getValueAlignmentSplit(val.email).received.toFixed(1) }}</span>
                          </div>
                        </div>
                      </div>
                    </el-tooltip>

                    <el-tooltip v-if="medals[val.email] > 0" :content="`${medals[val.email]} medal${medals[val.email] === 1 ? '' : 's'}`" placement="top">
                      <div class="detail-stat">
                        <div class="detail-stat-label">{{ $t("insights.Medals") }}</div>
                        <div class="detail-achievement-icons">
                          <span class="detail-achievement-chip">
                            <img :src="$utils('icons', 'Medals_32')" alt="Medals"/>
                            <span>{{ medals[val.email] }}</span>
                          </span>
                        </div>
                      </div>
                    </el-tooltip>
                  </div>

                  <div
                    v-if="trulyDetails[val.email] && trulyDetails[val.email].length > 0"
                    class="detail-recognized-by"
                    :class="[ blurMode ? 'blurelement' : '' ]"
                  >
                    <div class="detail-recognized-header">
                      <img :src="$utils('icons', 'Outstanding_32')" alt="" class="detail-recognized-header-icon"/>
                      <div class="detail-recognized-header-stack">
                        <div class="detail-recognized-header-title">{{ $t("insights.Recognized_as_outstanding") }}</div>
                        <div class="detail-recognized-header-meta">
                          {{ trulyDetails[val.email].length }} {{ trulyDetails[val.email].length === 1 ? $t("insights.Peer_single") : $t("insights.Peers") }} · {{ $t("insights.Past_6_months") }}
                        </div>
                      </div>
                    </div>
                    <div class="detail-recognized-list">
                      <div
                        v-for="(item, idx) in trulyDetails[val.email].slice(0, 5)"
                        :key="idx"
                        class="detail-recognized-row"
                        :class="`detail-recognized-row-${recognitionTierMeta(item.tag).slug}`"
                      >
                        <span class="detail-recognized-dot" aria-hidden="true"></span>
                        <span class="detail-recognized-tier">{{ recognitionTierMeta(item.tag).label }}</span>
                        <span class="detail-recognized-person">
                          <span class="detail-recognized-sender">{{ getTrulySenderName(item.sender) }}</span>
                          <span class="detail-recognized-date">{{ formatTrulyDateMonthYear(item.date) }}</span>
                        </span>
                      </div>
                      <span
                        v-if="trulyDetails[val.email].length > 5"
                        class="detail-recognized-more"
                      >
                        +{{ trulyDetails[val.email].length - 5 }} {{ $t("insights.More") }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Panel B: Engagement & Contributions -->
              <div class="detail-panel">
                <div class="qd-eyebrow detail-panel-title">{{ $t("insights.Engagement_and_Contributions") }}</div>
                <div class="detail-panel-body">
                  <div class="detail-bar-row">
                    <span class="detail-bar-label">{{ $t("insights.Checkin_consistency") }}</span>
                    <div class="detail-bar-wrap">
                      <div class="detail-bar">
                        <div
                          class="detail-bar-fill"
                          :class="`detail-bar-fill-${getScoreBand(getCompositeMetric(val.email, 'computed_checkin_consistency'))}`"
                          :style="{ width: `${Math.max(2, Math.min(100, Number(getCompositeMetric(val.email, 'computed_checkin_consistency')) || 0))}%` }"
                        ></div>
                      </div>
                      <span class="detail-bar-value">{{ formatScore(getCompositeMetric(val.email, 'computed_checkin_consistency')) }}</span>
                    </div>
                  </div>
                  <!-- Giving / Receiving scores are median-normalized indices, not
                       percentages — tile + band label avoids misreading the score as
                       a percent (the failure mode if we used a progress bar). -->
                  <div class="detail-recognition-tiles">
                    <div
                      v-for="tile in recognitionTileDefs"
                      :key="tile.key"
                      class="detail-recognition-tile"
                      :class="`detail-recognition-tile-${getScoreBand(getCompositeMetric(val.email, tile.key))}`"
                    >
                      <div class="detail-recognition-tile-head">
                        <span class="detail-recognition-tile-label">{{ $t(tile.labelKey) }}</span>
                        <span
                          v-if="getCompositeMetric(val.email, tile.key) != null"
                          class="detail-recognition-tile-score"
                        >{{ formatScore(getCompositeMetric(val.email, tile.key)) }}</span>
                      </div>
                      <div class="detail-recognition-tile-band">
                        {{ getRecognitionBandLabel(getCompositeMetric(val.email, tile.key)) || '—' }}
                      </div>
                      <div class="detail-recognition-tile-sub">{{ $t("insights.Past_6_months") }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Panel C: Context & Power Skills -->
              <div class="detail-panel">
                <div class="qd-eyebrow detail-panel-title">{{ $t("insights.Context_and_Power_Skills") }}</div>
                <div class="detail-panel-body">
                  <div
                    v-if="val.risk_due"
                    class="detail-risk-reason"
                    :class="[
                      blurMode ? 'blurelement' : '',
                      `detail-risk-reason-level-${val.risk_level || '0'}`
                    ]"
                  >
                    <span class="detail-risk-label">
                      <span class="detail-risk-dot"></span>
                      {{ $t("insights.Risk_reason") }}
                    </span>
                    <span class="detail-risk-text">{{ val.risk_due }}</span>
                  </div>

                  <div class="detail-flight-row" v-if="getCompositeMetric(val.email, 'computed_flight_risk') != null">
                    <span class="detail-bar-label">{{ $t("insights.Flight_Risk") }}</span>
                    <div class="detail-flight-wrap">
                      <div
                        class="detail-flight-meter"
                        :class="`detail-flight-meter-${getFlightRiskSegment(getCompositeMetric(val.email, 'computed_flight_risk'))}`"
                      >
                        <span class="detail-flight-segment detail-flight-segment-safe">{{ $t("insights.Flight_Risk_Safe") }}</span>
                        <span class="detail-flight-segment detail-flight-segment-watch">{{ $t("insights.Flight_Risk_Watch") }}</span>
                        <span class="detail-flight-segment detail-flight-segment-atrisk">{{ $t("insights.Flight_Risk_At_risk") }}</span>
                      </div>
                      <span class="detail-bar-value">{{ formatScore(getCompositeMetric(val.email, 'computed_flight_risk')) }}</span>
                    </div>
                  </div>

                  <div class="detail-bar-row detail-bar-row-inline" v-if="Number(getGoalMetric(val.email, 'owned_key_results')) > 0">
                    <span class="detail-bar-label">{{ $t("insights.Goals") }}</span>
                    <span class="detail-bar-value detail-goals-value">
                      {{ getGoalMetric(val.email, 'owned_key_results') }} KR · {{ formatScore(getGoalMetric(val.email, 'kr_progress')) }}% · health {{ formatScore(getGoalMetric(val.email, 'kr_health')) }}%
                    </span>
                  </div>
                  <div
                    class="detail-bar-row"
                    :class="{ 'detail-bar-row-disabled': !hasManagerAssignment(val) }"
                    v-if="!hasManagerAssignment(val) || getCompositeMetric(val.email, 'computed_manager_responsiveness') != null"
                  >
                    <span class="detail-bar-label">{{ $t("insights.Manager_responsiveness") }}</span>
                    <div v-if="hasManagerAssignment(val)" class="detail-bar-wrap">
                      <div class="detail-bar">
                        <div
                          class="detail-bar-fill"
                          :class="`detail-bar-fill-${getScoreBand(getCompositeMetric(val.email, 'computed_manager_responsiveness'))}`"
                          :style="{ width: `${Math.max(2, Math.min(100, Number(getCompositeMetric(val.email, 'computed_manager_responsiveness')) || 0))}%` }"
                        ></div>
                      </div>
                      <span class="detail-bar-value">{{ formatScore(getCompositeMetric(val.email, 'computed_manager_responsiveness')) }}</span>
                    </div>
                    <div v-else class="detail-bar-wrap detail-bar-wrap-disabled" aria-disabled="true">
                      <div class="detail-bar detail-bar-disabled" aria-hidden="true"></div>
                      <span class="detail-bar-value detail-bar-value-muted">{{ $t("insights.No_manager_assigned") }}</span>
                    </div>
                  </div>

                  <div class="detail-eq-grid" v-if="hasPowerSkillsData(val)">
                    <div class="qd-eyebrow-sub detail-eq-title">{{ $t("insights.Power_Skills") }}</div>
                    <div class="detail-eq-cells">
                      <div class="detail-eq-cell"><span class="detail-eq-label">{{ $t("insights.Empathy") }}</span><span class="detail-eq-value">{{ formatScore(val.ps_empathy) }}<span class="detail-eq-suffix">/10</span></span></div>
                      <div class="detail-eq-cell"><span class="detail-eq-label">{{ $t("insights.Self_Awareness") }}</span><span class="detail-eq-value">{{ formatScore(val.ps_self_awareness) }}<span class="detail-eq-suffix">/10</span></span></div>
                      <div class="detail-eq-cell"><span class="detail-eq-label">{{ $t("insights.Critical_Thinking") }}</span><span class="detail-eq-value">{{ formatScore(val.ps_critical_thinking) }}<span class="detail-eq-suffix">/10</span></span></div>
                      <div class="detail-eq-cell"><span class="detail-eq-label">{{ $t("insights.Leadership") }}</span><span class="detail-eq-value">{{ formatScore(val.ps_leadership) }}<span class="detail-eq-suffix">/10</span></span></div>
                      <div class="detail-eq-cell"><span class="detail-eq-label">{{ $t("insights.Initiative") }}</span><span class="detail-eq-value">{{ formatScore(val.ps_initiative_making) }}<span class="detail-eq-suffix">/10</span></span></div>
                      <div class="detail-eq-cell"><span class="detail-eq-label">{{ $t("insights.Optimism") }}</span><span class="detail-eq-value">{{ formatScore(val.ps_optimism) }}<span class="detail-eq-suffix">/10</span></span></div>
                    </div>
                  </div>
                </div>
              </div>
              </template>
            </div>
          </transition>
        </div>
        <div class="people-table-skeleton" v-if="loadingPeopleTable">
          <div
            v-for="row in [1, 2, 3, 4]"
            :key="`people-table-skeleton-${row}`"
            class="people-table-skeleton-row"
          >
            <div class="people-table-skeleton-person">
              <div class="image-skeleton image-profile-40 opa-06"></div>
              <div class="people-table-skeleton-meta">
                <div class="text-skeleton fs-14" style="width: 128px">&nbsp;</div>
                <div class="text-skeleton fs-12 opa-06 mt-6" style="width: 92px">&nbsp;</div>
              </div>
            </div>
            <div class="people-table-skeleton-metrics">
              <div class="text-skeleton people-table-skeleton-chip">&nbsp;</div>
              <div class="text-skeleton people-table-skeleton-chip">&nbsp;</div>
              <div class="text-skeleton people-table-skeleton-chip">&nbsp;</div>
              <div class="text-skeleton people-table-skeleton-chip">&nbsp;</div>
              <div class="text-skeleton people-table-skeleton-chip">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-preview-user v-if="modalPreviewDataStatus" :modalMemberData="modalMemberData" :userDetail="userDetail"
      :showingModal="modalPreviewDataStatus" :passProfileToRelationship="passProfileToRelationship"
      @closed="closedModal"></modal-preview-user>
    <div class="remove-padding-modal">
      <el-dialog :visible.sync="modalViewListExcels" top="12vh" width="480px">
        <div class="recipients-modal-style fc-000000">
          <div class="flex-center">
            <span class="fs-20 fw-700">{{ $t("insights.Excels_at") }}</span>
            <span class="big-tag">{{ viewListExcelsDataSelected.label }}</span>
          </div>
          <div class="mt-24">
            <span class="fs-18 fw-700">{{ viewListExcelsDataSelected.userCount }}
              {{ $t("insights.profiles") }}</span>
          </div>
          <div class="mt-4">
            <span class="fc-626262 fs-14">{{
              $t("insights.were_tagged_by")
            }}</span>
          </div>
        </div>
        <div class="members-recipients thin-scrollbar">
          <div v-for="item in viewListExcelsDataSelected.userList" :key="item.key" class="rowDataStyle">
            <div class="columnDataStyle">
              <div class="flex-center">
                <div class="flex-center" v-if="item.imageProfile">
                  <img v-lazy="item.imageProfile" :key="item.imageProfile" class="image-skeleton image-profile-40" />
                </div>
                <div v-else class="image image-profile-40">
                  <div class="text-in-image text-in-image-40 flex-mid">
                    {{ $utils("acronymName", { fullName: item.fullname }) }}
                  </div>
                </div>
                <div class="flex-column pl-16">
                  <span class="text-name">{{ item.fullname }}</span>
                  <span class="text-email">{{ item.team_name }}</span>
                </div>
                <div class="ml-auto cell flex-mid">
                  {{ item.excelsCount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

    </div>
    <el-dialog
      :visible.sync="engagementBreakdownDialogVisible"
      custom-class="engagement-breakdown-dialog"
      width="520px"
      top="8vh"
      title="Engagement breakdown"
      @closed="clearEngagementScoreModal"
    >
      <div v-if="selectedEngagementPerson" class="engagement-breakdown-modal">
        <div class="engagement-breakdown-header">
          <div class="engagement-breakdown-person">
            <div class="engagement-breakdown-kicker">{{ getSelectedEngagementSourceLabel() }}</div>
            <div class="engagement-breakdown-name">
              {{ selectedEngagementPerson.firstname }} {{ selectedEngagementPerson.lastname }}
            </div>
            <div class="engagement-breakdown-team">{{ selectedEngagementPerson.team_name }}</div>
          </div>
          <div
            class="engagement-breakdown-score-card"
            :class="`score-chip-${getScoreBand(getSelectedEngagementScore())}`"
          >
            <div class="engagement-breakdown-score-value">{{ formatScore(getSelectedEngagementScore()) }}</div>
            <div class="engagement-breakdown-score-caption">
              <template v-if="getSelectedEngagementScore() === null">Not enough data</template>
              <template v-else>{{ scoreBandLabel(getSelectedEngagementScore()) }}</template>
            </div>
          </div>
        </div>

        <div class="engagement-breakdown-meta">
          <div class="engagement-breakdown-meta-item">
            <i class="el-icon-date" aria-hidden="true"></i>
            <div>
              <span>Window</span>
              <strong>{{ getSelectedEngagementPeriod() || "Recent window unavailable" }}</strong>
            </div>
          </div>
          <div class="engagement-breakdown-meta-item">
            <i class="el-icon-check" aria-hidden="true"></i>
            <div>
              <span>Signals</span>
              <strong>{{ getSelectedEngagementFullCreditSummary() }}</strong>
            </div>
          </div>
        </div>

        <template v-if="getSelectedEngagementRows().length">
          <div class="engagement-breakdown-section-heading">
            <div>
              <div class="engagement-breakdown-section-title">Participation signals</div>
              <div class="engagement-breakdown-section-copy">
                Progress toward full credit.
              </div>
            </div>
            <div class="engagement-breakdown-focus">{{ getSelectedEngagementFocusText() }}</div>
          </div>
          <div class="engagement-breakdown-list">
            <div
              v-for="row in getSelectedEngagementRows()"
              :key="row.key"
              class="engagement-breakdown-row"
            >
              <div class="engagement-breakdown-row-top">
                <div class="engagement-breakdown-row-main">
                  <div class="engagement-breakdown-row-titleline">
                    <div class="engagement-breakdown-row-label">{{ row.label }}</div>
                    <span class="engagement-breakdown-status" :class="row.statusClass">
                      {{ row.statusLabel }}
                    </span>
                  </div>
                  <div class="engagement-breakdown-row-detail">{{ row.detail }}</div>
                </div>
                <div
                  class="engagement-breakdown-row-rate"
                  :class="{ 'is-empty': row.rateTone === 'empty' }"
                >
                  <strong>{{ row.rateValue }}</strong>
                  <span v-if="row.targetLabel">{{ row.targetLabel }}</span>
                </div>
              </div>
              <div class="engagement-breakdown-meter" aria-hidden="true">
                <span :style="{ width: `${row.barPercent}%` }"></span>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="engagement-breakdown-empty">
          We do not have enough detail to explain this score yet. Try again after the next engagement update.
        </div>
      </div>
    </el-dialog>
    <risk-drill-down
      :visible.sync="showRiskDrillDown"
      :week-dates="labelDate"
      :selected-week-index.sync="riskDrillDownWeekIndex"
      :risk-history-data="riskDrillDownData"
      :week-risk-counts="riskDrillDownWeekCounts"
    />
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { importMemberDeps } from '@/store/integrations';
import { getCompanyTimezone, toCompanyDate } from '@/store/utils/companyTimezone';

// Flight Risk band cutoffs. Shared between flightRiskLabel (i18n copy) and
// getFlightRiskSegment (meter slug) so the band boundaries can't drift.
const FLIGHT_RISK_AT_RISK = 60;
const FLIGHT_RISK_WATCH = 30;

// Recognition tiles in the expand panel — order matters (Giving before
// Receiving). Defined once at module scope to drive a v-for and prevent the
// two near-identical tile blocks from drifting.
const RECOGNITION_TILE_DEFS = [
  { key: "computed_giving_recognition", labelKey: "insights.Giving" },
  { key: "computed_receiving_recognition", labelKey: "insights.Receiving" },
];

const normalizeGroupKey = (value) => String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
const CONNECTOR_NETWORK_KEYS = new Set(['high_network', 'super_network', 'high_outer', 'super_outer']);
const LIMITED_NETWORK_KEYS = new Set(['low_network', 'medium_network', 'medium_inner', 'medium_outer']);
const UNDER_RECOGNIZED_TALENT_KEYS = new Set([
  'untapped_potential',
  'valued_contributor',
  'emerging_talent',
  'high_potential',
  'latent_potential',
  'hidden_talent',
]);

// Sortable metric columns. Frozen so Vue's reactivity walker leaves it alone —
// these never mutate at runtime. Each accessor takes `(vm, person)` so the
// sort comparator stays type-flat (one accessor call → one number/null) and
// doesn't have to know about per-column signature quirks.
const METRIC_COLUMNS = Object.freeze([
  {
    key: "wellbeing",
    titleKey: "insights.Wellbeing",
    subtitleKey: "insights.Wellbeing_subtitle",
    tooltipKey: "insights.col_wellbeing_tooltip",
    accessor: (vm, p) => vm.getWellbeingScore(p.email),
  },
  {
    key: "engagement",
    titleKey: "insights.Engagement",
    subtitleKey: "insights.Engagement_subtitle",
    tooltipKey: "insights.col_engagement_tooltip",
    accessor: (vm, p) => vm.getCompositeMetric(p.email, "computed_engagement"),
  },
  {
    key: "performance",
    titleKey: "insights.Performance",
    subtitleKey: "insights.Performance_subtitle_v2",
    tooltipKey: "insights.col_performance_tooltip",
    accessor: (vm, p) => vm.getPerformanceMetric(p).value,
  },
  {
    key: "peer_trust",
    titleKey: "insights.Peer_Trust",
    subtitleKey: "insights.Peer_Trust_subtitle_v2",
    tooltipKey: "insights.col_peer_trust_tooltip",
    accessor: (vm, p) => vm.getCompositeMetric(p.email, "computed_trust"),
  },
  {
    key: "impact",
    titleKey: "insights.Impact_Rating",
    subtitleKey: "insights.Overall_Score",
    tooltipKey: "insights.col_impact_rating_tooltip",
    accessor: (vm, p) => vm.showImpactPercentile
      ? vm.calculatePercentile(p.email)
      : p.impact_rating,
  },
]);

// Click cycle for column-header sort: inactive -> desc -> asc -> inactive.
const SORT_NEXT = { none: "desc", desc: "asc", asc: null };

const normalizeSignalCode = (value) => {
  if (value === null || value === undefined || value === '') return '000';
  const source = Array.isArray(value) ? value.join('') : String(value);
  const digits = source.replace(/\D/g, '');
  return digits ? digits.padStart(3, '0').slice(-3) : '000';
};

export default {
  name: "people",
  components: {
    modalPreviewUser: require("@/components/even/modal/user-preview").default,
    'risk-drill-down': require("@/components/insights/RiskDrillDown.vue").default,
  },
  created() {
    this.loadingPeopleTable = !(this.starperform && this.starperform.length > 0);
    this.loadInitialPeopleIntelligence();
    this.loadCohortOptions();
  },
  props: {
    tabActive: String,
  },
  watch: {
    // Initialize team selection when teams are loaded (one-time setup)
    optionsTeam: {
      handler(teams) {
        if (teams && teams.length > 0) {
          const currentTeamId = this.$store.getters["people/selectTeam"];
          // Only set if not already set
          if (!currentTeamId || currentTeamId === '') {
            if (this.user.user_type === 'leadership') {
              this.$store.commit("people/setTeamId", { keyword: this.user.team });
            } else {
              this.$store.commit("people/setTeamId", {
                keyword: this.allTeamsLabel,
              });
            }
          }
        }
      },
      immediate: true
    },
    inputSearch() {
      this.expandedEmails = [];
      if (this.searchMembersDebounceTimer) {
        window.clearTimeout(this.searchMembersDebounceTimer);
      }
      this.searchMembersDebounceTimer = window.setTimeout(() => {
        this.$store.dispatch("people/searchMembers", this.checkedTalentType);
        this.searchMembersDebounceTimer = null;
      }, 250);
    },
    selectTeam() {
      this.expandedEmails = [];
      // this.$store.dispatch("people/getStarAndRiskDataChart", "");
      if (!this.loadingDataChart && !this.loadingDataChartFirstTime && this.optionsTeam.length > 0) {
        this.$store.dispatch("people/searchByTeam", this.checkedTalentType);
      }
    },
    loadingDataChart(newVal, oldVal) {
      // When loading finishes, re-render charts after the skeleton swaps back to canvases.
      if (oldVal === true && newVal === false) {
        this.$nextTick(() => {
          this.renderRiskRecoveryChart();
          if (this.PowerSkillShowingData === 'Impact Rating') {
            this.renderImpactDonutChart();
          }
        });
      }
    },
    starperform: {
      handler(members) {
        if (members && members.length > 0 && this.loadingPeopleTable) {
          this.loadingPeopleTable = false;
        }
        // Re-render donut chart when starperform data changes (team filter applied)
        if (this.PowerSkillShowingData === 'Impact Rating' && !this.loadingDataChart) {
          this.$nextTick(() => {
            this.renderImpactDonutChart();
          });
        }
      },
      immediate: true
    },
    initialPeopleLoading(isLoading) {
      if (isLoading && !(this.starperform && this.starperform.length > 0)) {
        this.loadingPeopleTable = true;
      } else if (this.starperform && this.starperform.length > 0) {
        this.loadingPeopleTable = false;
      }
    },
    loadingDataChartFirstTime() {
      if (!this.loadingDataChartFirstTime) {
        this.$store.dispatch("people/searchByTeam", this.checkedTalentType);
      }
    },
    RiskAndStarChart() {
      if (!this.loadingDataChart && !this.loadingDataChartFirstTime) {
        if (this.my_risk_recovery_chart) this.my_risk_recovery_chart.destroy();
        this.renderRiskRecoveryChart();
      }
    },
    tabActive(val) {
      if (val == "people") {
        if (this.my_risk_recovery_chart) {
          this.my_risk_recovery_chart.destroy();
        }
        this.renderRiskRecoveryChart();
        this.$nextTick(() => {
          this.renderImpactDonutChart();
        });
      } else {
        if (this.my_risk_recovery_chart) {
          this.my_risk_recovery_chart.destroy();
        }
        if (this.my_impact_donut_chart) {
          this.my_impact_donut_chart.destroy();
        }
      }
    },
    impactDistribution: {
      handler() {
        if (this.PowerSkillShowingData === 'Impact Rating') {
          this.$nextTick(() => {
            this.renderImpactDonutChart();
          });
        }
      },
      deep: true
    },
    PowerSkillShowingData(val) {
      // Re-render Risk Chart to adjust for height change
      this.$nextTick(() => {
        if (this.my_risk_recovery_chart) {
          this.my_risk_recovery_chart.destroy();
        }
        this.renderRiskRecoveryChart();
      });

      if (val === 'Impact Rating') {
        this.$nextTick(() => {
          this.renderImpactDonutChart();
        });
      } else {
        if (this.my_impact_donut_chart) {
          this.my_impact_donut_chart.destroy();
          this.my_impact_donut_chart = null;
        }
      }
    },
    selectedTalentGroup() {
      this.expandedEmails = [];
    },
  },
  computed: {
    recognitionTileDefs() {
      return RECOGNITION_TILE_DEFS;
    },
    riskChartHeight() {
      // Taller height for Impact Rating view to match donut chart + legend
      // Standard height for other views
      return this.PowerSkillShowingData === 'Impact Rating' ? '260px' : '210px';
    },
    inputSearch: {
      get() {
        // this.checkedTalentType = this.talentTypeOptionAllCheck
        return this.$store.getters["people/inputSearch"];
      },
      set(value) {
        this.$store.commit("people/setinputSearch", {
          keyword: value,
          userstatus: this.type,
        });
      },
    },
    selectTeam: {
      get() {
        return this.$store.getters["people/selectTeam"];
      },
      set(value) {
        this.$store.commit("people/setTeamId", { keyword: value });
      },
    },
    // Per-email KR metrics derived from the goals store. Mirrors talent-matrix.vue:609.
    // Returns empty when goals haven't been loaded; Performance column falls back to gem rate.
    goalMetricsByEmail() {
      const goalsFlat = (this.$store.getters && this.$store.getters["goals/allGoalsFlat"]) || [];
      const metrics = {};
      const krOwnerValue = (kr, email) => {
        if (kr && kr.mode === "individual" && kr.owner_progress) {
          return Number(kr.owner_progress[email] || 0);
        }
        return Number((kr && kr.current_value) || 0);
      };
      const krOwnerProgress = (kr, email) => {
        if (!kr || kr.target_value === kr.start_value) return 0;
        const currentValue = krOwnerValue(kr, email);
        const raw = ((currentValue - kr.start_value) / (kr.target_value - kr.start_value)) * 100;
        return Math.min(Math.max(raw, 0), 100);
      };
      const krHealthStatus = (progress) => {
        if (progress >= 100) return "completed";
        if (progress >= 60) return "on_track";
        if (progress >= 30) return "at_risk";
        return "off_track";
      };

      goalsFlat.forEach((goal) => {
        const keyResults = goal && goal.key_results ? goal.key_results : [];
        keyResults.forEach((kr) => {
          const ownerEmails = Array.isArray(kr.owner_emails) ? Array.from(new Set(kr.owner_emails)) : [];
          ownerEmails.forEach((email) => {
            if (!email) return;
            if (!metrics[email]) {
              metrics[email] = { owned_key_results: 0, progressSum: 0, healthyCount: 0 };
            }
            const progress = krOwnerProgress(kr, email);
            const status = krHealthStatus(progress);
            metrics[email].owned_key_results += 1;
            metrics[email].progressSum += progress;
            if (status === "on_track" || status === "completed") {
              metrics[email].healthyCount += 1;
            }
          });
        });
      });

      Object.keys(metrics).forEach((email) => {
        const owned = metrics[email].owned_key_results || 0;
        metrics[email].kr_progress = owned > 0 ? Math.round((metrics[email].progressSum / owned) * 10) / 10 : 0;
        metrics[email].kr_health = owned > 0 ? Math.round((metrics[email].healthyCount * 100 / owned) * 10) / 10 : 0;
      });

      return metrics;
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    // peoplerisk() {
    //   return this.$store.getters["people/peoplerisk"];
    // },
    starperform() {
      return this.$store.getters["people/starperform"];
    },
    optionsTeam() {
      // Pure getter - no side effects
      return this.$store.getters["team/teamsall"];
    },
    allTeamsLabel() {
      return `All Teams (${this.optionsTeam.length})`;
    },
    cohortsAll() {
      return this.$store.getters["membersCohort/cohortsall"] || [];
    },
    membersByCohort() {
      return this.$store.getters["membersCohort/membersByCohort"] || {};
    },
    cohortMembersAll() {
      return this.$store.getters["membersCohort/membersall"] || {};
    },
    visibleCohortOptions() {
      const cohorts = this.cohortsAll || [];
      if (this.user.user_type !== 'leadership') return cohorts;

      const allowedTeams = {};
      (this.optionsTeam || []).forEach((team) => {
        if (team && team.key) allowedTeams[team.key] = true;
      });
      if (this.user.team) allowedTeams[this.user.team] = true;

      return cohorts.filter((cohort) => {
        if (Array.isArray(cohort.sup) && cohort.sup.some((member) => member && member.team && allowedTeams[member.team])) {
          return true;
        }

        const users = this.membersByCohort[cohort.key] || cohort.users || {};
        return Object.keys(users).some((key) => {
          const rawValue = users[key];
          const email = typeof rawValue === 'string' ? rawValue : key.replace(/\|\|/g, '.');
          const member = this.cohortMembersAll[email] || this.cohortMembersAll[key] || this.membersall[email] || this.membersall[key];
          return member && member.team && allowedTeams[member.team];
        });
      });
    },
    selectedCohortId() {
      return typeof this.selectTeam === 'string' && this.selectTeam.indexOf('cohort:') === 0
        ? this.selectTeam.slice('cohort:'.length)
        : '';
    },
    selectedCohortEmailLookup() {
      const lookup = {};
      if (!this.selectedCohortId) return lookup;

      const addEmail = (value) => {
        if (!value) return;
        if (typeof value === 'string') {
          lookup[value] = true;
          lookup[value.replace(/\|\|/g, '.')] = true;
          return;
        }
        if (value.email) lookup[value.email] = true;
        if (value.key) lookup[String(value.key).replace(/\|\|/g, '.')] = true;
      };

      const cohort = this.cohortsAll.find((item) => item.key === this.selectedCohortId || item.id === this.selectedCohortId);
      const users = this.membersByCohort[this.selectedCohortId] || (cohort && cohort.users) || {};
      Object.keys(users).forEach((key) => {
        addEmail(key);
        addEmail(users[key]);
      });

      return lookup;
    },
    talentTypeOption() {
      return this.$store.getters["people/talentTypeOption"];
    },
    modalMemberData() {
      return this.$store.getters["people/modalMemberData"];
    },
    membersall() {
      return this.$store.getters["people/membersall"];
    },
    passProfileToRelationship() {
      let passProfile = {
        firstname: this.userDetail.firstname || "",
        lastname: this.userDetail.lastname || "",
        teamColor: this.userDetail.house_color || "",
        house: this.userDetail.house || "",
        pic: this.userDetail.large_pic || false,
      };
      return passProfile;
    },
    RiskAndStarChart() {
      return this.$store.getters["people/RiskAndStarChart"];
    },
    talentChartData() {
      return this.$store.getters["people/talentChartData"];
    },
    talentChartOpacities() {
      const data = this.talentChartData;
      if (!data || Object.keys(data).length === 0) {
        return {};
      }
      
      const values = Object.values(data).filter(val => val > 0);
      if (values.length === 0) {
        return {};
      }
      
      const maxValue = Math.max(...values);
      const minValue = Math.min(...values);
      const range = maxValue - minValue;
      
      const opacities = {};
      Object.keys(data).forEach(key => {
        const value = data[key] || 0;
        if (value === 0) {
          opacities[key] = 0.4;
        } else if (range === 0) {
          opacities[key] = 1;
        } else {
          const normalizedValue = (value - minValue) / range;
          opacities[key] = Math.max(0.65, Math.min(1, 0.65 + (normalizedValue * 0.35)));
        }
      });
      
      return opacities;
    },
    networkChartOpacities() {
      const data = this.networkChartData;
      if (!data || Object.keys(data).length === 0) {
        return {};
      }
      
      const values = Object.values(data).filter(val => val > 0);
      if (values.length === 0) {
        return {};
      }
      
      const maxValue = Math.max(...values);
      const minValue = Math.min(...values);
      const range = maxValue - minValue;
      
      const opacities = {};
      Object.keys(data).forEach(key => {
        const value = data[key] || 0;
        if (value === 0) {
          opacities[key] = 0.4;
        } else if (range === 0) {
          opacities[key] = 1;
        } else {
          const normalizedValue = (value - minValue) / range;
          opacities[key] = Math.max(0.65, Math.min(1, 0.65 + (normalizedValue * 0.35)));
        }
      });
      
      return opacities;
    },
    networkChartData() {
      return this.$store.getters["people/networkChartData"];
    },
    // powerChartData() {
    //   return this.$store.getters["people/powerChartData"];
    // },
    // excelsAtDataChart() {
    //   return this.$store.getters["people/excelsAtDataChart"];
    // },
    viewListExcelsData() {
      return this.$store.getters["people/viewListExcelsData"];
    },
    labelDate() {
      return this.$store.getters["people/labelDate"];
    },
    // Cached lookup: active members keyed by email (only rebuilds when membersall changes)
    riskDrillDownMemberLookup() {
      var lookup = {};
      var membersall = this.membersall;
      if (membersall) {
        var memberValues = Array.isArray(membersall) ? membersall : Object.values(membersall);
        for (var mi = 0; mi < memberValues.length; mi++) {
          var m = memberValues[mi];
          if (m && m.email) lookup[m.email] = m;
        }
      }
      return lookup;
    },
    // Week-independent: builds per-person risk history from allDataRisk
    // Only recomputes when risk data, members, or archived lookup changes — NOT on tab switch
    riskDrillDownPeopleMap() {
      var allDataRisk = this.$store.state.people.allDataRisk;
      var masterDate = this.$store.state.people.masterDate;

      if (!masterDate || masterDate.length === 0 || !allDataRisk || Object.keys(allDataRisk).length === 0) {
        return {};
      }

      var memberLookup = this.riskDrillDownMemberLookup;
      var membersByKey = this.$store.state.people.membersByKey || {};
      var archiveLookup = this.archivedMemberLookup || {};
      var teamByKey = this.$store.state.people.teamByKey || {};

      // Build team scope for filtering (respects team dropdown selection)
      var selectedTeamId = this.$store.state.people.team_id;
      var selectedTeamScope = selectedTeamId && selectedTeamId.substring(0, 1) === '-'
        ? selectedTeamId
        : (this.user.user_type === 'leadership' ? this.user.team : '');
      var teamScope = {};
      var hasTeamFilter = !!(selectedTeamScope && selectedTeamScope.substring(0, 1) === '-');
      var cohortEmailLookup = this.selectedCohortEmailLookup;
      var hasCohortFilter = !!this.selectedCohortId;
      if (hasTeamFilter) {
        var organization = this.$store.state.main.organization || {};
        if (organization[selectedTeamScope]) {
          for (var tk in organization[selectedTeamScope]) {
            if (organization[selectedTeamScope].hasOwnProperty(tk)) teamScope[tk] = true;
          }
        }
        if (Object.keys(teamScope).length === 0) {
          teamScope[selectedTeamScope] = true;
        }
      }

      var peopleMap = {};
      var lastRiskWeek = {};

      for (var weekIdx = 0; weekIdx < masterDate.length; weekIdx++) {
        var dateStr = masterDate[weekIdx];
        var teamsForDate = allDataRisk[dateStr];
        if (!teamsForDate) continue;

        for (var teamId in teamsForDate) {
          if (!teamsForDate.hasOwnProperty(teamId)) continue;
          if (hasTeamFilter && !teamScope[teamId]) continue;
          var teamMembers = teamsForDate[teamId];
          if (!teamMembers) continue;

          for (var i = 0; i < teamMembers.length; i++) {
            var entry = teamMembers[i];
            if (!entry || !entry.email) continue;
            if (hasCohortFilter && !cohortEmailLookup[entry.email]) continue;

            var email = entry.email;
            if (!peopleMap[email]) {
              var member = memberLookup[email];
              var foundInActive = !!member;
              if (!member) {
                member = membersByKey[email.replace(/\./g, '||')] || null;
                if (member) foundInActive = true;
              }
              if (!member && archiveLookup[email]) {
                member = archiveLookup[email];
              }

              var teamRef = entry.team || (member && member.team);
              var teamName = (teamRef && teamByKey[teamRef]) ? (teamByKey[teamRef].name || '') : '';

              var displayFirstname = (member && member.firstname) || '';
              var displayLastname = (member && member.lastname) || '';
              if (!displayFirstname && !displayLastname) {
                displayFirstname = email.split('@')[0];
              }

              peopleMap[email] = {
                email: email,
                firstname: displayFirstname,
                lastname: displayLastname,
                team_name: teamName,
                risk_due: '',
                profilepic: (member && (member.profilepic_crop || member.profilepic)) || null,
                weeklyRisk: new Array(masterDate.length).fill(null),
                isArchived: !foundInActive,
              };
              lastRiskWeek[email] = -1;
            }

            var riskLevel = entry.risk_level;
            if (riskLevel !== undefined && riskLevel !== null) {
              peopleMap[email].weeklyRisk[weekIdx] = String(riskLevel);
            }

            var levelStr = String(riskLevel);
            if (this.isAtRisk(levelStr) && weekIdx > lastRiskWeek[email]) {
              lastRiskWeek[email] = weekIdx;
              if (entry.risk_due) peopleMap[email].risk_due = entry.risk_due;
            }
          }
        }
      }

      return peopleMap;
    },
    // Week-dependent: categorizes and filters people based on selected week tab
    // Use the same source as the chart for consistent tab counts
    riskDrillDownWeekCounts() {
      var chart = this.RiskAndStarChart;
      return (chart && chart.sumrisk) || [];
    },
    riskDrillDownData() {
      var peopleMap = this.riskDrillDownPeopleMap;
      var selectedIdx = this.riskDrillDownWeekIndex;

      var result = [];
      for (var email in peopleMap) {
        if (!peopleMap.hasOwnProperty(email)) continue;
        var src = peopleMap[email];

        var freq = 0;
        var atRiskInOtherWeek = false;
        for (var wk = 0; wk < src.weeklyRisk.length; wk++) {
          if (this.isAtRisk(src.weeklyRisk[wk])) {
            freq++;
            if (wk !== selectedIdx) atRiskInOtherWeek = true;
          }
        }

        var selectedLevel = src.weeklyRisk[selectedIdx];
        var atRiskThisWeek = this.isAtRisk(selectedLevel);
        var category;

        if (atRiskThisWeek && atRiskInOtherWeek) {
          category = 'recurring';
        } else if (atRiskThisWeek && !atRiskInOtherWeek) {
          category = 'first_time';
        } else if (selectedLevel === '0') {
          category = 'recovered';
        } else {
          continue;
        }

        result.push({
          email: src.email,
          firstname: src.firstname,
          lastname: src.lastname,
          team_name: src.team_name,
          risk_due: src.risk_due,
          profilepic: src.profilepic,
          weeklyRisk: src.weeklyRisk,
          isArchived: src.isArchived,
          riskFrequency: freq,
          category: category,
        });
      }

      var categoryOrder = { 'recurring': 0, 'first_time': 1, 'recovered': 2 };
      result.sort(function (a, b) {
        var catDiff = (categoryOrder[a.category] || 0) - (categoryOrder[b.category] || 0);
        if (catDiff !== 0) return catDiff;
        if (a.category === 'first_time') {
          return (parseInt(b.weeklyRisk[selectedIdx]) || 0) - (parseInt(a.weeklyRisk[selectedIdx]) || 0);
        }
        return b.riskFrequency - a.riskFrequency;
      });

      return result;
    },
    loadingDataChart() {
      return this.$store.getters["people/loadingDataChart"];
    },
    loadingDataChartFirstTime() {
      return this.$store.getters["people/loadingDataChartFirstTime"];
    },
    initialPeopleLoading() {
      return this.$store.state.people.initialLoading;
    },
    deferredPeopleLoading() {
      return this.$store.state.people.deferredLoading;
    },
    primaryMetricsLoading() {
      const talentMatrixState = this.$store.state.talentMatrix || {};
      return !!(
        this.user &&
        this.user.company &&
        talentMatrixState.primaryMetricsLoading &&
        talentMatrixState.primaryMetricsCompany === this.user.company
      );
    },
    tableScoresReady() {
      const talentMatrixState = this.$store.state.talentMatrix || {};
      return !!(
        this.user &&
        this.user.company &&
        talentMatrixState.tableScoresLoaded &&
        talentMatrixState.tableScoresCompany === this.user.company
      );
    },
    wellbeingScoresReady() {
      const talentMatrixState = this.$store.state.talentMatrix || {};
      return !!(
        this.user &&
        this.user.company &&
        talentMatrixState.who5Loaded &&
        talentMatrixState.who5ScoresCompany === this.user.company
      );
    },
    peopleDataLoadKey() {
      if (!this.user) return '';
      return [
        this.user.company || '',
        this.user.user_type || '',
        this.user.team || '',
      ].join('|');
    },
    talentGroupCountsReady() {
      return this.$store.state.people.detailLoadedCompany === this.peopleDataLoadKey;
    },
    allDataImpactTooltip() {
      return this.$store.getters["people/allDataImpactTooltip"];
    },
    alignement() {
      return this.$store.getters["people/alignement"];
    },
    recognition() {
      return this.$store.getters["people/recognition"];
    },
    truly() {
      return this.$store.getters["people/truly"];
    },
    trulyDetails() {
      return this.$store.getters["people/trulyDetails"] || {};
    },
    medals() {
      return this.$store.getters["people/medals"];
    },
    talentGroups() {
      return [
        { key: 'promotion_ready', label: 'Promotion Ready', description: 'People with strong impact and a clear pattern of exceeding expectations in manager reviews. Good for promotion or succession conversations.' },
        { key: 'atrisk_star', label: 'At-Risk Stars', description: 'High-impact people showing medium or high risk signals. They may need support to stay engaged.' },
        { key: 'invisible', label: 'Invisible Talent', description: 'High-impact, engaged people with low manager attention and low recognition or peer visibility.' },
        { key: 'culture_champ', label: 'Culture Champions', description: 'People who regularly recognize others, show strong values alignment, and stay engaged.' },
        { key: 'connector', label: 'High-Impact Connectors', description: 'Strong performers with broad cross-team networks who recognize others. They help information and trust move across teams.' },
        { key: 'silent_contrib', label: 'Silent Contributors', description: 'Good performers with limited network visibility but clear work quality or peer trust. They may need more visibility.' },
        { key: 'rising_unsupported', label: 'Rising but Unsupported', description: 'People with impact 40+ and engagement 50+, but no manager performance feedback yet. They may need a first review or coaching conversation.' },
        { key: 'disengaged', label: 'Disengaged Talent', description: 'People with low engagement but signs of capability from impact, performance, or peer trust.' },
      ];
    },
    selectedTalentGroupConfig() {
      return this.talentGroups.find(g => g.key === this.selectedTalentGroup) || { label: 'All People', description: '' };
    },
    talentGroupBasePeople() {
      const peopleState = this.$store.state.people || {};
      const people = peopleState.loadpage === false
        ? (this.starperform || [])
        : (peopleState.starperformall || []);
      return people;
    },
    filteredByTalentGroup() {
      if (this.selectedTalentGroup === 'all') return this.starperform;
      return this.talentGroupBasePeople.filter(person => this.matchesTalentGroup(person, this.selectedTalentGroup));
    },
    metricColumns() {
      return METRIC_COLUMNS;
    },
    // Final list rendered in the table. When a column header sort is active,
    // wraps `filteredByTalentGroup` with a stable comparator that pushes
    // null/empty values to the bottom regardless of direction.
    //
    // Decorate-sort-undecorate: accessors run once per row (not 2N log N
    // times). Matters for the impact-percentile column whose accessor is
    // O(N) — without this the sort is O(N² log N).
    displayedPeople() {
      const list = this.filteredByTalentGroup || [];
      if (list.length < 2 || !this.columnSort.key) return list;
      const col = METRIC_COLUMNS.find((c) => c.key === this.columnSort.key);
      if (!col) return list;
      const dir = this.columnSort.direction === "asc" ? 1 : -1;
      const decorated = list.map((person) => {
        const raw = col.accessor(this, person);
        const num = Number(raw);
        return { person, num, empty: raw == null || !Number.isFinite(num) };
      });
      decorated.sort((a, b) => {
        if (a.empty && b.empty) return 0;
        if (a.empty) return 1;
        if (b.empty) return -1;
        return (a.num - b.num) * dir;
      });
      return decorated.map((d) => d.person);
    },
    totalPeopleCount() {
      return this.talentGroupBasePeople.length;
    },
    talentGroupCounts() {
      const people = this.talentGroupBasePeople;
      const counts = {};
      this.talentGroups.forEach(g => { counts[g.key] = 0; });
      people.forEach(person => {
        this.talentGroups.forEach(g => {
          if (this.matchesTalentGroup(person, g.key)) counts[g.key]++;
        });
      });
      return counts;
    },
    isAllTeamsSelected() {
      return this.selectTeam && this.selectTeam.includes('All Teams');
    },
    percentileScopeText() {
      // No need for scoped text in All Teams view
      return this.isAllTeamsSelected 
        ? this.$t("insights.Entire_Company")
        : (this.percentileScope === "filtered" 
            ? this.$t("insights.Current_Filtered_List") 
            : this.$t("insights.Entire_Company"));
    },
    percentileScopeShortText() {
      // No need for scoped text in All Teams view
      return this.isAllTeamsSelected 
        ? this.$t("insights.Global")
        : (this.percentileScope === "filtered" 
            ? this.$t("insights.Scoped") 
            : this.$t("insights.Global"));
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    currentAvgImpactRating() {
      // Calculate current average from ALL members (for global percentile calculations)
      const allMembers = Object.values(this.membersall || {});
      const membersWithImpact = allMembers.filter(m => m && m.impact_rating && parseFloat(m.impact_rating) > 0);
      if (membersWithImpact.length === 0) return 0;
      return membersWithImpact.reduce((sum, m) => sum + parseFloat(m.impact_rating), 0) / membersWithImpact.length;
    },
    filteredAvgImpactRating() {
      // Calculate average from FILTERED members (respects team selection)
      const members = this.filteredMembersForDistribution;
      if (members.length === 0) return 0;
      return members.reduce((sum, m) => sum + parseFloat(m.impact_rating), 0) / members.length;
    },
    filteredMembersForDistribution() {
      // Check if any filter is active (team or search)
      const teamId = this.$store.state.people.team_id;
      const searchInput = this.$store.state.people.inputSearch || '';
      const isFilterActive = (teamId && (teamId.startsWith('-') || teamId.startsWith('cohort:'))) || searchInput.length > 2;
      
      // When filter is active, starperform contains ALL filtered members (not paginated)
      // When no filter, use starperformall which has all company members
      const members = isFilterActive 
        ? (this.starperform || [])
        : (this.$store.state.people.starperformall || []);
      
      // Filter to only members with valid impact ratings
      return members.filter(m => m && m.impact_rating && parseFloat(m.impact_rating) > 0);
    },
    impactDistribution() {
      // Calculate distribution from FILTERED members (respects team selection)
      const membersWithImpact = this.filteredMembersForDistribution;
      
      const ranges = [
        { label: '0-20', min: 0, max: 20, count: 0, color: '#E53935' },      // Red
        { label: '20-40', min: 20, max: 40, count: 0, color: '#FF7043' },    // Orange-Red
        { label: '40-60', min: 40, max: 60, count: 0, color: '#FBC02D' },    // Yellow
        { label: '60-80', min: 60, max: 80, count: 0, color: '#9CCC65' },    // Light Green
        { label: '80-100', min: 80, max: 100, count: 0, color: '#43A047' },  // Green
      ];
      
      membersWithImpact.forEach(member => {
        const rating = parseFloat(member.impact_rating);
        for (const range of ranges) {
          if (rating >= range.min && (rating < range.max || (range.max === 100 && rating <= 100))) {
            range.count++;
            break;
          }
        }
      });
      
      const maxCount = Math.max(...ranges.map(r => r.count), 1);
      
      return {
        ranges,
        total: membersWithImpact.length,
        maxCount
      };
    },
    // Computed property to derive all company ratings from membersall (replaces fetchAllCompanyRatings)
    allCompanyRatings() {
      const allMembers = this.membersall;
      if (!allMembers || Object.keys(allMembers).length === 0) {
        return [];
      }
      return Object.values(allMembers)
        .filter(member => member && typeof member === 'object')
        .map(member => ({
          email: member.email,
          impact_rating: parseFloat(member.impact_rating) || 0
        }))
        .filter(member => member.impact_rating > 0);
    },
  },
  data() {
    return {
      options: [
        {
          value: "All Teams",
          label: "All Teams",
        },
        {
          value: "Teams1",
          label: "Teams1",
        },
      ],
      type: "all",
      selectedTalentGroup: "all",
      checkedTalentType: [],
      disp_talentType: "All_Types",
      arrDataCheck: [],
      modalPreviewDataStatus: false,
      loadingPeopleTable: false,
      userDetail: {},
      engagementBreakdownDialogVisible: false,
      selectedEngagementPerson: null,
      // timeShowingData: "By Week",
      PowerSkillShowingData: "Impact Rating",
      modalViewListExcels: false,
      viewListExcelsDataSelected: {},
      my_risk_recovery_chart: null,
      my_impact_donut_chart: null,
      riskChartRenderFrame: null,
      searchMembersDebounceTimer: null,
      showImpactPercentile: false,
      percentileScope: "filtered", // 'filtered' or 'global'
      happinessPatterns: {}, // Store happiness patterns for each user
      loadingPatterns: {}, // Track loading state for each user's pattern
      showRiskDrillDown: false,
      archivedMemberLookup: {},
      archivedMemberLookupLoaded: false,
      riskDrillDownWeekIndex: 0,
      expandedEmails: [],
      deferredPeopleIntelligenceTimer: null,
      deferredTalentGroupCountsTimer: null,
      pendingTalentGroup: "",
      columnSort: { key: null, direction: "desc" },
      peopleInitialLoadRunId: 0,
      peopleLoadStepRunId: 0,
      peopleInitialLoadTimer: null,
    };
  },
  mounted() {
    if (this.optionsTeam.length > 0 && this.selectTeam == '') {
      this.selectTeam = this.user.user_type == 'leadership' ? this.user.team : "";
    }

    // Render charts if data is already available (e.g., navigating back to this view)
    this.$nextTick(() => {
      if (!this.loadingDataChart && !this.loadingDataChartFirstTime && this.RiskAndStarChart && Object.keys(this.RiskAndStarChart).length > 0) {
        this.renderRiskRecoveryChart();
        if (this.PowerSkillShowingData === 'Impact Rating') {
          this.renderImpactDonutChart();
        }
      }
    });
  },
  beforeDestroy() {
    if (this.searchMembersDebounceTimer) {
      window.clearTimeout(this.searchMembersDebounceTimer);
      this.searchMembersDebounceTimer = null;
    }
    if (this.deferredPeopleIntelligenceTimer) {
      window.clearTimeout(this.deferredPeopleIntelligenceTimer);
      this.deferredPeopleIntelligenceTimer = null;
    }
    if (this.deferredTalentGroupCountsTimer) {
      window.clearTimeout(this.deferredTalentGroupCountsTimer);
      this.deferredTalentGroupCountsTimer = null;
    }
    if (this.riskChartRenderFrame) {
      window.cancelAnimationFrame(this.riskChartRenderFrame);
      this.riskChartRenderFrame = null;
    }
    if (this.my_risk_recovery_chart) {
      this.my_risk_recovery_chart.destroy();
      this.my_risk_recovery_chart = null;
    }
    if (this.my_impact_donut_chart) {
      this.my_impact_donut_chart.destroy();
      this.my_impact_donut_chart = null;
    }
  },
  methods: {
    loadCohortOptions() {
      if (!this.user || !this.user.company) return;
      if (this.cohortsAll && this.cohortsAll.length > 0) return;
      this.$store.dispatch("membersCohort/getCohorts", { user: this.user }).catch((error) => {
        console.warn("[people insight] cohort options load failed", error);
      });
    },
    getCohortOptionValue(key) {
      return `cohort:${key}`;
    },
    getPeopleLoadTimestamp() {
      if (typeof performance !== "undefined" && performance.now) {
        return performance.now();
      }

      return Date.now();
    },
    getPeopleLoadDuration(startedAt) {
      const durationMs = this.getPeopleLoadTimestamp() - startedAt;

      return {
        durationMs: Number(durationMs.toFixed(1)),
        durationSeconds: Number((durationMs / 1000).toFixed(2)),
        durationMinutes: Number((durationMs / 60000).toFixed(2)),
      };
    },
    startPeopleInitialLoadTimer() {
      const runId = ++this.peopleInitialLoadRunId;
      const label = `[people insight] initial load ${runId}`;

      this.peopleInitialLoadTimer = {
        label,
        startedAt: this.getPeopleLoadTimestamp(),
        company: this.user.company,
        phases: {
          initial: false,
          primaryMetrics: false,
          charts: false,
          details: false,
        },
        failedLoads: [],
      };
    },
    markPeopleInitialLoadPhase(phase, error) {
      const timer = this.peopleInitialLoadTimer;
      if (!timer || !timer.phases || !(phase in timer.phases)) return;

      timer.phases[phase] = true;
      if (error && timer.failedLoads.indexOf(phase) === -1) {
        timer.failedLoads.push(phase);
      }

      const finished = Object.keys(timer.phases).every((key) => timer.phases[key]);
      if (!finished) return;

      this.peopleInitialLoadTimer = null;
    },
    async runPeopleTimedStep(stepName, task) {
      const timer = this.peopleInitialLoadTimer;
      const parentLabel = timer ? timer.label : "[people insight]";
      const stepLabel = `${parentLabel} ${stepName} ${++this.peopleLoadStepRunId}`;
      const startedAt = this.getPeopleLoadTimestamp();

      try {
        const result = await task();
        return result;
      } catch (error) {
        console.warn(`[people insight] ${stepName} failed`, {
          timer: stepLabel,
          ...this.getPeopleLoadDuration(startedAt),
          error,
        });
        throw error;
      }
    },
    loadInitialPeopleIntelligence() {
      if (!this.user || !this.user.company) return;

      this.startPeopleInitialLoadTimer();
      this.runPeopleTimedStep("loadPeopleIntelligenceInitial", () =>
        this.$store.dispatch("people/loadPeopleIntelligenceInitial", { user: this.user })
      )
        .then(() => {
          this.markPeopleInitialLoadPhase("initial");
          this.loadingPeopleTable = false;
          this.$nextTick(() => {
            this.scheduleDeferredPeopleIntelligence({ includeCharts: true, includeDetails: false, delay: 600 });
            const primaryMetricsPromise = this.loadPrimaryPeopleMetrics();
            // Details are lazy/on-demand — do not block the initial load timer.
            this.markPeopleInitialLoadPhase("details");

            Promise.resolve(primaryMetricsPromise).then(() => {
              this.loadFullPeoplePrimaryMetrics();
              this.scheduleDeferredPeopleIntelligence({
                includeCharts: false,
                includeDetails: true,
                delay: 1000,
              });
            });
          });
        })
        .catch((error) => {
          this.markPeopleInitialLoadPhase("initial", error);
          this.markPeopleInitialLoadPhase("primaryMetrics", error);
          this.markPeopleInitialLoadPhase("charts", error);
          this.markPeopleInitialLoadPhase("details", error);
          console.error('Failed to load People Intelligence table:', error);
          this.loadingPeopleTable = false;
        });
    },
    loadPrimaryPeopleMetrics() {
      if (!this.user || !this.user.company) return null;
      const peopleState = this.$store.state.people || {};
      const employees = peopleState.starperformall && peopleState.starperformall.length > 0
        ? peopleState.starperformall
        : (peopleState.membersall || []);
      const visibleEmployees = this.starperform || [];

      return this.runPeopleTimedStep("loadPeoplePrimaryMetrics", () =>
        this.$store.dispatch("talentMatrix/loadPeoplePrimaryMetrics", {
          user: this.user,
          employees,
          visibleEmployees,
        })
      ).then((result) => {
        this.markPeopleInitialLoadPhase("primaryMetrics");
        return result;
      }).catch((error) => {
        this.markPeopleInitialLoadPhase("primaryMetrics", error);
        console.error("Failed to load primary People Intelligence metrics:", error);
      });
    },
    loadFullPeoplePrimaryMetrics() {
      if (!this.user || !this.user.company) return null;
      const peopleState = this.$store.state.people || {};
      const employees = peopleState.starperformall && peopleState.starperformall.length > 0
        ? peopleState.starperformall
        : (peopleState.membersall || []);

      return this.$store.dispatch("talentMatrix/loadPeopleFullPrimaryMetrics", {
        user: this.user,
        employees,
      }).catch((error) => {
        console.error("Failed to load full People Intelligence metrics:", error);
      });
    },
    scheduleDeferredPeopleIntelligence(options = {}) {
      if (!this.user || !this.user.company) return;

      const includeDetails = !!options.includeDetails;
      const timerKey = includeDetails ? 'deferredTalentGroupCountsTimer' : 'deferredPeopleIntelligenceTimer';
      if (this[timerKey]) return;

      const delay = Number.isFinite(options.delay) ? options.delay : (includeDetails ? 3000 : 600);
      this[timerKey] = window.setTimeout(() => {
        this[timerKey] = null;
        this.loadDeferredPeopleIntelligence(options);
      }, delay);
    },
    loadDeferredPeopleIntelligence(options = {}) {
      if (!this.user || !this.user.company) return;

      const includeCharts = options.includeCharts !== false;
      const includeDetails = !!options.includeDetails;
      const stepName = includeDetails
        ? "loadPeopleDeferredDetails"
        : "loadPeopleDeferredCharts";

      return this.runPeopleTimedStep(stepName, () =>
        this.$store.dispatch("people/loadPeopleDeferredPanels", Object.assign({ user: this.user }, options))
      ).then((result) => {
        if (includeCharts) this.markPeopleInitialLoadPhase("charts");
        if (includeDetails) this.markPeopleInitialLoadPhase("details");
        return result;
      }).catch((error) => {
        if (includeCharts) this.markPeopleInitialLoadPhase("charts", error);
        if (includeDetails) this.markPeopleInitialLoadPhase("details", error);
          console.error('Failed to load deferred People Intelligence data:', error);
      });
    },
    handleTalentGroupClick(key) {
      if (!this.talentGroupCountsReady) {
        this.pendingTalentGroup = key;
        this.loadDeferredPeopleIntelligence({ includeCharts: false, includeDetails: true })
          .then(() => {
            if (this.pendingTalentGroup === key && this.talentGroupCountsReady) {
              this.selectedTalentGroup = this.selectedTalentGroup === key ? 'all' : key;
            }
            this.pendingTalentGroup = "";
          });
        return;
      }
      this.selectedTalentGroup = this.selectedTalentGroup === key ? 'all' : key;
    },
    talentGroupCountLabel(key) {
      if (key === 'all') return this.totalPeopleCount;
      if (!this.talentGroupCountsReady) return '...';
      return this.talentGroupCounts[key] || 0;
    },
    isPeopleDetailLoading(email) {
      const loadingByEmail = this.$store.state.people.detailLoadingByEmail || {};
      return !!loadingByEmail[email];
    },
    isPeopleDetailReady(email) {
      const detailByEmail = this.$store.state.people.detailByEmail || {};
      return !!detailByEmail[email];
    },
    isTableScoreLoading(email, key) {
      if (!email || !key) return false;
      if (this.getCompositeMetric(email, key) !== null) return false;
      if (this.tableScoresReady) return false;
      return this.initialPeopleLoading || this.primaryMetricsLoading || !this.tableScoresReady;
    },
    getWellbeingScore(email) {
      return this.getCompositeMetric(email, "computed_who5");
    },
    isWellbeingScoreLoading(email) {
      if (!email) return false;
      if (this.getWellbeingScore(email) !== null) return false;
      if (this.wellbeingScoresReady) return false;
      return this.getWellbeingScore(email) === null;
    },
    ensurePeopleDetail(email) {
      if (!email || !this.user || !this.user.company) return;
      this.$store.dispatch("people/ensurePeopleDetail", { user: this.user, email })
        .catch((error) => {
          console.error('Failed to load People Intelligence row detail:', error);
        });
    },
    metricNumber(email, key) {
      const value = this.getCompositeMetric(email, key);
      if (value === null || value === undefined || value === '') return null;
      const numberValue = Number(value);
      return Number.isFinite(numberValue) ? numberValue : null;
    },
    isLowManagerSupportSignal(person, managerResponsiveness) {
      const coinSignal = normalizeSignalCode(person && person.talent_value_coin);
      return coinSignal === '000' || coinSignal === '010' || (managerResponsiveness !== null && managerResponsiveness < 40);
    },
    matchesTalentGroup(person, group) {
      const email = person.email;
      const rec = this.recognition[email] || {};
      const align = this.alignement[email] || {};
      const trulyCount = this.truly[email] || 0;
      const impact = parseFloat(person.impact_rating) || 0;
      const health = parseFloat(person.healthbar) || 0;
      const risk = String(person.risk_level || '');
      const talent = person.talent || '';
      const network = person.network_type || '';
      const engStar = (person.engagement && person.engagement.past30days && person.engagement.past30days.star) || 0;
      const skillRating = parseFloat(align.rating_skill) || 0;
      const talentKey = normalizeGroupKey(talent);
      const networkKey = normalizeGroupKey(network);
      const engagementScore = this.metricNumber(email, 'computed_engagement');
      const managerResponsiveness = this.metricNumber(email, 'computed_manager_responsiveness');
      const receivingRecognition = this.metricNumber(email, 'computed_receiving_recognition');
      const peerTrust = this.metricNumber(email, 'computed_peer_trust');
      const receivedRecognitionCount = Number(rec.totalReceived || 0);
      const givenRecognitionCount = Number(rec.totalGiven || 0);
      const isEngaged = health >= 50 || (engagementScore !== null && engagementScore >= 50) || engStar >= 2;
      const lowManagerSupport = this.isLowManagerSupportSignal(person, managerResponsiveness);
      const lowReceivedRecognition = receivedRecognitionCount <= 1
        || (receivingRecognition !== null && receivingRecognition < 40)
        || (peerTrust !== null && peerTrust <= 2);
      const lowPeerVisibility = LIMITED_NETWORK_KEYS.has(networkKey) || (peerTrust !== null && peerTrust <= 2);

      switch (group) {
        case 'promotion_ready': {
          // Signal: consistently rated Exceeding Expectations on manager performance reviews.
          // `computed_exceeding_performance` = exceeding rate (culture=4 AND goal=4) × sqrt-
          // confidence curve from send_review_gem, null when no manager reviews exist.
          // Important: we deliberately do NOT use `computed_performance` (gem rate) because
          // gems include Meeting Expectations — fine performance, but not a promotion signal.
          // Promotion readiness requires Exceeding patterns specifically.
          const exceed = this.getCompositeMetric(person.email, 'computed_exceeding_performance');
          return exceed !== null && exceed >= 70 && impact >= 60;
        }
        case 'invisible':
          return impact >= 60
            && isEngaged
            && lowManagerSupport
            && (lowReceivedRecognition || lowPeerVisibility || UNDER_RECOGNIZED_TALENT_KEYS.has(talentKey))
            && risk !== '3';
        case 'atrisk_star':
          // "Star" = high impact (≥55, top half of most companies). "At risk" = medium/high
          // people-risk level. The previous hardcoded talent-type allowlist (Superstar /
          // High Performer / etc.) was over-specification — most real customers' talent
          // taxonomies use names like "Latent Potential", "Unsung Talent", "High Potential"
          // that weren't on the list, so the filter returned 0 even when stars-at-risk
          // clearly existed. Impact + risk_level is sufficient signal on its own.
          return impact >= 55 && (risk === '2' || risk === '3');
        case 'culture_champ':
          // valueAlignmentGiven / valueAlignmentReceived are 0-10 averages of per-recognition
          // AI ratings (see people.ts:2513-2514). The original threshold of 0.5 was a leftover
          // from a 0-1 scale; against 0-10 it admits anyone with any value alignment at all.
          // 5.0 = midpoint of the scale, which is a meaningful "strong alignment" bar.
          return givenRecognitionCount >= 3
            && ((parseFloat(rec.valueAlignmentGiven) || 0) >= 5.0 || (parseFloat(rec.valueAlignmentReceived) || 0) >= 5.0)
            && isEngaged;
        case 'silent_contrib':
          return impact >= 50
            && LIMITED_NETWORK_KEYS.has(networkKey)
            && (trulyCount >= 1 || skillRating >= 3.0);
        case 'rising_unsupported': {
          const managerPerformanceFeedback = this.getCompositeMetric(email, 'computed_performance');
          const hasNoManagerPerformanceFeedback = managerPerformanceFeedback === null || managerPerformanceFeedback === undefined;

          return impact >= 40
            && engagementScore !== null
            && engagementScore >= 50
            && hasNoManagerPerformanceFeedback;
        }
        case 'disengaged': {
          const isLowParticipation = engagementScore !== null && engagementScore < 30;
          const performanceMetric = this.getPerformanceMetric(person);
          const performanceScore = performanceMetric && performanceMetric.value !== null && performanceMetric.value !== undefined
            ? Number(performanceMetric.value)
            : null;
          const hasCapabilitySignal = impact >= 40
            || (performanceScore !== null && Number.isFinite(performanceScore) && performanceScore >= 40)
            || (peerTrust !== null && peerTrust >= 3);

          return isLowParticipation && hasCapabilitySignal;
        }
        case 'connector':
          // A connector bridges groups, so the network archetype must indicate breadth.
          // Includes "High Outer" alongside "Super Outer" — both describe strong cross-team
          // network density, which is the essence of the connector role. Previously omitted
          // "High Outer", causing people doing exactly this work to be missed.
          return impact >= 60
            && CONNECTOR_NETWORK_KEYS.has(networkKey)
            && givenRecognitionCount >= 2;
        default:
          return true;
      }
    },
    filterRisk(type) {
      if (type == "all") {
        document.getElementById("filterRisk").innerHTML = "All";
      } else if (type == "low") {
        document.getElementById("filterRisk").innerHTML = "Low Risk";
      } else if (type == "med") {
        document.getElementById("filterRisk").innerHTML = "Med Risk";
      } else if (type == "high") {
        document.getElementById("filterRisk").innerHTML = "High Risk";
      }
      this.$store.dispatch("people/filterRisk", type);
    },
    sortBy(type) {
      if (type == "highest_risk") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Highest_Risk_Level"
        );
      } else if (type == "lowest_risk") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Lowest_Risk_Level"
        );
      } else if (type == "highest_impact") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Highest_Impact_Rating"
        );
      } else if (type == "lowest_impact") {
        document.getElementById("sortBy").innerHTML = this.$t(
          "insights.Lowest_Impact_Rating"
        );
      }
      this.type = type;
      this.columnSort = { key: null, direction: "desc" };
      this.$store.dispatch("people/sortBy", {
        type: type,
        checked: this.checkedTalentType,
      });
    },
    setColumnSort(key) {
      const current = this.columnSort.key === key ? this.columnSort.direction : "none";
      const next = SORT_NEXT[current];
      this.columnSort = next == null
        ? { key: null, direction: "desc" }
        : { key, direction: next };
    },
    getImgPeopleUrl(pic) {
      var replacePic = pic.replace(/ /g, "_");
      var images = require.context(
        "../../assets/images/people/",
        false,
        /\.png$/
      );
      return images("./" + replacePic + "@2x.png");
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgStar(value){
      if(Number(value)<1.75){
        return require("@/assets/images/people/star_and_health_indicators/power_star_red@2x.png");
      }else if(Number(value)>=1.75&&Number(value)<3.5){
        return require("@/assets/images/people/star_and_health_indicators/power_star_yellow@2x.png");
      }else if(Number(value)>=3.5){
        return require("@/assets/images/people/star_and_health_indicators/power_star_green@2x.png");
      }
     
    },
    getImgHouse(name){
   
      return require("@/assets/images/people/badges_level/" + name + ".png");

    },
    handleSelectAll() {
      if (this.checkedTalentType.length !== this.talentTypeOption.length) {
        let checked = [];
        for (const i in this.talentTypeOption) {
          checked.push(this.talentTypeOption[i].type);
        }
        this.checkedTalentType = checked;
      }
    },
    dropdownTalentTypeClick() {
      if (this.arrDataCheck.length == 0) {
        let checked = [];
        for (const i in this.talentTypeOption) {
          checked.push(this.talentTypeOption[i].type);
        }
        this.checkedTalentType = checked;
        this.arrDataCheck = checked;
      }
    },
    cancelTalentType() {
      this.checkedTalentType = this.arrDataCheck;
      this.$refs.dropdownMenu.visible = false;
    },
    saveTalentType() {
      if (this.checkedTalentType.length > 0) {
        if (this.checkedTalentType.length == this.talentTypeOption.length) {
          this.disp_talentType = "All_Types";
        } else if (this.checkedTalentType.length == 1) {
          if (
            this.checkedTalentType[0] == "High Network" ||
            this.checkedTalentType[0] == "High Inner" ||
            this.checkedTalentType[0] == "High Outer" ||
            this.checkedTalentType[0] == "Low Network" ||
            this.checkedTalentType[0] == "Medium Network" ||
            this.checkedTalentType[0] == "Super Network" ||
            this.checkedTalentType[0] == "Medium Inner" ||
            this.checkedTalentType[0] == "Medium Outer" ||
            this.checkedTalentType[0] == "Super Inner" ||
            this.checkedTalentType[0] == "Super Outer"
          ) {
            this.disp_talentType = this.checkedTalentType[0].replace(/ /g, "_");
          } else {
            this.disp_talentType = this.checkedTalentType[0];
          }
        } else {
          this.disp_talentType = "Multiple_Selection";
        }
        this.arrDataCheck = this.checkedTalentType;
        this.$store.dispatch("people/searchByTalent", this.checkedTalentType);
        this.$refs.dropdownMenu.visible = false;
      }
    },
    showPreviewData(row, column, event) {
      const item = row;
      this.userDetail = {};
      if (item.introduce) this.userDetail.introduce = item.introduce;
      if (item.culture_add_percentile) this.userDetail.culture_add_percentile = item.culture_add_percentile
      this.userDetail.large_pic = item.large_pic;
      this.userDetail.firstname = item.firstname;
      this.userDetail.lastname = item.lastname;
      this.userDetail.email = item.email;
      this.userDetail.dispteam = item.team_name;
      let colorCode = item.team_color ? item.team_color.replace(/#/g, "") : "";
      this.userDetail.team_color = colorCode;
      this.userDetail.team = item.team;
      this.userDetail.boss = item.boss;
      this.userDetail.tmp_boss = item.boss;
      this.userDetail.boss_pic = item.boss_pic;
      this.userDetail.dispboss = item.boss_name;
      this.userDetail.boss_firstname = item.boss_firstname;
      this.userDetail.boss_lastname = item.boss_lastname;
      this.userDetail.language = item.language;
      this.userDetail.user_type = item.user_type;
      this.userDetail.status = item.status;
      this.userDetail.to_now = item.to_now;
      this.userDetail.streak_count = item.streak_count ? item.streak_count : 0;
      this.userDetail.super_feedback_count = item.super_feedback_count
        ? item.super_feedback_count
        : 0;
      this.userDetail.medal = item.medal ? item.medal : [];
      this.userDetail.coin = item.coin;
      this.userDetail.gem = item.gem;
      this.userDetail.house = item.house;
      this.userDetail.joined = item.joined ? item.joined : "";
      this.userDetail.joined_tooltips =
        item.joined_tooltips && item.joined_tooltips.length > 0
          ? item.joined_tooltips[0]
          : [];
      if (item.order_join) {
        let joinTotal = Object.keys(this.membersall).filter(
          (k) => this.membersall[k].order_join
        ).length;
        this.userDetail.joined_tooltips["percent"] = (
          ((joinTotal - item.order_join) / joinTotal) *
          100
        ).toFixed();
      }
      this.$store.dispatch("newmember/getDataHerepoint", item.email);
      this.$store.dispatch("people/getModalMemberData", item);
      this.modalPreviewDataStatus = true;
    },
    closedModal() {
      this.$store.commit("people/setModalMemberData", []);
      this.modalPreviewDataStatus = !this.modalPreviewDataStatus;
    },
    titleInfo(creatElement, { column, $index }) {
      return <div class="fs-12">{this.$t("insights.Name_Team_and")}</div>;
    },
    titleTalentTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <div class="fs-12">{this.$t("insights.Talent_Type")}</div>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5 ml-auto">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Talent_Type")}
              </div>
              <div>{this.$t("insights.Talent_is_classified")}</div>
              <div>
                {this.$t("insights.coins_and_gems")}{" "}
                <span class="italic">{this.$t("insights.Network")}</span>
              </div>
              <div>
                <span class="italic">{this.$t("insights.Effectiveness")}</span>.{" "}
                {this.$t("insights.Gems_are_a_measure")}{" "}
                <span class="italic">
                  {this.$t("insights.Individual_Performance")}
                </span>
                .
              </div>
              <div>
                1. <span class="fw-700">{this.$t("insights.Low")}</span>:{" "}
                {this.$t("insights.Low_frequency")}
              </div>
              <div>
                2. <span class="fw-700">{this.$t("insights.Uptake")}</span>:{" "}
                {this.$t("insights.A_recent_increase_in")}
              </div>
              <div>
                3. <span class="fw-700">{this.$t("insights.High")}</span>:{" "}
                {this.$t("insights.High_frequency")}
              </div>
              <div>
                4. <span class="fw-700">{this.$t("insights.Super")}</span>:{" "}
                {this.$t("insights.High_frequency_and_high")}
              </div>
              <div class="read-more">
                <a
                  href="https://www.notion.so/happilyai/Insights-Talent-Type-8dded941ece343968466954e585f4d7d"
                  target="_blank"
                >
                  {this.$t("insights.Read_more_here")}
                </a>
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    titleNetworkTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <span class="fs-12">{this.$t("insights.Network_Type")}</span>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Network_Type")}
              </div>
              <div>{this.$t("insights.Talent_is_classified_by")}</div>
              <div>{this.$t("insights.connections_as_determined")}</div>
              <div>{this.$t("insights.recognition_and_peer")}:</div>
              <div>
                1. <span class="fw-700">{this.$t("insights.Low_Network")}</span>
                : {this.$t("insights.Low_inner_and_outer")}
              </div>
              <div>
                2. <span class="fw-700">{this.$t("insights.High_Inner")}</span>:{" "}
                {this.$t("insights.High_Inner_but_low")}
              </div>
              <div>
                3. <span class="fw-700">{this.$t("insights.High_Outer")}</span>:{" "}
                {this.$t("insights.Low_inner_but_high")}
              </div>
              <div>...</div>
              <div>
                9.{" "}
                <span class="fw-700">{this.$t("insights.High_Network")}</span>:{" "}
                {this.$t("insights.High_Network")}
              </div>
              <div class="read-more">
                <a
                  href="https://www.notion.so/happilyai/Insights-Network-Type-dfde58f252fa4079aca2aed3a4ba7e4e"
                  target="_blank"
                >
                  {this.$t("insights.Read_more_here")}
                </a>
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    titleAchievementsTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <div class="fs-12">{this.$t("insights.Achievements")}</div>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5" style="width: 350px">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Achievements")}
              </div>
              <div>{this.$t("insights.Highlighting_key_accomplishments")}:</div>
              <div>
                -{" "}
                <span class="fw-700">
                  {this.$t("insights.Engagement_Group")}
                </span>
                : {this.$t("insights.Highly_Moderately_Somewhat_Under")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.Medals")}</span>:{" "}
                {this.$t("insights.Recognized_with_a_Leadership")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">
                  {this.$t("insights.Truly_Outstanding")}
                </span>
                : {this.$t("insights.Recognized_as_Truly_Outstanding")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">{this.$t("insights.Star_Performer")}</span>
                : {this.$t("insights.A_star_is_earned")}
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    titleImpactRatingTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <div class="fs-12">{this.$t("insights.Impact_Rating")}</div>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5" style="width: 350px">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Impact_Rating")}
              </div>
              <div>{this.$t("insights.A_score_that_represents")}:</div>
              <div>
                - <span class="fw-700">{this.$t("insights.Talent_Type")}</span>:{" "}
                {this.$t("insights.Based_on_manager_and")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.Network_Type")}</span>
                : {this.$t("insights.Based_on_connections_created")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">
                  {this.$t("insights.Engagement_Group")}
                </span>
                : {this.$t("insights.Based_on_the_quality_and")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.Medals")}</span>:{" "}
                {this.$t("insights.Medals_received_in_the")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">
                  {this.$t("insights.Truly_Outstanding")}
                </span>
                : {this.$t("insights.Truly_Outstanding_ratings")}
              </div>
              <div>
                -{" "}
                <span class="fw-700">{this.$t("insights.Star_Performer")}</span>
                : {this.$t("insights.Number_of_weeks_qualified")}
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    titleRiskLevelTooltip(creatElement, { column, $index }) {
      return (
        <div class="flex-center">
          <div class="fs-12">{this.$t("insights.Risk_Level")}</div>
          <el-tooltip
            class="header-table-tooltip"
            placement="top"
            effect="light"
          >
            <div slot="content" class="p-5" style="width: 350px;">
              <div class="fs-14 fw-700 pb-8">
                {this.$t("insights.Risk_Level")}
              </div>
              <div>{this.$t("insights.Talent_that_are_retention")}</div>
              <div>{this.$t("insights.of_Not_Great_and")}</div>
              <div>{this.$t("insights.you_feeling_today")}</div>
              <div>
                - <span class="fw-700">{this.$t("insights.Low")}</span>:{" "}
                {this.$t("insights.Twice_last_week")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.Medium")}</span>:{" "}
                {this.$t("insights.More_than_twice")}
              </div>
              <div>
                - <span class="fw-700">{this.$t("insights.High")}</span>:{" "}
                {this.$t("insights.More_than_twice_last_and")}
              </div>
            </div>
            <img
              src={this.$utils("icons", "ic_help_outline-16px")}
              class="ml-4 cursor-pointer"
              alt="icons_ic_help_outline-16px"
            />
          </el-tooltip>
        </div>
      );
    },
    renderRiskRecoveryChart() {
      if (this.my_risk_recovery_chart) {
        this.my_risk_recovery_chart.destroy();
        this.my_risk_recovery_chart = null;
      }

      let chart = this.$refs.riskAndRecoveryChart;
      if (chart) {
        var ctx = chart.getContext("2d");
        const data = {
          labels: this.labelDate,
          datasets: [
            // Recovery (green) - shown as separate bars above the risk
            {
              data: this.RiskAndStarChart.recovery || [],
              backgroundColor: "#35D077",
              label: "Recovery",
              borderWidth: 0,
              type: "bar",
              stack: "Stack 1",
              recovery: this.RiskAndStarChart.recovery,
              lowrisk: this.RiskAndStarChart.lowrisk,
              medrisk: this.RiskAndStarChart.medrisk,
              highrisk: this.RiskAndStarChart.highrisk,
              datalabels: {
                color: "#35D077",
                anchor: "end",
                align: "end",
                clamp: true,
                offset: 0,
                formatter: function (value) {
                  return value > 0 ? value : '';
                },
              },
            },
            // High risk (darkest red)
            {
              data: this.RiskAndStarChart.highrisk || [],
              backgroundColor: "#900505",
              label: "High",
              borderWidth: 0,
              type: "bar",
              stack: "Stack 0",
              recovery: this.RiskAndStarChart.recovery,
              lowrisk: this.RiskAndStarChart.lowrisk,
              medrisk: this.RiskAndStarChart.medrisk,
              highrisk: this.RiskAndStarChart.highrisk,
              datalabels: {
                display: false,
              },
            },
            // Medium risk
            {
              data: this.RiskAndStarChart.medrisk || [],
              backgroundColor: "#C41919",
              label: "Medium",
              borderWidth: 0,
              type: "bar",
              stack: "Stack 0",
              recovery: this.RiskAndStarChart.recovery,
              lowrisk: this.RiskAndStarChart.lowrisk,
              medrisk: this.RiskAndStarChart.medrisk,
              highrisk: this.RiskAndStarChart.highrisk,
              datalabels: {
                display: false,
              },
            },
            // Low risk (lightest red)
            {
              data: this.RiskAndStarChart.lowrisk || [],
              sumData: this.RiskAndStarChart.sumrisk || [],
              backgroundColor: "#E21A1A",
              label: "Low",
              borderWidth: 0,
              type: "bar",
              stack: "Stack 0",
              recovery: this.RiskAndStarChart.recovery,
              lowrisk: this.RiskAndStarChart.lowrisk,
              medrisk: this.RiskAndStarChart.medrisk,
              highrisk: this.RiskAndStarChart.highrisk,
              datalabels: {
                color: "#F44336",
                anchor: "end",
                align: "end",
                clamp: true,
                offset: 0,
                formatter: function (value, context) {
                  const sum = context.dataset.sumData[context.dataIndex];
                  return sum > 0 ? sum : '';
                },
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        const getOrCreateTooltip = (chart) => {
          let tooltipEl = chart.canvas.parentNode.querySelector("div");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.style.background = "rgba(0, 0, 0, 0.7)";
            tooltipEl.style.borderRadius = "3px";
            tooltipEl.style.color = "white";
            tooltipEl.style.opacity = 1;
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.transform = "translate(-50%, 0)";
            tooltipEl.style.transition = "all .1s ease";

            const table = document.createElement("table");
            table.style.margin = "0px";

            tooltipEl.appendChild(table);
            chart.canvas.parentNode.appendChild(tooltipEl);
          }

          return tooltipEl;
        };

        const addCommasInNumber = (value) => {
          if (value === undefined || value === null) {
            return "0";
          }
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };

        const externalTooltipHandler = (context) => {
          const { chart, tooltip } = context;
          const tooltipEl = getOrCreateTooltip(chart);

          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          if (tooltip.body) {
            const bodyLines = tooltip.body.map((b) => b.lines);
            const tableHead = document.createElement("thead");
            const tableBody = document.createElement("tbody");
            bodyLines.forEach((body, i) => {
              const dataPoints = tooltip.dataPoints[i];
              const span = `<div class="container-tooltip" style="z-index: 99">
                  <div style="position: relative; width: 140px;">
                    <div style="font-size: 11px; font-weight: 700;">
                      ${dataPoints.label}
                    </div>
                    <div style="display: flex; align-items: center; font-size: 11px; margin-top: 2px;">
                      <div style="width: 14px; height: 12px; background-color: #35D077; margin-right: 6px;"></div>
                      <div>Recovery: ${addCommasInNumber(
                        dataPoints.dataset.recovery ? dataPoints.dataset.recovery[dataPoints.dataIndex] : 0
                      )}</div>
                    </div>
                    <div style="display: flex; align-items: center; font-size: 11px; margin-top: 2px;">
                      <div style="width: 14px; height: 12px; background-color: #e21a1a; margin-right: 6px;"></div>
                      <div>Low Risk: ${addCommasInNumber(
                        dataPoints.dataset.lowrisk ? dataPoints.dataset.lowrisk[dataPoints.dataIndex] : 0
                      )}</div>
                    </div>
                    <div style="display: flex; align-items: center; font-size: 11px; margin-top: 2px;">
                      <div style="width: 14px; height: 12px; background-color: #c41919; margin-right: 6px;"></div>
                      <div>Medium Risk: ${addCommasInNumber(
                        dataPoints.dataset.medrisk ? dataPoints.dataset.medrisk[dataPoints.dataIndex] : 0
                      )}</div>
                    </div>
                    <div style="display: flex; align-items: center; font-size: 11px; margin-top: 2px;">
                      <div style="width: 14px; height: 12px; background-color: #900505; margin-right: 6px;"></div>
                      <div>High Risk: ${addCommasInNumber(
                        dataPoints.dataset.highrisk ? dataPoints.dataset.highrisk[dataPoints.dataIndex] : 0
                      )}</div>
                    </div>
                    <div style="position: absolute; bottom: -17.5px; left: 48%;">
                      <div style="border: 5px solid #000; border-color: #000000ae transparent transparent; width: 0px; height: 0px;"></div>
                    </div>
                  </div>
                </div>`;
              tableBody.innerHTML = span;
            });

            const tableRoot = tooltipEl.querySelector("table");

            while (tableRoot.firstChild) {
              tableRoot.firstChild.remove();
            }

            tableRoot.appendChild(tableHead);
            tableRoot.appendChild(tableBody);
          }

          const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltip.caretX + "px";
          tooltipEl.style.top = positionY + tooltip.caretY + -56 + "px";
          tooltipEl.style.font = tooltip.options.bodyFont.string;
          tooltipEl.style.padding =
            tooltip.options.padding + "px " + tooltip.options.padding + "px";
        };
        // Calculate dynamic y-axis max based on data
        const recoveryData = this.RiskAndStarChart.recovery || [];
        const riskSumData = this.RiskAndStarChart.sumrisk || [];
        const maxRecovery = Math.max(...recoveryData, 0);
        const maxRisk = Math.max(...riskSumData, 0);
        const overallMax = Math.max(maxRecovery, maxRisk);
        // Add 20% padding and round to nice number
        const yAxisMax = Math.ceil((overallMax * 1.2) / 10) * 10;
        const stepSize = yAxisMax <= 50 ? 10 : yAxisMax <= 100 ? 20 : 25;
        
        options.layout = {
          padding: {
            left: 0,
            right: 33,
          },
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.4,
            borderRadius: 4,
          },
        };
        options.scales = {
          y: {
            stacked: true,
            suggestedMax: yAxisMax > 0 ? yAxisMax : 50,
            min: 0,
            ticks: {
              stepSize: stepSize,
              display: true,
              font: {
                size: 10,
              },
              color: 'rgba(0, 0, 0, 0.5)',
            },
            grid: {
              display: true,
              color: 'rgba(0, 0, 0, 0.06)',
              drawBorder: false,
            },
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              font: {
                size: 10,
              },
              color: 'rgba(0, 0, 0, 0.5)',
            },
          },
        };
        options.interaction = {
          intersect: false,
          mode: "nearest",
          axis: "xy",
        };
        options.plugins.tooltip = {
          enabled: false,
          position: "average",
          intersect: false,
          external: externalTooltipHandler,
        };
        options.plugins.datalabels = {
          font: {
            weight: "bold",
            size: 10,
          },
        };
        const vm = this;
        options.onClick = async function (event, elements, chart) {
          if (elements.length > 0) {
            var weekIndex = elements[0].index;
            vm.riskDrillDownWeekIndex = weekIndex;
            await vm.loadArchivedMemberLookup();
            vm.showRiskDrillDown = true;
          }
        };
        options.onHover = function (event, elements) {
          event.native.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
        };
        if (this.riskChartRenderFrame) {
          window.cancelAnimationFrame(this.riskChartRenderFrame);
        }
        this.riskChartRenderFrame = window.requestAnimationFrame(() => {
          this.my_risk_recovery_chart = new Chart(ctx, {
            type: "bar",
            data: data,
            options: options,
            plugins: [ChartDataLabels],
          });
          this.riskChartRenderFrame = null;
        });
      }
    },
    renderImpactDonutChart() {
      const canvas = this.$refs.impactDonutChart;
      if (!canvas) return;
      
      // Destroy existing chart
      if (this.my_impact_donut_chart) {
        this.my_impact_donut_chart.destroy();
      }
      
      const ctx = canvas.getContext("2d");
      const distribution = this.impactDistribution;
      
      const data = {
        labels: distribution.ranges.map(r => r.label),
        datasets: [{
          data: distribution.ranges.map(r => r.count),
          backgroundColor: distribution.ranges.map(r => r.color),
          borderColor: '#fff',
          borderWidth: 2,
          hoverBorderWidth: 3,
          hoverOffset: 4,
        }]
      };
      
      // External tooltip handler for proper z-index above center text
      const getOrCreateTooltip = (chart) => {
        let tooltipEl = chart.canvas.parentNode.querySelector('.donut-tooltip');
        if (!tooltipEl) {
          tooltipEl = document.createElement('div');
          tooltipEl.className = 'donut-tooltip';
          tooltipEl.style.background = 'rgba(0, 0, 0, 0.85)';
          tooltipEl.style.borderRadius = '8px';
          tooltipEl.style.color = 'white';
          tooltipEl.style.opacity = '0';
          tooltipEl.style.pointerEvents = 'none';
          tooltipEl.style.position = 'absolute';
          tooltipEl.style.transform = 'translate(-50%, -100%)';
          tooltipEl.style.transition = 'opacity 0.15s ease';
          tooltipEl.style.padding = '10px 14px';
          tooltipEl.style.fontSize = '12px';
          tooltipEl.style.zIndex = '100';
          tooltipEl.style.whiteSpace = 'nowrap';
          tooltipEl.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
          chart.canvas.parentNode.appendChild(tooltipEl);
        }
        return tooltipEl;
      };

      const externalTooltipHandler = (context) => {
        const { chart, tooltip } = context;
        const tooltipEl = getOrCreateTooltip(chart);

        if (tooltip.opacity === 0) {
          tooltipEl.style.opacity = '0';
          return;
        }

        if (tooltip.body) {
          const dataIndex = tooltip.dataPoints[0].dataIndex;
          const range = distribution.ranges[dataIndex];
          const count = range.count;
          const percentage = distribution.total > 0 ? Math.round((count / distribution.total) * 100) : 0;
          
          tooltipEl.innerHTML = `
            <div style="font-weight: 700; margin-bottom: 6px;">Impact Rating: ${range.label}</div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <span style="width: 10px; height: 10px; background: ${range.color}; border-radius: 2px; display: inline-block;"></span>
              <span>${count} ${count === 1 ? 'person' : 'people'}</span>
            </div>
            <div style="opacity: 0.8; margin-top: 4px;">${percentage}% of total</div>
          `;
        }

        const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
        tooltipEl.style.opacity = '1';
        tooltipEl.style.left = positionX + tooltip.caretX + 'px';
        tooltipEl.style.top = positionY + tooltip.caretY - 10 + 'px';
      };

      const options = {
        responsive: true,
        maintainAspectRatio: true,
        cutout: '65%',
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
            external: externalTooltipHandler,
          },
          datalabels: {
            display: false,
          }
        },
        animation: {
          animateRotate: true,
          animateScale: false,
          duration: 600,
        },
      };
      
      this.my_impact_donut_chart = new Chart(ctx, {
        type: 'doughnut',
        data: data,
        options: options,
      });
    },
    setBarWidth(value, max) {
      let percentage = (value / max) * 100;
      return (234 / 100) * percentage;
    },
    setBarExcelsWidth(percentage) {
      return (80 * percentage) / 100 || "0";
    },
    handlePowerPick(command) {
      this.PowerSkillShowingData = command;
    },
    getBarHeight(count, maxCount) {
      // Calculate bar height proportionally
      if (count === 0) return 8;
      const minHeight = 16;
      const maxHeight = 90;
      const calculatedHeight = (count / maxCount) * maxHeight;
      return Math.max(minHeight, Math.round(calculatedHeight));
    },
    getPercentage(count, total) {
      if (total === 0) return 0;
      return Math.round((count / total) * 100);
    },
    healthBarColor(value) {
      if (value < 25) {
        return "#B40303";
      } else if (value < 50) {
        return "#F44336";
      } else if (value < 75) {
        return "#FBC02D";
      } else {
        return "#66BB6A";
      }
    },
    talentAndNetworkTagsStyle(value) {
      if (value == "Low Network" || value == "Latent Potential") {
        return "tag-red";
      } else if (
        value == "Medium Inner" ||
        value == "Medium Outer" ||
        value == "Medium Network" ||
        value == "Up-and-coming" ||
        value == "Contributor" ||
        value == "Community Pillar" ||
        value == "Rising Star" ||
        value == "Crowd Favorite"
      ) {
        return "tag-half-red";
      } else if (
        value == "High Outer" ||
        value == "High Inner" ||
        value == "Untapped Potential" ||
        value == "Engaged Contributor" ||
        value == "Emerging Talent" ||
        value == "Valued Contributor" ||
        value == "Key Player" ||
        value == "High Potential" ||
        value == "Unsung Talent"
      ) {
        return "tag-orange";
      } else if (
        value == "Super Outer" ||
        value == "High Network" ||
        value == "Super Inner" ||
        value == "Activated" ||
        value == "Core Player" ||
        value == "High Performer"
      ) {
        return "tag-half-green";
      } else if (
        value == "Super Outer" ||
        value == "Superstar" ||
        value == "High Performer" ||
        value == "Respected Expert" ||
        value == "Distinguished Talent" ||
        value == "Solid Performer"
      ) {
        return "tag-green";
      }
      return "tag-green";
    },
    viewListClick(id) {
      this.modalViewListExcels = true;
      this.viewListExcelsDataSelected = this.viewListExcelsData[id];
    },
    statusOfImpact(value) {

      switch (value) {
        case "a":
          return `<span class="fc-F22F3C fw-900">LOW </span>`;
        case "b":
          return `<span class="fc-C69312 fw-900">OKAY </span>`;
        case "c":
          return `<span class="fc-27BC6C fw-900">GREAT </span>`;
        case "d":
          return `<span class="fc-27BC6C fw-900">EXCELLENT </span>`;
      }
      return ``;
    },
    toolTipClass(value) {
      switch (value) {
        case "a":
          return "color: #F22F3C;";
        case "b":
          return "color: #C69312;";
        case "c":
          return "color: #27BC6C;";
        case "d":
          return "color: #27BC6C;";
      }
    },
    getStrokeColor(value) {
      if (value >= 80) {
        return "#66BB6A";
      } else if (value >= 51 && value <= 79) {
        return "#FBC02D";
      } else {
        return "#F44336";
      }
    },
    // Score band for 0-100 metrics where higher = better.
    // 5-bucket scheme aligned to the Impact Rating distribution donut so the
    // table reads with one color language across every score column AND
    // matches the chart slice for the same value:
    //   80+ excellent (vivid green) · 60-79 high (light green) ·
    //   40-59 yellow · 20-39 orange · 1-19 low (red) · 0 zero · null empty.
    getScoreBand(value) {
      if (value === null || value === undefined || isNaN(value)) return "empty";
      const v = Number(value);
      if (v >= 80) return "excellent";
      if (v >= 60) return "high";
      if (v >= 40) return "yellow";
      if (v >= 20) return "orange";
      if (v >= 1) return "low";
      return "zero";
    },
    // Inverted score band for metrics where high = bad (e.g. flight risk).
    // Returns the COLOR-semantic band name so the same score-chip classes apply:
    //   high flight risk -> "low" chip (red)
    //   low  flight risk -> "high" chip (green)
    getInvertedScoreBand(value) {
      if (value === null || value === undefined || isNaN(value)) return "empty";
      const v = Number(value);
      if (v >= 60) return "low";         // high flight risk -> red chip
      if (v >= 30) return "moderate";    // moderate -> yellow chip
      return "high";                      // 0-29 = safe -> green chip
    },
    flightRiskLabel(value) {
      if (value === null || value === undefined || isNaN(value)) return "";
      const v = Number(value);
      if (v >= FLIGHT_RISK_AT_RISK) return this.$t("insights.Flight_Risk_At_risk");
      if (v >= FLIGHT_RISK_WATCH) return this.$t("insights.Flight_Risk_Watch");
      return this.$t("insights.Flight_Risk_Safe");
    },
    getFlightRiskSegment(value) {
      if (value === null || value === undefined || isNaN(value)) return "safe";
      const v = Number(value);
      if (v >= FLIGHT_RISK_AT_RISK) return "atrisk";
      if (v >= FLIGHT_RISK_WATCH) return "watch";
      return "safe";
    },
    recognitionTierMeta(tag) {
      if (tag === "Truly") {
        return { slug: "truly", label: this.$t("insights.Truly_Outstanding") };
      }
      return { slug: "exceeding", label: this.$t("insights.Exceeding_Expectations") };
    },
    // Recognition band label for median-normalized 0-100 indices (Giving /
    // Receiving). Translates the score into a plain-English position vs. the
    // team median, since a progress-bar reading of "85%" would misread the
    // index. Threshold table follows the existing score-band cutoffs.
    getRecognitionBandLabel(value) {
      if (value === null || value === undefined || isNaN(value)) return "";
      const v = Number(value);
      if (v >= 85) return this.$t("insights.Band_top_quartile");
      if (v >= 70) return this.$t("insights.Band_above_median");
      if (v >= 40) return this.$t("insights.Band_typical");
      return this.$t("insights.Band_below_typical");
    },
    // Plain-language band label for positive 0-100 metrics. Used as the chip
    // caption in place of technical labels like "DEBI" or "Gem rate". Mirrors
    // the 5-band thresholds in getScoreBand so caption and color always
    // resolve from the same boundaries.
    scoreBandLabel(value) {
      if (value === null || value === undefined || isNaN(value)) return "";
      const v = Number(value);
      if (v >= 80) return this.$t("insights.Band_Excellent");
      if (v >= 60) return this.$t("insights.Band_Good");
      if (v >= 40) return this.$t("insights.Band_Fair");
      if (v >= 20) return this.$t("insights.Band_Watch");
      return this.$t("insights.Band_Poor");
    },
    // Read a composite metric (e.g. computed_engagement, computed_trust) for the given email.
    // Composite scores live in the talentMatrix store, populated by loadCompositeScores.
    getCompositeMetric(email, key) {
      if (!email) return null;
      const scores = this.$store.state.talentMatrix && this.$store.state.talentMatrix.compositeScores;
      if (!scores || !scores[email]) return null;
      const value = scores[email][key];
      return value === undefined ? null : value;
    },
    getEngagementScoreActionLabel(person) {
      const first = person && person.firstname ? person.firstname : "";
      const last = person && person.lastname ? person.lastname : "";
      const name = `${first} ${last}`.trim() || (person && person.email) || "this person";
      return `View engagement score breakdown for ${name}`;
    },
    openEngagementScoreModal(person) {
      this.selectedEngagementPerson = person || null;
      this.engagementBreakdownDialogVisible = true;
    },
    clearEngagementScoreModal() {
      this.selectedEngagementPerson = null;
    },
    getSelectedEngagementEmail() {
      return this.selectedEngagementPerson && this.selectedEngagementPerson.email
        ? this.selectedEngagementPerson.email
        : "";
    },
    getSelectedEngagementScore() {
      const email = this.getSelectedEngagementEmail();
      return email ? this.getCompositeMetric(email, "computed_engagement") : null;
    },
    getSelectedEngagementSourceLabel() {
      const email = this.getSelectedEngagementEmail();
      return email ? this.getEngagementScoreSourceLabel(email) : "Score source unavailable";
    },
    getSelectedEngagementPeriod() {
      const email = this.getSelectedEngagementEmail();
      return email ? this.getEngagementScorePeriodText(email) : "";
    },
    getSelectedEngagementRows() {
      const email = this.getSelectedEngagementEmail();
      return email ? this.getEngagementScoreBreakdownRows(email) : [];
    },
    getSelectedEngagementFullCreditSummary() {
      const rows = this.getSelectedEngagementRows();
      if (!rows.length) return "Breakdown pending";
      const healthyRows = rows.filter((row) => row.statusTone === "good" || row.statusTone === "near").length;
      const signalLabel = rows.length === 1 ? "signal" : "signals";
      return `${healthyRows} of ${rows.length} healthy ${signalLabel}`;
    },
    getSelectedEngagementFocusText() {
      const rows = this.getSelectedEngagementRows();
      if (!rows.length) return "";
      const toneRank = { empty: 0, low: 1, watch: 2, near: 3, good: 4 };
      const lowest = rows.reduce((current, row) => {
        const currentRank = toneRank[current.statusTone] === undefined ? 0 : toneRank[current.statusTone];
        const rowRank = toneRank[row.statusTone] === undefined ? 0 : toneRank[row.statusTone];
        if (rowRank < currentRank) return row;
        if (rowRank === currentRank && row.barPercent < current.barPercent) return row;
        return current;
      }, rows[0]);
      if (lowest.statusTone === "good") {
        return "Signals look healthy";
      }
      if (lowest.statusTone === "near") {
        return `Closest target: ${lowest.label}`;
      }
      if (lowest.statusTone === "empty") {
        return `Needs signal: ${lowest.label}`;
      }
      return `Focus: ${lowest.label}`;
    },
    getEngagementScoreSourceLabel(email) {
      const source = this.getCompositeMetric(email, "computed_engagement_source");
      const score = this.getCompositeMetric(email, "computed_engagement");
      if (source === "debi") {
        return "DEBI-aligned daily index";
      }
      if (source === "monthly") {
        return "Monthly engagement proxy";
      }
      if (score !== null) {
        return "Legacy score source";
      }
      return "Score source unavailable";
    },
    getEngagementScorePeriodText(email) {
      const period = this.getCompositeMetric(email, "computed_engagement_period");
      return period ? this.formatEngagementPeriod(period) : "";
    },
    parseEngagementDate(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || "").trim());
      if (!match) return null;
      return {
        year: Number(match[1]),
        monthIndex: Number(match[2]) - 1,
        day: Number(match[3]),
      };
    },
    formatEngagementPeriod(period) {
      const parts = String(period || "").split(/\s+to\s+/i);
      if (parts.length !== 2) return period;
      const start = this.parseEngagementDate(parts[0]);
      const end = this.parseEngagementDate(parts[1]);
      if (!start || !end) return period;
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      if (start.year === end.year && start.monthIndex === end.monthIndex) {
        return `${months[start.monthIndex]} ${start.day} - ${end.day}, ${end.year}`;
      }
      if (start.year === end.year) {
        return `${months[start.monthIndex]} ${start.day} - ${months[end.monthIndex]} ${end.day}, ${end.year}`;
      }
      return `${months[start.monthIndex]} ${start.day}, ${start.year} - ${months[end.monthIndex]} ${end.day}, ${end.year}`;
    },
    getEngagementComponentLabel(type) {
      const labels = {
        DPSRRS: "Pulse response",
        OFRS: "Open feedback rate",
        OFES: "Open feedback effort",
        RPRS: "Recognition participation",
        VAS: "Values alignment",
      };
      return labels[type] || type;
    },
    formatEngagementBreakdownNumber(value) {
      if (value === null || value === undefined || isNaN(value)) return "Not available";
      const rounded = Math.round(Number(value) * 10) / 10;
      return Math.abs(rounded - Math.round(rounded)) < 0.05
        ? String(Math.round(rounded))
        : rounded.toFixed(1);
    },
    formatEngagementPercent(value) {
      if (value === null || value === undefined || isNaN(value)) return "Not available";
      return String(Math.round(Number(value)));
    },
    pluralizeEngagementUnit(value, singular, plural) {
      return Number(value) === 1 ? singular : (plural || `${singular}s`);
    },
    getEngagementDenominatorLabel(source) {
      if (source === "OFRS.answer") return "open feedback given";
      if (source === "RPRS.answer") return "recognition given";
      return "available opportunities";
    },
    getEngagementComponentDetail(item) {
      const answer = this.formatEngagementBreakdownNumber(item.answer);
      const denominator = this.formatEngagementBreakdownNumber(item.denominator);

      if (item.rate === null) {
        return "No recent activity for this signal";
      }

      if (item.type === "DPSRRS") {
        return `${answer} of ${denominator} ${this.pluralizeEngagementUnit(item.denominator, "pulse opportunity", "pulse opportunities")}`;
      }
      if (item.type === "OFRS") {
        return `${answer} of ${denominator} ${this.pluralizeEngagementUnit(item.denominator, "open-feedback opportunity", "open-feedback opportunities")}`;
      }
      if (item.type === "OFES") {
        return `${answer} of ${denominator} ${this.pluralizeEngagementUnit(item.denominator, "feedback answer", "feedback answers")} showed enough detail`;
      }
      if (item.type === "RPRS") {
        return `${answer} ${this.pluralizeEngagementUnit(item.answer, "recognition")} sent; target ${denominator}`;
      }
      if (item.type === "VAS") {
        return `${answer} of ${denominator} ${this.pluralizeEngagementUnit(item.denominator, "recognition")} tied to values`;
      }

      const denominatorLabel = this.getEngagementDenominatorLabel(item.denominatorSource);
      return `${answer} of ${denominator} ${denominatorLabel}`;
    },
    getEngagementSignalStatus(item, rate, target, progress) {
      if (rate === null || !isFinite(rate)) {
        return {
          label: "No signal",
          statusClass: "is-empty",
          tone: "empty",
        };
      }

      if (target && target > 0 && rate >= target) {
        if (item.type === "RPRS") {
          return { label: "Active", statusClass: "is-full", tone: "good" };
        }
        if (item.type === "VAS") {
          return { label: "Aligned", statusClass: "is-full", tone: "good" };
        }
        return { label: "Met", statusClass: "is-full", tone: "good" };
      }

      if (item.type === "OFES") {
        if (rate >= 90) return { label: "Strong", statusClass: "is-full", tone: "good" };
        if (rate >= 75) return { label: "Healthy", statusClass: "is-near", tone: "near" };
        if (rate > 0) return { label: "Light", statusClass: "is-watch", tone: "watch" };
        return { label: "No signal", statusClass: "is-empty", tone: "empty" };
      }

      if (item.type === "OFRS") {
        if (progress >= 90) return { label: "Near", statusClass: "is-near", tone: "near" };
        if (rate >= 50) return { label: "Some", statusClass: "is-watch", tone: "watch" };
        if (rate > 0) return { label: "Light", statusClass: "is-low", tone: "low" };
        return { label: "None yet", statusClass: "is-empty", tone: "empty" };
      }

      if (item.type === "DPSRRS") {
        if (rate >= 90) return { label: "Strong", statusClass: "is-near", tone: "near" };
        if (rate >= 70) return { label: "Some missed", statusClass: "is-watch", tone: "watch" };
        if (rate > 0) return { label: "Low", statusClass: "is-low", tone: "low" };
        return { label: "None yet", statusClass: "is-empty", tone: "empty" };
      }

      if (item.type === "RPRS") {
        if (rate >= 70) return { label: "Active", statusClass: "is-near", tone: "near" };
        if (rate > 0) return { label: "Light", statusClass: "is-watch", tone: "watch" };
        return { label: "None yet", statusClass: "is-empty", tone: "empty" };
      }

      if (item.type === "VAS") {
        if (rate >= 60) return { label: "Some alignment", statusClass: "is-near", tone: "near" };
        if (rate > 0) return { label: "Low", statusClass: "is-watch", tone: "watch" };
        return { label: "No signal", statusClass: "is-empty", tone: "empty" };
      }

      if (progress >= 90) return { label: "Near target", statusClass: "is-near", tone: "near" };
      if (progress > 0) return { label: "Some signal", statusClass: "is-watch", tone: "watch" };
      return { label: "Not measured", statusClass: "is-empty", tone: "empty" };
    },
    getEngagementScoreBreakdownRows(email) {
      const breakdown = this.getCompositeMetric(email, "computed_engagement_breakdown");
      if (!breakdown || !Array.isArray(breakdown.components)) return [];

      return breakdown.components.map((item) => {
        const rate = item.rate === null || item.rate === undefined ? null : Number(item.rate);
        const target = item.cap === null || item.cap === undefined ? null : Number(item.cap);
        const barPercent = rate !== null && isFinite(rate) && target && target > 0
          ? Math.min(Math.max((rate / target) * 100, 0), 100)
          : 0;
        const targetLabel = target && target < 100
          ? `Full at ${this.formatEngagementPercent(target)}%`
          : "";
        const rateIsEmpty = rate === null || !isFinite(rate);
        const rateValue = rateIsEmpty
          ? "No data"
          : `${this.formatEngagementPercent(rate)}%`;
        const status = this.getEngagementSignalStatus(item, rate, target, barPercent);

        return {
          key: item.type,
          label: this.getEngagementComponentLabel(item.type),
          barPercent,
          detail: this.getEngagementComponentDetail(item),
          rateValue,
          rateTone: rateIsEmpty ? "empty" : "measured",
          targetLabel,
          statusLabel: status.label,
          statusClass: status.statusClass,
          statusTone: status.tone,
        };
      });
    },
    getManagerAssignmentEmail(person) {
      if (!person) return "";
      if (typeof person.boss === "string" && person.boss.trim()) {
        return person.boss.trim();
      }
      if (person.boss && typeof person.boss === "object" && person.boss.email) {
        return String(person.boss.email).trim();
      }
      if (!person.email) return "";
      const allUsersByKey = (this.$store.state.main && this.$store.state.main.allUser) || {};
      const userRecord = allUsersByKey[person.email.replace(/\./g, "||")];
      return userRecord && typeof userRecord.boss === "string" ? userRecord.boss.trim() : "";
    },
    hasManagerAssignment(person) {
      return !!this.getManagerAssignmentEmail(person);
    },
    // Read KR-related metrics computed from the goals store.
    getGoalMetric(email, key) {
      if (!email) return null;
      const map = this.goalMetricsByEmail || {};
      if (!map[email]) return null;
      const value = map[email][key];
      return value === undefined ? null : value;
    },
    // Performance is KR-driven when goals are owned, otherwise driven by manager review gems.
    // computed_performance is null when no review records exist for the person — that's
    // the "No data" state (distinct from "received reviews but scored 0", which is real Poor).
    getPerformanceMetric(person) {
      if (!person) return { value: null, caption: "", source: null };
      const ownedKR = Number(this.getGoalMetric(person.email, "owned_key_results")) || 0;
      if (ownedKR > 0) {
        const kp = Number(this.getGoalMetric(person.email, "kr_progress")) || 0;
        const kh = Number(this.getGoalMetric(person.email, "kr_health")) || 0;
        return {
          value: Math.round((kp + kh) / 2),
          caption: `KR · ${Math.round(kp)}%`,
          source: "kr",
        };
      }
      const perf = this.getCompositeMetric(person.email, "computed_performance");
      if (perf === null || perf === undefined || isNaN(perf)) {
        return { value: null, caption: this.$t("insights.No_data"), source: "empty" };
      }
      return {
        value: Math.round(Number(perf)),
        caption: this.$t("insights.Performance_subtitle_gem"),
        source: "gem",
      };
    },
    formatScore(value) {
      if (value === null || value === undefined || isNaN(value)) return "—";
      return Math.round(Number(value));
    },
    // Look up a person's display name from the membersall lookup. Falls back to
    // the local-part of the email if the sender isn't in the company roster
    // (e.g. ex-employees who gave recognition before leaving).
    getTrulySenderName(email) {
      if (!email) return "";
      const lookup = this.riskDrillDownMemberLookup || {};
      const m = lookup[email];
      if (m) {
        const fn = m.firstname || "";
        const ln = m.lastname || "";
        const full = `${fn} ${ln}`.trim();
        if (full) return full;
      }
      return email.split("@")[0];
    },
    // "May 8" style — month-day, no year. Tooltips are ephemeral so the year
    // adds clutter; the 6-month lookback bounds the ambiguity.
    formatTrulyDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(String(dateStr).slice(0, 10) + "T00:00:00");
      if (isNaN(d.getTime())) return String(dateStr).slice(0, 10);
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      return `${months[d.getMonth()]} ${d.getDate()}`;
    },
    // "Feb 2026" — Recognized By list rows show the year because the 6-month
    // lookback can cross a year boundary and the row is persistently visible
    // (not behind a hover, unlike formatTrulyDate's tooltip context).
    formatTrulyDateMonthYear(dateStr) {
      if (!dateStr) return "";
      const d = new Date(String(dateStr).slice(0, 10) + "T00:00:00");
      if (isNaN(d.getTime())) return String(dateStr).slice(0, 10);
      return this.$dateFns.format(d, "MMM YYYY");
    },
    hasPowerSkillsData(person) {
      if (!person) return false;
      const keys = ["ps_empathy", "ps_self_awareness", "ps_critical_thinking", "ps_leadership", "ps_initiative_making", "ps_optimism"];
      return keys.some((k) => {
        const v = person[k];
        return v !== null && v !== undefined && !isNaN(v) && Number(v) > 0;
      });
    },
    isRowExpanded(email) {
      return this.expandedEmails.indexOf(email) !== -1;
    },
    toggleRowExpanded(email, event) {
      if (event) {
        event.stopPropagation();
      }
      const idx = this.expandedEmails.indexOf(email);
      if (idx === -1) {
        this.expandedEmails.push(email);
        this.ensurePeopleDetail(email);
        if (this.user && this.user.company) {
          this.$store.dispatch("people/loadPeopleMedals", this.user)
            .catch((error) => {
              console.error("Failed to load People Intelligence medals:", error);
            });
        }
      } else {
        this.expandedEmails.splice(idx, 1);
      }
    },
    getHealthIndicatorImage(riskLevel) {
      const imageMap = {
        '0': 'recovery@2x.png',
        '1': 'risk_low@2x.png',
        '2': 'risk_med@2x.png',
        '3': 'risk_high@2x.png'
      };
      return imageMap[riskLevel] ? require(`@/assets/images/people/${imageMap[riskLevel]}`) : null;
    },
    arrayToRecognition(value,type) {
      const arr = [];
      let color = "bar-red";
      if(type=='gem'){
        if(value=='100'){
          for (let i = 0; i < 4; i++) {
            if(i>0){
              color = "";
            }
            arr.push(`${color}`);
          }
        }else if(value=='110'){
          color = "bar-yellow";
          for (let i = 0; i < 4; i++) {
            if(i>1){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='120'){
          color = "bar-yellow";
          for (let i = 0; i < 4; i++) {
            if(i>2){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='125'){
          color = "bar-green";
          for (let i = 0; i < 4; i++) {
            if(i>2){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='130'){
          color = "bar-green";
          for (let i = 0; i < 4; i++) {
           
            arr.push(`${color}`);
          }

        }
      }else{
        if(value=='000'){
          for (let i = 0; i < 4; i++) {
            if(i>0){
              color = "";
            }
            arr.push(`${color}`);
          }
        }else if(value=='010'){
          color = "bar-yellow";
          for (let i = 0; i < 4; i++) {
            if(i>1){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='020'){
          color = "bar-yellow";
          for (let i = 0; i < 4; i++) {
            if(i>2){
              color = "";
            }
            arr.push(`${color}`);
          }

        }else if(value=='030'){
          color = "bar-green";
          for (let i = 0; i < 4; i++) {
           
            arr.push(`${color}`);
          }

        }

      }      
      return arr;
    },
    getTalentTooltip(talent) {
      const tooltips = {
        "Latent Potential": "Shows promise but currently under-recognized by both peers and managers.",
        "Contributor": "Beginning to gain manager recognition while still building peer support.",
        "Crowd Favorite": "Highly regarded by peers for support, but not yet fully recognized by management for performance.",
        "Unsung Talent": "Highly valued and recognized by peers for supportiveness, but not yet recognized by management for performance.",
        "Up-and-coming": "Shows early signs of potential, starting to be noticed by both peers and managers.",
        "Rising Star": "Gaining recognition from both peers and management, with stronger management appreciation.",
        "Emerging Talent": "Popular among peers and beginning to gain management recognition for performance.",
        "High Potential": "Highly regarded by peers for supportiveness, with emerging recognition from management for performance.",
        "Community Pillar": "Highly respected by peers but not yet fully recognized by management for performance.",
        "Engaged Contributor": "Valued by peers and starting to gain management recognition for performance.",
        "Core Player": "Key team member with strong peer support and solid management recognition.",
        "Solid Performer": "Consistently meets expectations with both peer and management recognition.",
        "Valued Contributor": "Recognized by management for performance, gradually building peer network.",
        "Key Player": "Important to the team, with growing recognition from both peers and management.",
        "Respected Expert": "Widely respected by peers and highly valued by management for performance.",
        "Distinguished Talent": "Exemplary in management-recognized contributions, with strong peer support.",
        "Untapped Potential": "Highly recognized by management for performance, but not yet well-known or supported by peers.",
        "Activated": "Strong peer support with increasing management recognition of performance.",
        "High Performer": "Excelling in management's view with strong peer respect.",
        "Superstar": "Exceptional contributor recognized widely by both peers and management."
      };

      return tooltips[talent] || "No description available";
    },
    getSkillTooltip(rating) {
      const skillLevel = parseFloat(rating);
      if (isNaN(skillLevel)) return "Invalid rating";

      if (skillLevel >= 0 && skillLevel < 1) {
        return "Developing Awareness: Responses show a beginning recognition of these power skills. There's great potential for growth as engagement and reflection in these areas continue.";
      } else if (skillLevel >= 1 && skillLevel < 2) {
        return "Building Foundation: Responses demonstrate a basic understanding of these power skills. Continued exploration and practice will strengthen this foundation and expand capabilities.";
      } else if (skillLevel >= 2 && skillLevel < 3) {
        return "Actively Applying: Responses indicate regular use of these power skills. Seeking further opportunities to apply and refine them in various situations will enhance proficiency.";
      } else if (skillLevel >= 3 && skillLevel < 4) {
        return "Skillful Integration: Responses reflect strong proficiency in these areas, showing a nuanced understanding and consistent application of these power skills.";
      } else if (skillLevel >= 4 && skillLevel <= 5) {
        return "Mastery and Leadership: Responses demonstrate exceptional command of these power skills. This level of expertise not only shows mastery but also the potential to inspire others. Consider opportunities for mentoring colleagues.";
      } else {
        return "Rating out of range";
      }
    },
    getGreaterValueAlignment(email) {
      if (this.recognition[email]) {
        const given = this.recognition[email].valueAlignmentGiven || 0;
        const received = this.recognition[email].valueAlignmentReceived || 0;
        return Math.max(given, received);
      }
      return 0;
    },
    // Compact band label for Skills (0–5). Mirrors getSkillTooltip thresholds
    // but returns a short word — the leader-facing semantic anchor that lives
    // under the headline number.
    getSkillBandLabel(rating) {
      const r = parseFloat(rating);
      if (isNaN(r) || r <= 0) return "";
      if (r < 1) return this.$t("insights.Skill_band_developing");
      if (r < 2) return this.$t("insights.Skill_band_building");
      if (r < 3) return this.$t("insights.Skill_band_applying");
      if (r < 4) return this.$t("insights.Skill_band_integrated");
      return this.$t("insights.Skill_band_mastery");
    },
    getSkillBandSlug(rating) {
      const r = parseFloat(rating);
      if (isNaN(r) || r <= 0) return "none";
      if (r < 1) return "developing";
      if (r < 2) return "building";
      if (r < 3) return "applying";
      if (r < 4) return "integrated";
      return "mastery";
    },
    // Compact band label for Values (0–10). Score is AI-derived from peer
    // recognition activity (given & received) — band wording emphasises
    // alignment rather than proficiency.
    getValuesBandLabel(score) {
      const s = parseFloat(score);
      if (isNaN(s) || s <= 0) return "";
      if (s >= 9) return this.$t("insights.Values_band_strong");
      if (s >= 7) return this.$t("insights.Values_band_aligned");
      if (s >= 5) return this.$t("insights.Values_band_mixed");
      return this.$t("insights.Values_band_emerging");
    },
    getValuesBandSlug(score) {
      const s = parseFloat(score);
      if (isNaN(s) || s <= 0) return "none";
      if (s >= 9) return "strong";
      if (s >= 7) return "aligned";
      if (s >= 5) return "mixed";
      return "emerging";
    },
    // Given/Received halves of the Values score. The visible UI takes max()
    // for the headline; this surfaces the split ONLY when the two sides
    // diverge meaningfully (|delta| >= 1.5 on a 0–10 scale), so leaders see
    // "celebrated for values" vs "champions values in others" without
    // forcing every row to carry the extra line.
    getValueAlignmentSplit(email) {
      const rec = this.recognition[email];
      if (!rec) return { given: 0, received: 0, show: false };
      const given = parseFloat(rec.valueAlignmentGiven) || 0;
      const received = parseFloat(rec.valueAlignmentReceived) || 0;
      const show = Math.abs(given - received) >= 1.5 && given > 0 && received > 0;
      return { given, received, show };
    },
    // Source-aware tooltip for Values. Pairs with the existing
    // getSkillTooltip — both surface the AI origin so the credibility of
    // these signals lives one hover away rather than cluttering the card.
    getValuesTooltip(email) {
      const rec = this.recognition[email] || {};
      const given = parseFloat(rec.valueAlignmentGiven) || 0;
      const received = parseFloat(rec.valueAlignmentReceived) || 0;
      const total = (rec.totalGiven || 0) + (rec.totalReceived || 0);
      const lines = [
        this.$t("insights.Values_tooltip_intro"),
        "",
        `${this.$t("insights.Values_split_given_label")}: ${given.toFixed(1)} / 10`,
        `${this.$t("insights.Values_split_received_label")}: ${received.toFixed(1)} / 10`,
        total > 0 ? `${total} ${this.$t("insights.Values_tooltip_events_suffix")}` : "",
      ];
      return lines.filter(Boolean).join("\n");
    },
    getNetworkTooltip(networkType) {
      const tooltips = {
        "Low Network": "Limited connections within the organization. Opportunity to expand professional relationships both within and outside immediate team.",
        "Medium Outer": "Developing connections across different departments or teams. Good at bridging gaps between diverse groups in the organization.",
        "Medium Inner": "Strong connections within immediate team or department. Valued collaborator among close colleagues.",
        "Medium Network": "Balanced mix of connections within and outside immediate team. Demonstrates ability to work effectively across various groups.",
        "High Outer": "Extensive connections beyond immediate team. Excels at cross-departmental collaboration and information sharing.",
        "High Inner": "Deeply embedded within immediate team or department. Key player in fostering team cohesion and shared knowledge.",
        "High Network": "Wide-ranging connections throughout the organization. Adept at leveraging relationships for collaborative problem-solving.",
        "Super Outer": "Exceptional at forming connections across the entire organization. Influential in bridging organizational silos and driving cross-functional initiatives.",
        "Super Inner": "Central figure within immediate team or department. Pivotal in shaping team culture and facilitating internal communication.",
        "Super Network": "Extraordinary connection hub across all levels of the organization. Uniquely positioned to influence organizational culture and drive collaborative innovation."
      };
      return tooltips[networkType] || "Network type information";
    },
    getEngagementTooltip(houseLevel) {
      if (houseLevel.includes('novice')) {
        return "Low engagement health: not actively participating in check-ins, feedback and recognition.";
      } else if (houseLevel.includes('Inte')) {
        return "Medium engagement health: shows some activity in check-ins, feedback, and recognition.";
      } else if (houseLevel.includes('Adv')) {
        return "High engagement health: is actively participating in check-ins, feedback, and recognition.";
      } else if (houseLevel.includes('elite')) {
        return "Very high engagement health: is consistent and actively participating in check-ins, feedback, and recognition.";
      } else {
        return "Engagement level not available.";
      }
    },
    calculatePercentile(email) {
      // If we're viewing All Teams, use global calculation for both modes to ensure consistency
      if (this.isAllTeamsSelected || this.percentileScope === "global") {
        // Use global company-wide list
        return this.calculateGlobalPercentile(email);
      } else {
        // Use filtered list for scoped mode
        return this.calculateScopedPercentile(email);
      }
    },
    handlePercentileScope(scope) {
      this.percentileScope = scope;
    },
    calculateScopedPercentile(email) {
      // Use current filtered/scoped list
      const ratingsToUse = this.starperform
        .map(person => person.impact_rating)
        .filter(rating => rating !== undefined && rating !== null);
      
      // Find person in current filtered list
      const person = this.starperform.find(p => p.email === email);
      const personRating = person ? person.impact_rating : undefined;
      
      if (!personRating || ratingsToUse.length === 0) {
        return 0;
      }
      
      // Count how many ratings are less than or equal to this person's rating
      const countLessOrEqual = ratingsToUse.filter(rating => rating <= personRating).length;
      
      // Calculate percentile
      const percentile = (countLessOrEqual / ratingsToUse.length) * 100;
      
      return percentile;
    },
    calculateGlobalPercentile(email) {
      // allCompanyRatings is now a computed property derived from membersall
      if (this.allCompanyRatings.length === 0) {
        return 0; // Data not loaded yet, will update reactively
      }
      
      // Get all ratings from global data
      const ratingsToUse = this.allCompanyRatings
        .map(person => person.impact_rating)
        .filter(rating => rating !== undefined && rating !== null);
      
      // First try to find person in global list
      let personFromGlobal = this.allCompanyRatings.find(p => p.email === email);
      
      // If not found in global list (shouldn't happen), try current list
      if (!personFromGlobal) {
        personFromGlobal = this.starperform.find(p => p.email === email);
      }
      
      const personRating = personFromGlobal ? personFromGlobal.impact_rating : undefined;
      
      if (!personRating || ratingsToUse.length === 0) {
        return 0;
      }
      
      // Count how many ratings are less than or equal to this person's rating
      const countLessOrEqual = ratingsToUse.filter(rating => rating <= personRating).length;
      
      // Calculate percentile
      const percentile = (countLessOrEqual / ratingsToUse.length) * 100;
      
      return percentile;
    },
    exportTable() {
      // Export the rows the user is actually looking at — respects search,
      // team filter, talent type checkboxes, and the talent-group preset.
      // Leaders filtering to "At-Risk Stars" or "Promotion Ready" should be
      // able to hand that exact list to their HRBP.
      const allMembers = this.filteredByTalentGroup || [];
      
      // Define headers for CSV
      const headers = [
        'First Name',
        'Last Name',
        'Email',
        'Team',
        'Talent Type',
        'Network Type',
        'House Level',
        'Impact Rating',
        'Impact Rating Change',
        'Risk Level',
        'Impact Percentile',
        'Percentile Type', // Indicates if percentile is scoped or global
        'Skills Rating',
        'Values Alignment',
        'Medals Count',
        'Outstanding Ratings Count'
      ];
      
      // Transform data for CSV
      const csvData = allMembers.map(row => {
        const percentile = this.calculatePercentile(row.email);
        const percentileType = this.isAllTeamsSelected ? 'Global' : 
                             (this.percentileScope === 'filtered' ? 'Scoped' : 'Global');
        
        // Get additional data from other stores
        const alignementData = this.alignement[row.email] || {};
        const medalsCount = this.medals[row.email] || 0;
        const outstandingCount = this.truly[row.email] || 0;
        const recognitionData = this.recognition[row.email] || {};
        const valueAlignment = this.getGreaterValueAlignment(row.email);
        
        return [
          row.firstname,
          row.lastname,
          row.email,
          row.team_name,
          row.talent,
          row.network_type || '',
          row.house_level,
          (row.impact_rating || 0).toFixed(1),
          row.impact_compare ? row.impact_compare.toFixed(1) : '0',
          row.risk_level || '0',
          percentile.toFixed(1),
          percentileType,
          alignementData.rating_skill || '0.0',
          valueAlignment.toFixed(1),
          medalsCount,
          outstandingCount
        ];
      });
      
      // Add headers to beginning of data
      csvData.unshift(headers);
      
      // Convert to CSV string with proper escaping for CSV format
      const csvString = csvData.map(row => 
        row.map(field => {
          // Handle null/undefined
          if (field === null || field === undefined) {
            return '';
          }
          // If field contains comma, quotes, or newline, wrap in quotes and escape existing quotes
          if (typeof field === 'string' && (field.includes(',') || field.includes('"') || field.includes('\n'))) {
            return `"${field.replace(/"/g, '""')}"`;
          }
          return field;
        }).join(',')
      ).join('\n');
      
      // Create blob and download
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').substring(0, 19);
        const filterSuffix = this.selectedTalentGroup !== 'all'
          ? `_${this.selectedTalentGroup}`
          : '';
        link.setAttribute('download', `people_intelligence${filterSuffix}_${timestamp}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url); // Clean up the URL object
      }
    },
    async loadArchivedMemberLookup() {
      if (this.archivedMemberLookupLoaded) return;
      try {
        var company = this.$store.state.authen.user.company;
        var data = await importMemberDeps.getArchivedMembers(company);
        if (data) {
          var lookup = {};
          for (var key in data) {
            if (data.hasOwnProperty(key) && data[key].email) {
              lookup[data[key].email] = data[key];
            }
          }
          this.archivedMemberLookup = lookup;
        }
        this.archivedMemberLookupLoaded = true;
      } catch (e) {
        console.error('Failed to load archived members:', e);
      }
    },
    async loadHappinessPattern(email) {
      // Check if already loaded or loading
      if (this.happinessPatterns[email] || this.loadingPatterns[email]) {
        return;
      }
      
      // Set loading state
      this.$set(this.loadingPatterns, email, true);
      
      try {
        const firebase = require('firebase/app');
        require('firebase/firestore');
        
        // Get the current date and calculate 2 weeks back
        const companyId = this.user && this.user.company;
        const timezone = await getCompanyTimezone(companyId);
        const currentDate = toCompanyDate(new Date(), timezone);
        const twoWeeksAgo = new Date(currentDate);
        twoWeeksAgo.setDate(currentDate.getDate() - 14);
        
        // Format dates to match Firebase format (YYYY-MM-DD)
        const currentDateStr = currentDate.toISOString().split('T')[0];
        const twoWeeksAgoStr = twoWeeksAgo.toISOString().split('T')[0];
        
        // Generate array of workdays for the past 2 weeks
        const pattern = [];
        let currentDay = new Date(currentDate);
        
        // Get the start of this week (Monday)
        const startOfThisWeek = new Date(currentDate);
        const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday
        const daysFromMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Handle Sunday as 6 days from Monday
        startOfThisWeek.setDate(currentDate.getDate() - daysFromMonday);
        
        // Get the start of last week (Monday of previous week)
        const startOfLastWeek = new Date(startOfThisWeek);
        startOfLastWeek.setDate(startOfThisWeek.getDate() - 7);
        
        // Collect workdays going backwards from today
        let daysAdded = 0;
        while (daysAdded < 10) {
          const currentDayOfWeek = currentDay.getDay(); // 0 = Sunday, 6 = Saturday
          
          // Only add weekdays (Monday = 1, Friday = 5)
          if (currentDayOfWeek >= 1 && currentDayOfWeek <= 5) {
            const dateStr = currentDay.toISOString().split('T')[0];
            const dayName = currentDay.toLocaleDateString('en-US', { weekday: 'short' });
            
            // Determine which week this day belongs to based on actual calendar weeks
            let week;
            if (currentDay >= startOfThisWeek) {
              week = 2; // This week
            } else if (currentDay >= startOfLastWeek) {
              week = 1; // Last week
            } else {
              week = 0; // Older than 2 weeks (shouldn't happen with our 10-day limit)
            }
            
            pattern.unshift({
              date: dateStr,
              status: 'none', // Default to no response
              response: null,
              dayName: dayName,
              week: week
            });
            
            daysAdded++;
          }
          
          // Move to previous day
          currentDay.setDate(currentDay.getDate() - 1);
        }
        
        // Query Firebase using the exact same pattern as getDailyStatus (no company filter)
        const querySnapshot = await firebase.firestore()
          .collection('users_questions')
          .where('users', '==', email)
          .where('date', '<=', currentDateStr)
          .where('date', '>=', twoWeeksAgoStr)
          .get();
        
        // Process responses using the exact same logic as getDailyStatus
        const _data = {};
        
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          
          // Only process happiness question responses
          if (data.quest_id === "-Kgs61AHOnpJ3rfyQr6t") {
            if (_data[data.date]) {
              _data[data.date] = "";
            }
            
            // Map answers to status using exact same logic as store
            if (data.answer === 0 || data.answer === 1) {
              _data[data.date] = "green";
            } else if (data.answer === 2) {
              _data[data.date] = "yellow";
            } else if (data.answer === 3 || data.answer === 4) {
              _data[data.date] = "red";
            } else {
              _data[data.date] = "gray";
            }
          }
        });
        
        // Map processed data to pattern array
        pattern.forEach((day, index) => {
          const firebaseStatus = _data[day.date];
          let status = 'none';
          
          if (firebaseStatus) {
            switch (firebaseStatus) {
              case 'green':
                status = 'great';
                break;
              case 'yellow':
                status = 'okay';
                break;
              case 'red':
                status = 'poor';
                break;
              default:
                status = 'none';
            }
          }
          
          pattern[index].status = status;
        });
        
        // Store the pattern data
        this.$set(this.happinessPatterns, email, {
          pattern: pattern,
          lastUpdated: new Date().toISOString(),
          totalResponses: querySnapshot.size,
          happinessResponses: Object.keys(_data).length
        });
        
      } catch (error) {
        // Set empty pattern on error
        this.$set(this.happinessPatterns, email, {
          pattern: [],
          error: 'Failed to load pattern data',
          errorDetails: error.message
        });
      } finally {
        // Clear loading state
        this.$set(this.loadingPatterns, email, false);
      }
    },
    isAtRisk(level) {
      return level === '1' || level === '2' || level === '3';
    },
    getRiskLevelTitle(riskLevel) {
      const titles = {
        '0': 'Recovery',
        '1': 'Low Risk',
        '2': 'Medium Risk',
        '3': 'High Risk'
      };
      return titles[riskLevel] || 'Unknown';
    },
    formatPatternDayTooltip(day) {
      const statusLabels = {
        'great': 'Happy/Pretty Good',
        'okay': 'Okay/Meh',
        'poor': 'Not Great/Terrible',
        'none': 'No Response'
      };
      
      const date = new Date(day.date);
      const formattedDate = date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric' 
      });
      
      return `${formattedDate} (${day.dayName}): ${statusLabels[day.status]}`;
    },
    getDefaultRiskMessage(riskLevel) {
      const defaultMessages = {
        '0': 'This person appears to be in a good place with their well-being and engagement.',
        '1': 'This person may need some attention to maintain their well-being.',
        '2': 'This person could benefit from additional support and check-ins.',
        '3': 'This person may need immediate attention and support from their manager.'
      };
      
      return defaultMessages[riskLevel] || 'Well-being status is being monitored.';
    }
  },
};
</script>
<style lang="scss" scoped>
.selectStyle {
  width: 320px;
}

// Secondary-tier dropdown trigger: compact inline filter pill.
.menuOptionStyle {
  border-bottom: transparent;
  background: #ffffff;
  border: 1px solid #e2e4ea;
  border-radius: 8px;
  transition: background-color .15s ease, border-color .15s ease;

  &:hover {
    background-color: #f6f7f9;
  }
}

.txtOptionStar {
  color: #4a4a4a;
  font-size: 13px;
  font-weight: 600;
  margin-left: 16px;
  width: 190px;
  display: inline-block;
}

.divTable {
  flex: 1;
  margin-left: -9px;
}

.txtPercent {
  margin-left: 6px;
  font-size: 14px;
}

.txtPercent.green {
  color: #27bc6c;
}

.txtPercent.red {
  color: #f44336;
}

.divHeadCurcleRisk {
  width: 24px;
  height: 24px;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  z-index: 10;
}

.divHeadCurcleRisk.red {
  background-color: #b40303;
}

.divHeadCurcleRisk.grey {
  background-color: #939393;
}

.divDetailCurcleRisk {
  width: 72px;
  height: 24px;
  text-align: center;
  border-radius: 20px;
  z-index: 5;
}

.divDetailCurcleRisk.red {
  background-color: #e21a1a;
}

.divDetailCurcleRisk.grey {
  background-color: #bcbcbc;
}

.txtHeadRisk {
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
}

.txtDetailRisk {
  margin-left: 15px;
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 2px;
}
.txtDetailRiskRecovery {
  font-size: 12px;
  font-weight: 700;
  color: #1AC362;
  width: 70px;
  height: 25px;
  padding: 5px 8px 5px 8px;
  
}
.txtStar {
  margin-top: 5px;
  font-size: 20px;
}

.txtStar.risk {
  color: #7e7e7e;
}

.txtStar.perform {
  color: #4d4d4d;
}

.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.el-button--save {
  padding: 4px 16px;
  height: 24px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
}

.el-button--save:hover,
.el-button--save:focus {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 0.7;
}

.el-button--save:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

.el-button--cancel {
  padding: 4px 16px;
  height: 24px;
  font-size: 13px;
  font-weight: 700;
  color: #747474;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
}

.el-button--cancel:hover,
.el-button--cancel:focus {
  color: #747474;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  opacity: 0.7;
}

.el-button--cancel:active {
  color: #747474;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  opacity: 1;
}

.dispTalentTypeStyle {
  height: 24px;
  margin-right: 12px;
}

.tooltipStyle {
  width: 375px;
}

.buttom-detail-image {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  transition: 0.3s;
  opacity: 0;
  background: #fafafa;
}

.read-more {
  margin-top: 15px;

  >a {
    font-size: 12px;
    color: #32c2d5;
    text-decoration: none;
  }
}

.split-risk-power {
  display: grid;
  grid-template-columns: 600px auto;
  margin: 24px 0 32px;

  .power-container {
    margin-left: 16px;
    background-color: rgba(#000000, 0.03);
    padding: 24px 12px 10px 24px;
    border-radius: 24px;
  }

  .risk-container {
    background-color: rgba(#000000, 0.03);
    padding: 24px 24px 14px;
    border-radius: 24px;

    .risk-title {
      width: 12px;
      height: 12px;
    }

    .risk-title.recovery {
      background-color: #35D077;
    }

    .risk-title.one {
      background-color: #e21a1a;
    }

    .risk-title.two {
      background-color: #c41919;
    }

    .risk-title.three {
      background-color: #900505;
    }

    .risk-title.line {
      width: 20px;
      height: 2px;
      border-radius: 2px;
      background-color: #35d077;
    }
  }

  .power-tabs {
    width: calc(234px - 32px);
    height: 24px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    padding: 4px 16px;
    margin-top: 4px;
    border-radius: 3px;
    letter-spacing: 1.12px;
    position: relative;
    background-color: rgba($color: #000000, $alpha: 0.14);

    .color-bar {
      position: absolute;
      border-radius: 3px;
      left: 0;
      height: 32px;
    }

    .color-bar.ic_empathy {
      background-color: #6000da;
    }

    .color-bar.ic_selfawareness {
      background-color: #f77511;
    }

    .color-bar.ic_criticalthinking {
      background-color: #ff2b19;
    }

    .color-bar.ic_leadership {
      background-color: #00aa1a;
    }

    .color-bar.ic_initiative {
      background-color: #8ce100;
    }

    .color-bar.ic_optimism {
      background-color: #e2ec00;
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #000000;
    font-size: 14px;
    font-weight: 700;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
}

.people-panel-skeleton {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.people-panel-skeleton-risk {
  align-items: stretch;
  padding: 8px 8px 0;
  gap: 10px;
}

.people-risk-skeleton-axis {
  width: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding: 18px 0 28px;
}

.people-risk-skeleton-axis-label {
  width: 14px;
  height: 10px;
  border-radius: 999px;
}

.people-risk-skeleton-plot {
  flex: 1;
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: 16px 10px 0 2px;
}

.people-risk-skeleton-grid {
  position: absolute;
  inset: 16px 10px 28px 2px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.people-risk-skeleton-grid-line {
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.06);
}

.people-risk-skeleton-series {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.people-risk-skeleton-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.people-risk-skeleton-group-bars {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  height: 100%;
}

.people-risk-skeleton-bar {
  border-radius: 999px 999px 6px 6px;
}

.people-risk-skeleton-bar-thin {
  width: 12px;
  min-width: 12px;
}

.people-risk-skeleton-group-label {
  width: 34px;
  height: 10px;
  border-radius: 999px;
}

.people-impact-skeleton {
  min-height: 200px;
  flex-direction: column;
  gap: 16px;
  padding: 2px 4px 0;
}

.people-impact-skeleton-chart {
  position: relative;
  width: 148px;
  height: 148px;
}

.people-impact-skeleton-ring {
  position: relative;
  width: 148px;
  height: 148px;
  border-radius: 50%;
}

.people-impact-skeleton-ring::after {
  content: "";
  position: absolute;
  inset: 32px;
  border-radius: 50%;
  background: #f7f7f7;
}

.people-impact-skeleton-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.people-impact-skeleton-center-score {
  width: 52px;
  height: 20px;
  border-radius: 999px;
}

.people-impact-skeleton-center-label {
  width: 28px;
  height: 10px;
  border-radius: 999px;
}

.people-impact-skeleton-center-count {
  width: 64px;
  height: 10px;
  border-radius: 999px;
}

.people-impact-skeleton-legend-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 10px;
  align-items: center;
}

.people-impact-skeleton-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.people-impact-skeleton-chip-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.people-impact-skeleton-chip-line {
  height: 18px;
  border-radius: 999px;
}

.people-impact-skeleton-chip:last-child {
  grid-column: 1 / -1;
}

.people-grid-skeleton {
  min-height: 200px;
}

.people-grid-skeleton-matrix {
  display: grid;
  grid-template-columns: repeat(4, 42px);
  gap: 6px;
}

.people-grid-skeleton-cell {
  width: 42px;
  height: 32px;
  border-radius: 6px;
}

.impact-chart-container {
  padding: 12px 0;
  
  .donut-chart-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }
  
  .donut-chart-area {
    position: relative;
    width: 170px;
    height: 170px;
    flex-shrink: 0;
  }
  
  .donut-center-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
    z-index: 1; /* Stay below external tooltip */
  }
  
  .center-avg {
    font-size: 28px;
    font-weight: 700;
    color: #333;
    line-height: 1;
  }
  
  .center-label {
    font-size: 10px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.4);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 2px;
  }
  
  .center-people {
    font-size: 11px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.5);
    margin-top: 6px;
  }
  
  .donut-legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px 12px;
    width: 100%;
    padding: 0 4px;
  }
  
  .legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    background: rgba(0, 0, 0, 0.03);
    padding: 4px 8px;
    border-radius: 6px;
    white-space: nowrap;
  }
  
  .legend-color {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }
  
  .legend-label {
    color: rgba(0, 0, 0, 0.6);
    font-weight: 500;
  }
  
  .legend-count {
    font-weight: 700;
    color: #333;
  }
  
  .legend-percent {
    color: rgba(0, 0, 0, 0.4);
    font-size: 10px;
  }
}

.people-table-skeleton {
  margin: 16px 0 28px;
}

.people-table-skeleton-row {
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 16px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.people-table-skeleton-row:first-child {
  border-top: none;
}

.people-table-skeleton-person {
  display: flex;
  align-items: center;
  min-width: 220px;
}

.people-table-skeleton-meta {
  margin-left: 16px;
}

.people-table-skeleton-metrics {
  flex: 1;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
}

.people-table-skeleton-chip {
  width: 70px;
  height: 36px;
  border-radius: 8px;
}

.people-table-skeleton-pill {
  width: 56px;
  height: 22px;
  border-radius: 999px;
}

.network-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .flex {
    justify-content: center;
  }

  .text-left-table {
    position: relative;
    width: 30px;
    padding-top: 90px;
    
    .text {
      position: absolute;
      width: 100px;
      text-align: center;
      font-size: 11px;
      margin-left: -36px;
      color: rgba(#000000, 0.8);
      transform: rotate(-90deg);
      white-space: nowrap;
    }
  }

  .grid-table {
    width: 184px;
    display: grid;
    grid-template-columns: 45px 45px 45px 45px;
    border: 1px solid rgba(#000000, 0.2);
    border-width: 0 0 2px 2px;
    padding: 0 0 8px 12px;

    .cell {
      margin: auto;
      width: 42px;
      padding-top: 2px;
      height: 32px;
      margin: 0px 3px 3px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      position: relative;
    }

    .cell.c-FBC02D {
      background: #fbc02d;
    }

    .cell.c-C2E337 {
      background: #c2e337;
    }

    .cell.c-66BB6A {
      background: #66bb6a;
    }

    .cell.c-EF8D3A {
      background: #ef8d3a;
    }

    .cell.c-F44336 {
      background: #f44336;
    }

    .min-of-cell-2 {
      position: absolute;
      bottom: -6px;
      width: 42px;
      z-index: 99;
    }
  }
}

.excels-card {
  max-width: 242px;
  margin-bottom: 6px;

  .percent-tag {
    width: 80px;
    border-radius: 10px;
    height: 10px;

    .percent {
      border-radius: 10px;
      height: 10px;
      background-color: #6c30cc;
    }
  }

  .expend-user {
    background-color: rgba(#6c30cc, 0.08);
    box-shadow: 0px 3px 6px #00000005;
    border-radius: 4px;
    padding: 8px 12px 8px 16px;
    margin-top: 6px;
    user-select: none;

    .user-cell {
      position: relative;
      margin-right: 12px;

      .count-excels {
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translate(7px, -50%);
        padding: 2px 4px 0px;
        background-color: #006772;
        color: #fff;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
}

.recipients-modal-style {
  padding-top: 40px;
  padding-left: 40px;
  padding-bottom: 16px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 6px #00000014;

  .big-tag {
    padding: 7px 16px;
    font-weight: 700;
    font-weight: 16px;
    margin-left: 12px;
    color: #fff;
    border-radius: 4px;
    background-color: #0097a7;
  }
}

.members-recipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 40px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
}

.rowDataStyle {
  margin-bottom: 16px;

  .cell {
    height: 28px;
    width: 31px;
    padding-top: 3px;
    background-color: #006772;
    border-radius: 4px;
    color: #fff;
    font-weight: 700;
    font-size: 16px;
  }
}

.talent-tag {
  width: 100%;
  padding: 4px 8px 4px 8px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
}

.tag-red {
  background-color: #F4433620;
  color: #7E120A;
}

//  .tag-half-red{
//   background-color: rgba(#ef8d3a, 0.3);
//   color: #6f3f16;
// }

.tag-orange, .tag-half-red {
  background-color: #FBC02D20;
  color: #7E6016;
}

.tag-green, .tag-half-green {
  background-color: #66BB6A20;
  color: #008406;
}

// .tag-green {
//   background-color: rgba(#66bb6a, 0.3);
//   color: #124314;
// }

.impact-tag {
  line-height: 20px;
}

.achievements-contariner {
  width: 32px;
  margin-right: 6px;
  position: relative;

  .count-icon {
    position: absolute;
    top: -4px;
    right: -4px;
    height: 16px;
    min-width: 16px;
    padding: 0 1px;
    text-align: center;
    border-radius: 32px;
    background-color: #343434;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
  }
}

.achievements-contariner.no-have {
  opacity: 0.2;

  >img {
    filter: grayscale(100%);
  }
}

.engagement-no-data {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  margin-bottom: 7px;
  background-color: #ebebeb;
  font-weight: 700;
  font-size: 9px;
  line-height: 10px;
  color: #fff;
  text-align: center;
}

.box-card-table {
  position: relative;
  background: #FFFFFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  min-height: 72px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  padding: 0 12px 0 24px;
  transition: background-color 0.18s ease, box-shadow 0.18s ease;

  // Subtle lift on hover — helps the eye track across the row's chips and
  // telegraphs that the row is actionable (the chevron expands a detail panel).
  &:hover {
    background-color: #fafbfc;
    box-shadow:
      0 6px 16px -6px rgba(76, 50, 204, 0.14),
      0 1px 3px rgba(0, 0, 0, 0.06);

    .row-expand-btn {
      color: #4C32CC;
      background-color: rgba(76, 50, 204, 0.08);
      border-color: rgba(76, 50, 204, 0.18);
    }
  }

  &.expanded {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

// Risk/recovery state. We rely on the health-indicator icon (left of avatar)
// to convey state — no left-edge color band, no colored glow, no border accent.
// Matches the rest of the platform where rows don't use border-accent treatment.
.box-card-table.risk,
.box-card-table.recovery {
  /* no extra styling — health-indicator icon carries the state */
}

// People Intelligence — primary-metric table layout
.people-row-wrap {
  margin-top: 16px;

  .box-card-table {
    margin-top: 0;
  }
}

.people-table-header {
  display: flex;
  align-items: flex-start;
  padding: 14px 12px 12px 24px;
  border-bottom: 1px solid #eef0f5;
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: #ffffff;
  // Soft lift when scrolled — invisible at rest on white surface,
  // gently asserts depth once the row card slips under it.
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.06);

  // Scoped overrides: the shared qd-eyebrow tokens read too muted at
  // the table-header scale. Darker title + larger subtitle make column
  // identity scannable without breaking the global eyebrow system.
  .qd-eyebrow {
    font-size: 12px;
    color: #2f3441;
    letter-spacing: 0.06em;
    line-height: 1.35;
  }
  .qd-eyebrow-sub {
    font-size: 11px;
    color: #6b7080;
    font-weight: 500;
    margin-top: 3px;
    line-height: 1.35;
  }

  // Sortable metric columns. The chevron stays muted at rest (a hint, not a
  // demand) and brightens to brand purple when the column is the active sort.
  // Eyebrow text mirrors the indicator so the active column reads as a unit.
  .col-metric-sortable {
    cursor: pointer;
    user-select: none;
    border-radius: 6px;
    padding: 4px 6px;
    margin: -4px -6px;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #fafbfc;
      .col-sort-indicator { opacity: 1; color: #6C30CC; }
    }
    &:focus-visible {
      outline: 2px solid #6C30CC;
      outline-offset: 2px;
    }
    &.is-sorted {
      .qd-eyebrow { color: #6C30CC; }
      .col-sort-indicator { opacity: 1; color: #6C30CC; }
    }
  }

  .col-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .col-sort-indicator {
    font-size: 9px;
    line-height: 1;
    opacity: 0.35;
    color: #8a8a8a;
    transition: opacity 0.15s ease, color 0.15s ease;
  }
}

.qd-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8a8a;
  line-height: 1.4;
}

.qd-eyebrow-sub {
  font-size: 10px;
  font-weight: 500;
  color: #8a8a8a;
  margin-top: 2px;
  line-height: 1.3;
}

.people-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-shrink: 0;

  &.col-person {
    width: 240px;
    align-items: flex-start;
    text-align: left;
  }

  &.col-metric {
    width: 120px;
  }

  &.col-chevron {
    width: 32px;
    margin-left: auto;
  }
}

.person-meta {
  min-width: 0;
  flex: 1;

  .txtName,
  .txtTeam {
    width: 150px;
    max-width: 150px;
  }
}

.person-healthbar {
  width: 120px;
  margin-top: 6px;
}

// Score chips for primary metric columns.
// Pastel band colors mirror the canonical .qd-score-chip pattern in
// element-variables.scss:365 so the table reads as part of the same system.
// Dimensions are LOCKED (84px x 48px) so all chips align across columns.
.score-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 48px;
  padding: 4px 8px;
  border-radius: 8px;
  background-color: #f3f4f8;
  flex-shrink: 0;
  transition: background-color 0.15s ease;

  &-value {
    font-size: 16px;
    font-weight: 800;
    line-height: 1.1;
    color: #2A2A2A;
  }

  &-caption {
    font-size: 10px;
    font-weight: 600;
    color: #626262;
    margin-top: 2px;
    line-height: 1.2;
    letter-spacing: 0.02em;
    white-space: nowrap;
  }

  &.score-chip-excellent {
    background-color: #ACFFAC;
    .score-chip-value   { color: #0a4a1a; }
    .score-chip-caption { color: #0a4a1a; }
  }
  &.score-chip-high {
    background-color: #D9FDD8;
    .score-chip-value   { color: #2d5e33; }
    .score-chip-caption { color: #2d5e33; }
  }
  // Fair uses the canonical score-band-moderate pastel cream — warm = "has signal".
  // 5-band score chip palette. Aligned to the Impact Rating donut slice
  // colors so the cell pastel a leader sees in any score column matches the
  // chart slice that same value falls into:
  //   excellent #ACFFAC (donut 80-100 green)
  //   high      #D9FDD8 (donut 60-80 light green)
  //   yellow    #FFF3C4 (donut 40-60 yellow)
  //   orange    #FFE0CC (donut 20-40 orange)
  //   low       #FFEAEA (donut 0-20 red)
  // Text colors picked for WCAG-AA contrast on each pastel.
  &.score-chip-yellow {
    background-color: #FFF3C4;
    .score-chip-value   { color: #7a5d00; }
    .score-chip-caption { color: #7a5d00; }
  }
  &.score-chip-orange {
    background-color: #FFE0CC;
    .score-chip-value   { color: #8b3a00; }
    .score-chip-caption { color: #8b3a00; }
  }
  &.score-chip-low {
    background-color: #FFEAEA;
    .score-chip-value   { color: #991b1b; }
    .score-chip-caption { color: #991b1b; }
  }
  &.score-chip-zero {
    background-color: #F7CFD0;
    .score-chip-value   { color: #7d1d1d; }
    .score-chip-caption { color: #7d1d1d; }
  }
  // Empty = no signal at all. Neutral cool gray distinguishes "absent" from
  // any warm pastel chip alongside it — hue carries the meaning.
  &.score-chip-empty {
    background-color: #F2F3F7;
    .score-chip-value   { color: #9ea0a8; }
    .score-chip-caption { color: #9ea0a8; }
  }

  &.score-chip-loading {
    background-color: #F2F3F7;
    gap: 6px;
  }
}

.score-chip-loading-value {
  width: 30px;
  height: 16px;
  border-radius: 8px;
}

.score-chip-loading-caption {
  width: 48px;
  height: 10px;
  border-radius: 5px;
}

.score-chip-button {
  border: 0;
  font-family: inherit;
  cursor: pointer;
  outline: none;
  appearance: none;

  &:hover {
    box-shadow: 0 8px 18px -12px rgba(20, 28, 45, 0.55);
    transform: translateY(-1px);
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.22);
  }
}

// Impact chip caption: arrow + delta value, color shifts with direction.
.impact-caption {
  display: inline-flex;
  align-items: center;
  gap: 2px;

  .impact-arrow {
    font-size: 9px;
    line-height: 1;

    &.up   { color: #0DD379; }
    &.down { color: #FF4343; }
  }

  &.neutral { color: #b3b3b3; }
}

// Chevron toggle
.row-expand-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid transparent;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8a8a8a;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: rgba(76, 50, 204, 0.10);
    border-color: rgba(76, 50, 204, 0.22);
    color: #4C32CC;
  }

  &:focus {
    outline: 2px solid rgba(76, 50, 204, 0.35);
    outline-offset: 2px;
  }

  i {
    font-size: 14px;
    transition: transform 0.2s ease;
  }

  i.rotated {
    transform: rotate(180deg);
  }
}

// Expanded detail panel
.people-row-detail {
  background-color: #fafbfc;
  border: 1px solid #eef0f5;
  border-top: 1px solid #eef0f5;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 22px 28px 26px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 36px;
  row-gap: 0;
}

.people-detail-skeleton {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 36px;
  width: 100%;
}

.people-detail-skeleton-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.people-detail-skeleton-title {
  width: 132px;
  height: 12px;
  border-radius: 6px;
}

.people-detail-skeleton-line {
  width: 72%;
  height: 16px;
  border-radius: 8px;
}

.people-detail-skeleton-line-wide {
  width: 92%;
}

.people-detail-skeleton-line-short {
  width: 48%;
}

// Three columns, separated by generous whitespace rather than rules.
.detail-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;

  .detail-panel-title {
    color: #8a8a8a;
    margin-bottom: 2px;
  }

  .detail-panel-body {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
}

// Talent / Network pills — profile badges, not filter chips. Each category
// pulls its own tinted gradient + glowing radial dot, so the pill itself
// carries categorical weight without losing legibility. Reads like a small
// honor stamped on the row — earns the space it takes.
.detail-tag-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.detail-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.005em;
  white-space: nowrap;
  color: #2A2A2A;
  background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
  border: 1px solid #e0e3eb;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.02), inset 0 1px 0 rgba(255, 255, 255, 0.7);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-0.5px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.7);
  }

  .detail-pill-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, #cdd1d8 0%, #b3b3b3 70%, #8a8a8a 100%);
    flex-shrink: 0;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04);
  }

  // Category-tinted treatments — gradient background + radial-glowing dot
  // pulled from the Happily palette. The brand's Engage Yellow (#FFC200)
  // and accent ramp do the chromatic work; type stays high-contrast dark.

  &.tag-orange {
    background: linear-gradient(180deg, #FFF8EC 0%, #FFF1D8 100%);
    border-color: #f0d493;
    color: #5a4200;
    .detail-pill-dot {
      background: radial-gradient(circle at 30% 30%, #FFD955 0%, #F7B924 65%, #C99300 110%);
      box-shadow: 0 0 0 1px rgba(201, 147, 0, 0.3), 0 0 5px rgba(247, 185, 36, 0.4);
    }
  }

  &.tag-yellow {
    background: linear-gradient(180deg, #FFFCEB 0%, #FFF5C7 100%);
    border-color: #efdc92;
    color: #5a4200;
    .detail-pill-dot {
      background: radial-gradient(circle at 30% 30%, #FFE082 0%, #FFC200 60%, #C99300 110%);
      box-shadow: 0 0 0 1px rgba(201, 147, 0, 0.3), 0 0 5px rgba(255, 194, 0, 0.4);
    }
  }

  &.tag-green {
    background: linear-gradient(180deg, #EFFFF3 0%, #D8F8E2 100%);
    border-color: #a9dcb7;
    color: #1f5b2a;
    .detail-pill-dot {
      background: radial-gradient(circle at 30% 30%, #6CE995 0%, #0DD379 70%, #08a35d 110%);
      box-shadow: 0 0 0 1px rgba(8, 163, 93, 0.28), 0 0 5px rgba(13, 211, 121, 0.4);
    }
  }

  &.tag-half-green {
    background: linear-gradient(180deg, #F4FBF5 0%, #E5F4E9 100%);
    border-color: #bdd9c2;
    color: #2f6a35;
    .detail-pill-dot {
      background: radial-gradient(circle at 30% 30%, #a8dcad 0%, #76ca7d 60%, #4ea854 110%);
      box-shadow: 0 0 0 1px rgba(78, 168, 84, 0.25), 0 0 4px rgba(118, 202, 125, 0.3);
    }
  }

  &.tag-red {
    background: linear-gradient(180deg, #FFF4F4 0%, #FFE0E0 100%);
    border-color: #f0b8b8;
    color: #7a2629;
    .detail-pill-dot {
      background: radial-gradient(circle at 30% 30%, #ff8a8a 0%, #FF4343 65%, #c92e2e 110%);
      box-shadow: 0 0 0 1px rgba(201, 46, 46, 0.28), 0 0 5px rgba(255, 67, 67, 0.35);
    }
  }

  &.tag-half-red {
    background: linear-gradient(180deg, #FFF6F1 0%, #FFE4D6 100%);
    border-color: #f0c0a3;
    color: #7a3f1c;
    .detail-pill-dot {
      background: radial-gradient(circle at 30% 30%, #ffb088 0%, #ff8a5b 60%, #c95c2e 110%);
      box-shadow: 0 0 0 1px rgba(201, 92, 46, 0.28), 0 0 4px rgba(255, 138, 91, 0.35);
    }
  }
}

// Inline stat group: Skills · Values · Achievements
.detail-stat-row {
  display: flex;
  gap: 28px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.detail-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;

  .detail-stat-label {
    font-size: 10px;
    font-weight: 700;
    color: #8a8a8a;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .detail-stat-value {
    display: inline-flex;
    align-items: center;
    font-size: 17px;
    font-weight: 800;
    color: #2A2A2A;
    line-height: 1;
    letter-spacing: -0.01em;
    margin-top: 2px;

    .detail-stat-star {
      margin-left: 5px;
      position: relative;
      top: -1px;
    }

    .detail-stat-suffix {
      font-size: 11px;
      font-weight: 600;
      color: #b3b3b3;
      margin-left: 2px;
      letter-spacing: 0;
    }
  }

  // Band label: the semantic anchor that lets a leader scan without hovering
  // for the tooltip. Carries a small tinted dot — color drawn from the band
  // tier, so a quick peripheral glance tells you "good/mid/weak" before the
  // word resolves. Number remains the hero; the dot is the at-a-glance cue.
  .detail-stat-band {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #5a5e6b;
    line-height: 1.3;
    letter-spacing: 0.005em;

    .detail-stat-band-dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #b0b6c2;
      box-shadow: 0 0 0 2px rgba(176, 182, 194, 0.16);
      flex-shrink: 0;
    }

    // Top tier — peer recognition or self-reflection signals consistent
    // values/skills mastery.
    &.band-mastery .detail-stat-band-dot,
    &.band-strong .detail-stat-band-dot {
      background: #3AC47D;
      box-shadow: 0 0 0 2px rgba(58, 196, 125, 0.16);
    }

    // Upper-mid — consistent practice, room to grow.
    &.band-integrated .detail-stat-band-dot,
    &.band-aligned .detail-stat-band-dot {
      background: #5b6ad8;
      box-shadow: 0 0 0 2px rgba(91, 106, 216, 0.16);
    }

    // Mid — present but inconsistent.
    &.band-applying .detail-stat-band-dot,
    &.band-mixed .detail-stat-band-dot {
      background: #F7B924;
      box-shadow: 0 0 0 2px rgba(247, 185, 36, 0.18);
    }

    // Lower bands — keep the default neutral dot. Avoid red, which would
    // imply a negative judgment on what's often just early-stage / sparse
    // signal data.
  }

  // Given/Received split for Values. Two thin proportional bars stacked,
  // each row: small label · 56px track · value. The whole point of
  // surfacing the split is the *asymmetry* — short vs long bar makes that
  // visible at a glance in a way a number pair can't.
  .detail-stat-split {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 4px;

    .detail-stat-split-row {
      display: grid;
      grid-template-columns: 56px 56px 28px;
      align-items: center;
      gap: 8px;
      line-height: 1;
    }

    .detail-stat-split-label {
      font-size: 9px;
      font-weight: 700;
      color: #8a8a8a;
      text-transform: uppercase;
      letter-spacing: 0.08em;
    }

    .detail-stat-split-bar {
      position: relative;
      height: 4px;
      border-radius: 2px;
      background: #ECEEF3;
      overflow: hidden;
    }

    .detail-stat-split-bar-fill {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      border-radius: 2px;
      background: linear-gradient(90deg, #6c30cc 0%, #8B41F0 100%);
      transition: width 240ms cubic-bezier(0.22, 0.61, 0.36, 1);
    }

    .detail-stat-split-num {
      font-size: 11px;
      font-weight: 700;
      color: #2A2A2A;
      font-variant-numeric: tabular-nums;
      text-align: right;
    }
  }
}

.detail-achievement-icons {
  display: inline-flex;
  gap: 8px;
  align-items: center;
}

// Recognized as Outstanding: leads with an icon + count header, then chips
// listing each sender. Folds together what used to be the Achievements ⭐ chip
// and the separate "Recognized by" list — same Truly/Exceeding data source.
.detail-recognized-by {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}

.detail-recognized-header {
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1.2;

  .detail-recognized-header-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .detail-recognized-header-stack {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .detail-recognized-header-title {
    font-size: 13px;
    font-weight: 800;
    color: #2A2A2A;
    letter-spacing: -0.005em;
    line-height: 1.2;
  }

  .detail-recognized-header-meta {
    font-size: 11px;
    font-weight: 500;
    color: #8a8a8a;
    letter-spacing: 0.01em;
    line-height: 1.2;
  }
}

// Recognized By list — one row per peer rating. Editorial inline format:
// [tier-colored dot] [tier name in tier color] · [sender name in dark bold]
// [date in muted]. Sender name carries the most visual weight because that's
// the "who noticed me" signal a leader scans for. Tier color lives in the dot
// + tier name so leaders can still spot Truly Outstanding at a glance without
// a loud uppercase chip.
.detail-recognized-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-recognized-row {
  display: inline-flex;
  align-items: baseline;
  gap: 7px;
  padding: 4px 6px 4px 4px;
  margin-left: -6px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.45;
  flex-wrap: wrap;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #fafbfd;
  }

  // Leading dot — chromatic indicator of recognition tier.
  // Truly Outstanding = saturated Engage Yellow (#FFC200) for high signal.
  // Exceeding Expectations = soft cream that still reads gold but quieter.
  .detail-recognized-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
    align-self: center;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04);
  }

  &.detail-recognized-row-truly .detail-recognized-dot {
    background: radial-gradient(circle at 30% 30%, #FFE082 0%, #FFC200 60%, #C99300 100%);
    box-shadow: 0 0 0 1px rgba(201, 147, 0, 0.3), 0 0 6px rgba(255, 194, 0, 0.35);
  }

  &.detail-recognized-row-exceeding .detail-recognized-dot {
    background: radial-gradient(circle at 30% 30%, #FFF1B3 0%, #F5D76E 70%, #C99300 110%);
    box-shadow: 0 0 0 1px rgba(201, 147, 0, 0.18);
  }

  .detail-recognized-tier {
    font-weight: 700;
    white-space: nowrap;
    letter-spacing: -0.005em;
  }

  &.detail-recognized-row-truly .detail-recognized-tier {
    color: #8a5800;   // saturated gold ink — pairs with the bright dot
  }

  &.detail-recognized-row-exceeding .detail-recognized-tier {
    color: #a07520;   // softer gold ink — slightly lifted from the dot
  }

  // Person unit: sender + date as a single visual block. The two stay
  // together when the row wraps after the tier — the tier label is allowed
  // to break to its own line, but a person's name will never split from
  // their recognition date. Reads like a magazine byline.
  .detail-recognized-person {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
    white-space: nowrap;
    min-width: 0;
  }

  .detail-recognized-sender {
    font-weight: 700;
    color: #2A2A2A;
    letter-spacing: -0.005em;
  }

  .detail-recognized-date {
    font-weight: 500;
    color: #9aa0ad;
    font-size: 11px;
    letter-spacing: 0.01em;
    font-variant-numeric: tabular-nums;
    &::before {
      content: "·";
      margin-right: 5px;
      color: #c8ccd5;
    }
  }
}

.detail-recognized-more {
  font-size: 11px;
  font-weight: 600;
  color: #8a8a8a;
  letter-spacing: 0.02em;
  margin-top: 4px;
  padding-left: 14px;  // align under sender names (past dot + gap)
}

// Empty-state value: thin character for "not yet measured" — different visual
// register from the bold numeric score in a real chip. The lighter weight +
// wider tracking signals "absence" instead of "low number." WHO-5 etc.
.score-chip-value-empty {
  color: #c0c3cc;
  font-weight: 500;
  letter-spacing: 0.15em;
  font-size: 0.95em;
}

.detail-achievement-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 800;
  color: #2A2A2A;
  line-height: 1;

  img {
    width: 18px;
    height: 18px;
  }
}

// Bar-with-label rows used in Engagement + Context panels
.detail-bar-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;

  .detail-bar-label {
    color: #626262;
    font-weight: 500;
    letter-spacing: 0;
  }

  .detail-bar-value {
    color: #2A2A2A;
    font-weight: 700;
    white-space: nowrap;
    font-size: 12px;
    min-width: 28px;
    text-align: right;
    font-variant-numeric: tabular-nums;
  }

  // Goals row: inline label + value with no bar
  &.detail-bar-row-inline {
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;

    .detail-goals-value {
      text-align: right;
      font-weight: 600;
      color: #2A2A2A;
      letter-spacing: 0.01em;
    }
  }

  &.detail-bar-row-disabled {
    .detail-bar-label {
      color: #9aa1ad;
    }

    .detail-bar-value {
      color: #8d93a0;
      font-weight: 600;
      min-width: 0;
      max-width: 128px;
      white-space: normal;
      line-height: 1.2;
    }
  }
}

.detail-bar-wrap {
  display: flex;
  align-items: center;
  gap: 12px;

  .detail-bar {
    flex: 1;
    height: 7px;
    background-color: #ecedf2;
    border-radius: 999px;
    overflow: hidden;
    position: relative;
  }

  .detail-bar-fill {
    height: 100%;
    background-color: #b3b3b3;
    border-radius: 999px;
    transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    // Score-band semantic fills — echo the chip palette above the row
    &.detail-bar-fill-excellent { background-color: #5cbf63; }
    &.detail-bar-fill-high      { background-color: #76ca7d; }
    &.detail-bar-fill-yellow    { background-color: #eed24e; }
    &.detail-bar-fill-orange    { background-color: #f5a142; }
    &.detail-bar-fill-low       { background-color: #ff7a7a; }
    &.detail-bar-fill-zero      { background-color: #ff5b5b; }
    &.detail-bar-fill-empty     { background-color: #d8dbe3; }

    // Inverted band (Flight Risk): low value = green, high value = red
    &.detail-bar-fill-risk {
      background-color: #FF4343;
    }
    &.detail-bar-fill-risk-high     { background-color: #76ca7d; }
    &.detail-bar-fill-risk-moderate { background-color: #eed24e; }
    &.detail-bar-fill-risk-low      { background-color: #ff7a7a; }
    &.detail-bar-fill-risk-zero     { background-color: #ff5b5b; }
    &.detail-bar-fill-risk-empty    { background-color: #d8dbe3; }
  }
}

.detail-bar-wrap-disabled {
  .detail-bar-disabled {
    background-color: #f4f5f8;
    border: 1px dashed #d8dce6;
    box-sizing: border-box;
  }
}

.detail-bar-suffix {
  color: #8a8a8a;
  font-weight: 500;
  font-size: 11px;
  margin-left: 4px;
}

// Paired Giving / Receiving tiles. Band label carries the categorical signal;
// the right-aligned score is the quantitative anchor.
.detail-recognition-tiles {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 2px;
}

.detail-recognition-tile {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 11px 13px 12px;
  border-radius: 10px;
  background: #fafbfd;
  border: 1px solid #eef0f5;
  overflow: hidden;

  // Subtle top-edge highlight gives each tile a hint of depth without a heavy
  // shadow — reads as "lifted from the panel" without dashboard noise.
  &::before {
    content: "";
    position: absolute;
    inset: 0 0 auto 0;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.6) 50%, transparent 100%);
    pointer-events: none;
  }

  &.detail-recognition-tile-excellent { background: linear-gradient(180deg, #C2FFC2 0%, #ACFFAC 100%); border-color: #8edc8e; }
  &.detail-recognition-tile-high      { background: linear-gradient(180deg, #E8FFE7 0%, #D9FDD8 100%); border-color: #bce5bb; }
  &.detail-recognition-tile-yellow    { background: linear-gradient(180deg, #FFFAE0 0%, #FFF3C4 100%); border-color: #f0deaa; }
  &.detail-recognition-tile-orange    { background: linear-gradient(180deg, #FFEEDC 0%, #FFE0CC 100%); border-color: #f2c2a3; }
  &.detail-recognition-tile-low       { background: linear-gradient(180deg, #FFF1F1 0%, #FFEAEA 100%); border-color: #f5c8c8; }
  &.detail-recognition-tile-zero      { background: linear-gradient(180deg, #FBDEDF 0%, #F7CFD0 100%); border-color: #e5a8a9; }
  &.detail-recognition-tile-empty     { background: #fafbfd; border-color: #eef0f5; }

  // Head row: eyebrow on the left, score right-aligned. Reserves the full
  // tile width below for the band label so two-word labels ("Top quartile",
  // "Below typical") never wrap. Tiles are ~125px wide in the constrained
  // 3-panel layout — every horizontal pixel matters.
  .detail-recognition-tile-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
  }

  .detail-recognition-tile-label {
    font-size: 10px;
    font-weight: 700;
    color: #4a4a4a;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    line-height: 1.2;
  }

  // Numeric anchor — sits right-aligned in the head row, sized between the
  // eyebrow and the band so it reads as supporting detail (the band carries
  // the categorical meaning) without disappearing.
  .detail-recognition-tile-score {
    font-size: 14px;
    font-weight: 800;
    color: #1f1f1f;
    line-height: 1;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
    opacity: 0.7;
  }

  .detail-recognition-tile-band {
    font-size: 14px;
    font-weight: 800;
    color: #1f1f1f;
    line-height: 1.2;
    letter-spacing: -0.015em;
    margin-top: 2px;
  }

  .detail-recognition-tile-sub {
    font-size: 11px;
    font-weight: 500;
    color: #8a8d95;
    letter-spacing: 0.01em;
    line-height: 1.3;
    margin-top: 2px;
  }
}

// Flight Risk meter — three segments matching Safe / Watch / At risk thresholds.
.detail-flight-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;

  .detail-bar-label {
    color: #626262;
    font-weight: 500;
    letter-spacing: 0;
  }
}

.detail-flight-wrap {
  display: flex;
  align-items: center;
  gap: 12px;

  .detail-bar-value {
    color: #2A2A2A;
    font-weight: 700;
    white-space: nowrap;
    font-size: 12px;
    min-width: 28px;
    text-align: right;
    font-variant-numeric: tabular-nums;
  }
}

.detail-flight-meter {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;

  .detail-flight-segment {
    position: relative;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
    font-size: 9.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #c2c5cf;        // dialed-back muted ink for inactive segments
    background: #f1f2f6;   // softer inactive fill (was #ecedf2)
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  }

  // Active segment carries a subtle band-tinted gradient (lighter on the
  // left, slightly deeper on the right) plus a 1px inset highlight at the
  // top. Reads as "the band lights up" without the heavy chip-stamp look.
  &.detail-flight-meter-safe   .detail-flight-segment-safe {
    background: linear-gradient(180deg, #E8FFE6 0%, #C8F4C6 100%);
    color: #1f5b2a;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7), 0 1px 2px rgba(118, 202, 125, 0.18);
  }
  &.detail-flight-meter-watch  .detail-flight-segment-watch {
    background: linear-gradient(180deg, #FFF7E0 0%, #FFEBA8 100%);
    color: #6b520d;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7), 0 1px 2px rgba(238, 210, 78, 0.22);
  }
  &.detail-flight-meter-atrisk .detail-flight-segment-atrisk {
    background: linear-gradient(180deg, #FFDDDE 0%, #F5B3B5 100%);
    color: #7a2629;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6), 0 1px 2px rgba(255, 91, 91, 0.2);
  }
}

// Risk reason callout — soft tinted surface, no border accents.
// Risk level is conveyed by background tint + a small leading dot on the label,
// keeping the only chromatic signal consistent with the Panel A pill pattern.
.detail-risk-reason {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: #f3f4f8;
  border-radius: 6px;
  padding: 10px 12px;
  line-height: 1.45;

  &.detail-risk-reason-level-1 { background-color: rgba(118, 202, 125, 0.08); }
  &.detail-risk-reason-level-2 { background-color: rgba(238, 210, 78, 0.10); }
  &.detail-risk-reason-level-3 { background-color: rgba(255, 91, 91, 0.08); }

  .detail-risk-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
    font-weight: 700;
    color: #8a8a8a;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .detail-risk-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #b3b3b3;
    flex-shrink: 0;
  }

  &.detail-risk-reason-level-1 .detail-risk-dot { background-color: #76ca7d; }
  &.detail-risk-reason-level-2 .detail-risk-dot { background-color: #eed24e; }
  &.detail-risk-reason-level-3 .detail-risk-dot { background-color: #ff5b5b; }

  .detail-risk-text {
    font-size: 12px;
    color: #2A2A2A;
    line-height: 1.5;
  }
}

// Power Skills grid — no top border; the eyebrow + tighter rhythm sets the break
.detail-eq-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 6px;

  .detail-eq-title {
    color: #8a8a8a;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .detail-eq-cells {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
    row-gap: 8px;
  }

  .detail-eq-cell {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    font-size: 12px;
    padding-bottom: 6px;
    border-bottom: 1px dotted #e8eaf0;

    &:nth-last-child(-n+2) {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .detail-eq-label {
    color: #626262;
    font-weight: 500;
  }

  .detail-eq-value {
    color: #2A2A2A;
    font-weight: 700;
    font-variant-numeric: tabular-nums;

    .detail-eq-suffix {
      color: #b3b3b3;
      font-weight: 600;
      margin-left: 2px;
      font-size: 10px;
    }
  }
}

.metric-tooltip {
  max-width: 280px;
  line-height: 1.4;
}

// Expand/collapse animation
.people-expand-enter-active,
.people-expand-leave-active {
  transition: max-height 0.22s ease, opacity 0.18s ease;
  overflow: hidden;
}
.people-expand-enter,
.people-expand-leave-to {
  max-height: 0;
  opacity: 0;
}
.people-expand-enter-to,
.people-expand-leave {
  max-height: 600px;
  opacity: 1;
}
.health-indicator {
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 100;
  left: -10px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}
.noti-count {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background-color:transparent;
  color: white;
  font-family: 'Lato', 'Kanit', sans-serif;
  border: 0px;
  //border-radius: 50%;
  line-height: 20px;
  text-align: center;
}
.imgProfilehouse{
  width: 20px;
  height: 20px;
}
.bar-contariner {
    .bar {
      border-radius: 6px;
      width: 6px;
      height: 18px;
      margin-right: 2px;
      background-color: rgba($color: #000000, $alpha: 0.1);
    }

    .bar-green {
      background-color: #35d077;
    }

    .bar-yellow {
      background-color: #fbc02d;
    }

    .bar-red {
      background-color: #f44336;
    }
  }

  .section-break {
  height: 20px;
  width: 1px;
  background-color: rgba(#000, 0.1);
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}
.txtName,
.txtTeam {
  color: #3c3c3c;
  width: 130px;
}
.progress-wrapper {
  position: relative;
  width: 26px;
  height: 26px;
  display: inline-block;
  vertical-align: middle;
}

.imgProfile {
  width: 44px;
  height: 44px;
  border-radius: 44px;
}

.profilepic {
  position: relative
}

.profilepic .noti-count {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background-color:transparent;
  color: white;
  font-family: 'Lato', 'Kanit', sans-serif;
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
}
.score-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 500;
  color: #000;
  text-align: center;
  z-index: 2;
  text-align: center;
  line-height: 24px;
  /* Adjust this if you change the .progress-wrapper dimensions */
  white-space: nowrap;
  /* Prevents the label from wrapping to the next line */
}

.percentile-type {
  font-size: 12px;
  opacity: 0.7;
}

.el-dropdown-link {
  color: #000000;
  
  &:hover {
    color: #6c30cc;
  }
}

</style>
<style lang="scss">
// Allow the People Intelligence sticky header to escape the el-tabs vertical clip.
// el-tabs__content uses overflow:hidden to clip horizontal slide transitions —
// we keep horizontal clipping via `overflow-x: clip` (which doesn't establish a
// scroll container, unlike `hidden`) and let the vertical axis stay visible so
// `position: sticky` can resolve against the page scroll. Targeted to the
// Insights tabs ancestor so we don't affect tabs elsewhere in the app.
.style-bar.el-tabs > .el-tabs__content {
  overflow-x: clip;
  overflow-y: visible;
}

.engagement-breakdown-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.engagement-breakdown-dialog .el-dialog__header {
  padding: 18px 22px 0;
}

.engagement-breakdown-dialog .el-dialog__title {
  color: #1f2933;
  font-size: 17px;
  font-weight: 800;
}

.engagement-breakdown-dialog .el-dialog__body {
  padding: 14px 22px 22px;
  word-break: normal;
  overflow-wrap: normal;
  hyphens: none;
}

.engagement-breakdown-modal {
  color: #1f2933;
  word-break: normal;
  overflow-wrap: normal;
  hyphens: none;
}

.engagement-breakdown-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #edf0f5;
}

.engagement-breakdown-person {
  min-width: 0;
}

.engagement-breakdown-kicker {
  color: #6c30cc;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.engagement-breakdown-name {
  margin-top: 6px;
  color: #22242a;
  font-size: 21px;
  font-weight: 800;
  line-height: 1.18;
  word-break: normal;
  overflow-wrap: normal;
}

.engagement-breakdown-team {
  margin-top: 4px;
  color: #6f7482;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  word-break: normal;
  overflow-wrap: normal;
}

.engagement-breakdown-score-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 86px;
  min-width: 86px;
  height: 64px;
  border-radius: 8px;
  background-color: #f3f4f8;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);
}

.engagement-breakdown-score-value {
  font-size: 28px;
  font-weight: 900;
  line-height: 1;
  color: #2A2A2A;
  font-variant-numeric: tabular-nums;
}

.engagement-breakdown-score-caption {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
  color: #626262;
}

.engagement-breakdown-score-card.score-chip-excellent {
  background-color: #ACFFAC;
  .engagement-breakdown-score-value,
  .engagement-breakdown-score-caption { color: #0a4a1a; }
}

.engagement-breakdown-score-card.score-chip-high {
  background-color: #D9FDD8;
  .engagement-breakdown-score-value,
  .engagement-breakdown-score-caption { color: #2d5e33; }
}

.engagement-breakdown-score-card.score-chip-yellow {
  background-color: #FFF3C4;
  .engagement-breakdown-score-value,
  .engagement-breakdown-score-caption { color: #7a5d00; }
}

.engagement-breakdown-score-card.score-chip-orange {
  background-color: #FFE0CC;
  .engagement-breakdown-score-value,
  .engagement-breakdown-score-caption { color: #8b3a00; }
}

.engagement-breakdown-score-card.score-chip-low {
  background-color: #FFEAEA;
  .engagement-breakdown-score-value,
  .engagement-breakdown-score-caption { color: #991b1b; }
}

.engagement-breakdown-score-card.score-chip-zero {
  background-color: #F7CFD0;
  .engagement-breakdown-score-value,
  .engagement-breakdown-score-caption { color: #7d1d1d; }
}

.engagement-breakdown-score-card.score-chip-empty {
  background-color: #F2F3F7;
  .engagement-breakdown-score-value,
  .engagement-breakdown-score-caption { color: #9ea0a8; }
}

.engagement-breakdown-meta {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 10px;
  margin-top: 12px;
}

.engagement-breakdown-meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #edf0f5;
  border-radius: 8px;
  background: #fbfcff;
}

.engagement-breakdown-meta-item i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  min-width: 22px;
  height: 22px;
  border-radius: 7px;
  background: #f3efff;
  color: #6c30cc;
  font-size: 12px;
}

.engagement-breakdown-meta-item span {
  display: block;
  color: #8b91a0;
  font-size: 9px;
  font-weight: 800;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.engagement-breakdown-meta-item strong {
  display: block;
  margin-top: 2px;
  color: #292d36;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.3;
  word-break: normal;
  overflow-wrap: normal;
}

.engagement-breakdown-section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
}

.engagement-breakdown-section-title {
  color: #242833;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.2;
  word-break: normal;
  overflow-wrap: normal;
}

.engagement-breakdown-section-copy {
  margin-top: 3px;
  color: #7b8190;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
  word-break: normal;
  overflow-wrap: normal;
}

.engagement-breakdown-focus {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 1 220px;
  max-width: 220px;
  padding: 6px 8px;
  border-radius: 8px;
  background: #f3efff;
  color: #5530a5;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.25;
  text-align: right;
  word-break: normal;
  overflow-wrap: normal;
  hyphens: none;
}

.engagement-breakdown-focus::before {
  content: "";
  width: 6px;
  min-width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #6c30cc;
}

.engagement-breakdown-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 9px;
}

.engagement-breakdown-row {
  padding: 9px 12px 10px;
  border: 1px solid #e8ebf2;
  border-radius: 8px;
  background: #ffffff;
}

.engagement-breakdown-row-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.engagement-breakdown-row-main {
  min-width: 0;
}

.engagement-breakdown-row-titleline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.engagement-breakdown-row-label {
  color: #242833;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.25;
  word-break: normal;
  overflow-wrap: normal;
}

.engagement-breakdown-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 18px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #fff3c4;
  color: #7a5d00;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
}

.engagement-breakdown-status::before {
  content: "";
  width: 5px;
  min-width: 5px;
  height: 5px;
  border-radius: 999px;
  background: currentColor;
}

.engagement-breakdown-status.is-full {
  background: #d9fdd8;
  color: #256029;
}

.engagement-breakdown-status.is-near {
  background: #f3efff;
  color: #5530a5;
}

.engagement-breakdown-status.is-watch {
  background: #fff3c4;
  color: #7a5d00;
}

.engagement-breakdown-status.is-low {
  background: #ffe0cc;
  color: #8b3a00;
}

.engagement-breakdown-status.is-empty {
  background: #f2f3f7;
  color: #737986;
}

.engagement-breakdown-row-detail {
  margin-top: 4px;
  color: #6f7482;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
  word-break: normal;
  overflow-wrap: normal;
}

.engagement-breakdown-row-rate {
  min-width: 62px;
  text-align: right;
  white-space: nowrap;
}

.engagement-breakdown-row-rate strong,
.engagement-breakdown-row-rate span {
  display: block;
}

.engagement-breakdown-row-rate strong {
  color: #1f2933;
  font-size: 19px;
  font-weight: 900;
  line-height: 1.15;
  font-variant-numeric: tabular-nums;
}

.engagement-breakdown-row-rate.is-empty strong {
  color: #737986;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
}

.engagement-breakdown-row-rate span {
  margin-top: 3px;
  color: #8b91a0;
  font-size: 9px;
  font-weight: 800;
  line-height: 1.2;
}

.engagement-breakdown-meter {
  height: 4px;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #eef1f6;
}

.engagement-breakdown-meter span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #27bc6c;
}

.engagement-breakdown-empty {
  margin-top: 16px;
  padding: 18px;
  border: 1px solid #edf0f5;
  border-radius: 8px;
  background: #fafbfe;
  color: #6f7482;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.45;
}

@media (max-width: 720px) {
  .engagement-breakdown-dialog {
    width: calc(100vw - 28px) !important;
  }

  .engagement-breakdown-header,
  .engagement-breakdown-section-heading,
  .engagement-breakdown-row-top {
    align-items: stretch;
    flex-direction: column;
  }

  .engagement-breakdown-score-card {
    width: 100%;
  }

  .engagement-breakdown-meta {
    grid-template-columns: 1fr;
  }

  .engagement-breakdown-focus {
    max-width: none;
    text-align: left;
  }

  .engagement-breakdown-row-rate {
    text-align: left;
  }
}

#insightsPeople .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5f5f580;
  cursor: pointer;

  .buttom-detail-image {
    opacity: 1;
  }
}

#insightsPeople div.showOption>ul>li>div {
  height: 40px !important;
  line-height: 40px !important;
}

#insightsPeople .el-table th>.cell {
  /* color: #2E2E2E; */
  font-size: 14px;
}

#insightsPeople .el-table td {
  padding: 0px 0px 0px 0px;
}

.dropdownItem-insightsPeople {
  overflow-y: auto;
  max-height: 228px;

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #6c30cc;
    border-color: #6c30cc;
  }
}

.el-checkbox__input.is-focus span.el-checkbox__inner,
span.el-checkbox__inner:hover {
  border-color: #dcdfe6;
}

.el-checkbox__input.is-checked.is-focus span.el-checkbox__inner {
  border-color: #6c30cc;
}

.el-checkbox__input {
  zoom: 1.5;
}

.el-dropdown-link {
  cursor: default;
  color: transparent;
}

.el-tooltip__popper.is-light {
  box-shadow: 0 0 12px 0 #00000052;
  border-width: 0;

  >.popper__arrow {
    border-width: 0;
    box-shadow: 0px 0px 6px 2px #00000052;
  }
}

.el-tooltip__popper.is-dark {
  max-width: 280px;
}

.people-engagement-tooltip {
  max-width: 400px;
}

.people-engagement-tooltip-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
  line-height: 1.25;
}

.people-engagement-tooltip-line {
  color: #333;
}

.el-select-dropdown__item:hover {
  background-color: #6C30CC30;
  color: #6C30CC;
  font-weight: 700;
}

/* Health Indicator Tooltip Styles */
.health-tooltip-content {
  max-width: 300px;
  padding: 0;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.health-tooltip-header {
  display: flex;
  align-items: center;
  padding: 16px 16px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: #fafafa;
}

.tooltip-icon {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.tooltip-title {
  font-size: 15px;
  font-weight: 700;
  color: #333;
}

.health-tooltip-description {
  padding: 12px 16px;
  font-size: 13px;
  color: #555;
  line-height: 1.5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.happiness-pattern-section {
  padding: 16px;
}

.pattern-header {
  display: flex;
  align-items: baseline;
  margin-bottom: 8px;
}

.pattern-title {
  font-size: 12px;
  font-weight: 600;
  color: #000;
}

.pattern-subtitle {
  font-size: 11px;
  color: #666;
  margin-left: 6px;
}

.pattern-loading {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}

.loading-dots {
  display: flex;
  gap: 4px;
}

.loading-dots span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #6c30cc;
  animation: loading-bounce 1.4s ease-in-out infinite both;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes loading-bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.happiness-pattern {
  width: 100%;
}

.pattern-weeks-inline {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.pattern-week-inline {
  display: flex;
  align-items: center;
  gap: 6px;
}

.week-label {
  font-size: 10px;
  color: #666;
  font-weight: 600;
  width: 50px;
  text-align: right;
}

.pattern-grid-week {
  display: flex;
  gap: 3px;
}

.pattern-day {
  width: 12px;
  height: 12px;
  position: relative;
  cursor: pointer;
  transition: transform 0.1s ease;
}

.pattern-day:hover {
  transform: scale(1.3);
}

.day-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  box-sizing: border-box;
}

.pattern-great .day-indicator {
  background-color: #66BB6A;
}

.pattern-okay .day-indicator {
  background-color: #FBC02D;
}

.pattern-poor .day-indicator {
  background-color: #F44336;
}

.pattern-none .day-indicator {
  background-color: #E0E0E0;
  border: 1px solid #BDBDBD;
  width: 10px;
  height: 10px;
}



.pattern-unavailable {
  text-align: center;
  padding: 20px 0;
  color: #999;
  font-size: 12px;
}

.unavailable-icon {
  font-size: 24px;
  margin-bottom: 8px;
  opacity: 0.5;
}

/* Tooltip Popper Override */
.health-indicator-tooltip {
  max-width: 300px !important;
}

.health-indicator-tooltip.el-tooltip__popper {
  padding: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  background: #fff !important;
  border: 1px solid #e8e8e8 !important;
}

.health-indicator-tooltip.el-tooltip__popper[x-placement^="left"] .popper__arrow {
  border-left-color: #e8e8e8 !important;
}

.health-indicator-tooltip.el-tooltip__popper[x-placement^="left"] .popper__arrow::after {
  border-left-color: #fff !important;
}

// Talent Group chip strip — replaces the old <el-select> dropdown.
// Surfaces all 8 pre-curated presets as toggleable filter chips with
// counts and hover descriptions.
.talent-group-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.talent-group-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid #e2e4ea;
  color: #4a4a4a;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: #fafbfc;
    border-color: #d4d7de;
    color: #2A2A2A;
  }

  &:focus-visible {
    outline: 2px solid rgba(108, 48, 204, 0.35);
    outline-offset: 1px;
  }

  &.active {
    background: rgba(108, 48, 204, 0.10);
    border-color: rgba(108, 48, 204, 0.30);
    color: #4C32CC;

    .talent-group-chip-count {
      background: rgba(108, 48, 204, 0.18);
      color: #4C32CC;
    }
  }

  // Zero-count presets stay clickable but recede visually.
  &.empty:not(.active) {
    color: #b3b3b3;
    border-color: #eef0f5;

    .talent-group-chip-count {
      background: #f3f4f8;
      color: #b3b3b3;
    }
  }

  &.loading,
  &:disabled {
    cursor: wait;
    color: #9a9aa3;
    border-color: #eef0f5;
    background: #ffffff;
  }

  &:disabled:hover {
    background: #ffffff;
    border-color: #eef0f5;
    color: #9a9aa3;
  }

  .talent-group-chip-label {
    letter-spacing: 0.01em;
  }

  .talent-group-chip-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 18px;
    padding: 0 6px;
    border-radius: 999px;
    background: #f3f4f8;
    color: #80808a;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    font-variant-numeric: tabular-nums;
    transition: background 0.15s ease, color 0.15s ease;
  }
}

// Tooltip popper for the chip strip — light theme to match the chips,
// constrained width so the descriptions wrap into a readable card.
.talent-group-tooltip.el-tooltip__popper {
  max-width: 280px;
  line-height: 1.45;
  font-size: 12px;
}

.filter-criteria-toolbar {
  background-color: #f2edfa;
  border: 1px solid rgba(108, 48, 204, 0.18);
  border-radius: 4px;
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-criteria-toolbar .flex-center {
  display: flex;
  align-items: flex-start;
}

.filter-criteria-toolbar .filter-icon {
  color: #6C30CC;
  font-size: 18px;
  margin-right: 12px;
  margin-top: 3px;
}

.filter-criteria-toolbar .filter-details {
  flex: 1;
}

.filter-criteria-toolbar .filter-title {
  font-weight: 700;
  font-size: 14px;
  color: #333;
}

.filter-criteria-toolbar .filter-description {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

.filter-criteria-toolbar .edit-criteria-btn {
  color: #999;
  padding: 0;
  font-size: 16px;
  margin-left: 8px;
  margin-top: -2px;
}

.filter-criteria-toolbar .edit-criteria-btn:hover {
  color: #333;
}

</style>
